<template>
  <v-row justify="center">
    <v-dialog
      v-model="shower"
      scrollable
      persistent
      max-width="1000px"
      v-if="resolutionScreen >= 500"
    >
      <v-card style="height:650px;">
        <v-card-title
          >{{ $t("toolbar.specialupload") }} <v-spacer></v-spacer>
          <v-icon :color="color.theme" dense dark size="35">mdi-upload</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions class="mt-2" v-if="statusuploading === true">
          <!-- <v-btn
            elevation="1"
            fab
            x-small
            class="text-center ml-2"
            :color="$vuetify.theme.dark ? 'white' : color.theme"
            @click="cleardataNoclose()"
            :disabled="length_uploading >= 1"
          >
            <v-icon
              :color="$vuetify.theme.dark ? '#989898' : 'white'"
              dark
              size="16"
              >keyboard_backspace</v-icon
            >
          </v-btn> -->
          <v-checkbox v-if="!length_uploading >= 1 && temparraydataupload.filter((items) => ['warning', 'fail', 'cancel'].includes(items.status)).length >= 1" 
            class="mt-n1 ml-2" dense hide-details v-model="selectAll_reupload" 
            :disabled="length_uploading >= 1" @click="fn_selectAllItems()" ></v-checkbox>
          <v-spacer></v-spacer>
          <v-chip outlined class="mr-2"
            >{{
              $t("uploadfile.uploadingfile") + " " + length_uploading + " "
            }}
            {{
              length_uploading > 1
                ? $t("uploadfile.files")
                : $t("uploadfile.file")
            }}</v-chip
          >
          <v-chip outlined class="mr-2"
            >{{ $t("uploadfile.success") + " " + length_success + " " }}
            {{
              length_success > 1
                ? $t("uploadfile.files")
                : $t("uploadfile.file")
            }}</v-chip
          >
          <v-chip outlined class="mr-2"
            >{{ $t("uploadfile.fail") + " " + length_fail + " " }}
            {{
              length_fail > 1 ? $t("uploadfile.files") : $t("uploadfile.file")
            }}</v-chip
          >
          <v-chip outlined class="mr-2"
            >{{ $t("uploadfile.duplicate") + " " + length_duplicate + " " }}
            {{
              length_duplicate > 1
                ? $t("uploadfile.files")
                : $t("uploadfile.file")
            }}</v-chip
          >
        </v-card-actions>
        <v-card-text v-if="statusuploading === false">
          <v-layout class="mt-6">
            <v-flex
              xl7
              lg7
              md7
              class="px-8"
              style="overflow-y: scroll; max-height: 600px"
            >
              <div class="mb-4 text-left">
                <v-layout row wrap class="mx-1">
                  <v-flex lg8 xl8 md7>
                    <v-autocomplete
                      :items="datatemplate"
                      solo
                      v-model="selectdatatemplate"
                      :label="$t('smartinput.template')"
                      dense
                      prepend-icon="layers"
                      item-value="id"
                      item-text="template_name"
                      :color="color.theme"
                      outlined
                      :item-color="`${color.theme}`"
                      return-object
                      @change="
                        $v.$reset(),
                          getDetailsTemplate(
                            selectdatatemplate.id,
                            selectdatatemplate.structure_data,
                            selectdatatemplate
                          )
                      "
                      :no-data-text="$t('smartinput.no_data_templates')"
                      :disabled="isloadingChecking"
                    >
                      <!-- fn_check_smup_specific() ? '' :  -->
                      <template :color="color.theme" v-slot:item="{ item }">
                        <span style="">{{ item.template_name }}</span>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex
                    class="text-right mt-1"
                    lg4
                    xl4
                    md5
                    v-if="totalstackfile <= 0"
                  >
                    <v-chip outlined color="#FFA000">
                      <p
                        style="font-size: 16px; font-weight: 600;"
                        class="mt-4"
                      >
                        {{ $t("direct_upload.nofilewaitupload") }}
                      </p>
                    </v-chip>
                  </v-flex>
                  <v-flex class="text-right mt-1" lg4 xl4 md5 v-else>
                    <v-chip color="success">
                      <p style="font-size: 16px" class="mt-4">
                        <span style="font-weight: 600;">
                          {{ totalstackfile }}
                        </span>
                        {{
                          totalstackfile > 1
                            ? $t("direct_upload.files")
                            : $t("direct_upload.file")
                        }}
                      </p>
                    </v-chip>
                  </v-flex>
                  <v-flex v-if="datatemplate.length > 0" lg12 xl12 md12>
                    <v-card-actions class="mx-n3 mt-n4">
                      <div
                        class="pa-1 px-3 text-left"
                        :style="
                          $vuetify.theme.dark
                            ? 'background-color:#474747'
                            : 'background-color:#f5f5f5'
                        "
                        style="width: 100%; border-radius: 10px;"
                      >
                        <!-- <v-skeleton-loader
                          v-if="
                            loadingdatatemplate === true &&
                              checktemplatefolder === true
                          "
                          :style="
                            $vuetify.theme.dark
                              ? 'background-color:#474747'
                              : 'background-color:#f5f5f5'
                          "
                          type="text"
                        ></v-skeleton-loader> -->
                        <v-skeleton-loader
                          v-if="loadingdatatemplate === true"
                          :style="
                            $vuetify.theme.dark
                              ? 'background-color:#474747'
                              : 'background-color:#f5f5f5'
                          "
                          type="text"
                        ></v-skeleton-loader>
                        <span
                          v-else
                          class="font-weight-bold"
                          style="font-size: 14px;"
                        >
                          <!-- <p v-if="checktemplatefolder === true" class="mb-0">
                            {{ $t("smartinput.foldertemplate") }}
                            {{
                              datafoldertemplate.path === undefined
                                ? $t("smartinput.notyetchosen")
                                : datafoldertemplate.folder_name
                            }}
                          </p> -->
                          {{ $t("smartinput.fileto") }}
                          <span v-if="detailstemplate.aspect_data !== undefined">
                            <!-- {{ structure_symbol_data }} -->
                            {{ 
                            !['null', null, ''].includes(currenttemplate.structure_change_file_name)
                             ? structure_data_v3 : structure_data_v2 }}
                          </span>
                          <br>
                          <!-- {{ $t("smartinput.exemplefilename") }}
                          <span>
                            {{ currenttemplate.structure_file_name }}
                          </span> -->
                          <p v-if="currenttemplate.structure_file_name !== '' && currenttemplate.structure_file_name !== null" class="mb-0">
                            {{ $t("smartinput.exemplefilename") }}
                            {{ fn_extractFormat(currenttemplate.structure_file_name) }}
                          </p>
                        </span>
                      </div>
                    </v-card-actions>
                  </v-flex>
                </v-layout>
              </div>
              <!-- alert folder -->
              <div v-if="alertSomeFolder">
                <span style="color: red" class="font-weight-bold">
                  * {{ $t('smartinput.smartupload_type_error') }} 
                </span>
              </div>
              <!-- upload layout -->
              <div
                :style="
                  dropzoneuploadfiles +
                    'border-radius: 24px; position: relative;'
                "
                class="text-center mt-4 mx-auto dropzoneupload"
                id="dropzoneuploadfiles"
                v-if="totalstackfile > 0"
              >
                <div
                  @click="ImportFiles"
                  id="inputuploadfiles"
                  style="opacity: 0;"
                  class="dropzoneupload"
                >
                  <input
                    ref="importdoc"
                    type="file"
                    @change="fnStackFile"
                    multiple
                    class="d-none"
                  />
                </div>
                <v-overlay :value="stackfileloading" absolute>
                  <v-progress-circular indeterminate></v-progress-circular>
                </v-overlay>
                <v-list
                  class="pt-6 mr-n4 dropzoneupload"
                  dense
                  :style="
                    layouthoveruploadfiles +
                      'z-index:3; overflow-y: scroll; height: 320px;'
                  "
                  id="layouthoveruploadfiles"
                >
                  <v-list-item
                    class="no-hover my-n4 dropzoneupload"
                    v-for="(item) in arraydataupload"
                    :key="item.id"
                    :ripple="false"
                    id="listStackFiles"
                    @click="!['null', null, ''].includes(currenttemplate.structure_change_file_name) ? (selectedItem = item) : (selectedItem = null)"
                  >
                    <v-list-item-action class="mr-4" row id="listStackFiles">
                      <v-icon large :color="item.icon[1]" id="listStackFiles">{{
                        item.icon[0]
                      }}</v-icon>
                      <v-icon class="mt-1 ml-5" 
                      v-if="selectedItem !== null && selectedItem.id === item.id && checkSelectedItem" 
                      style="position: absolute; left: 25px">
                        mdi-circle-small
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content
                      class="mr-n2 pl-2 text-left dropzoneupload"
                      id="listStackFiles"
                    >
                      <v-list-item-title
                        style="font-size: 14px;"
                        id="listStackFiles"
                      >
                        <!-- {{ item.name + "." + item.typefile }} -->
                        {{ item.name }}
                      </v-list-item-title>
                      <v-list-item-subtitle
                        id="listStackFiles"
                        style="color:red;"
                        v-if="item.errorSize"
                      >
                        {{$t("smartinput.maxSizeFile")}}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle
                        id="listStackFiles"
                        style="color:red;"
                        v-else-if="
                          item.errorduplicate === 'nonapi' ||
                            item.errorduplicate === 'api'
                        "
                      >
                        {{ $t("uploadfile.fileduplicate") }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action id="listStackFiles" class="text-right">
                      <!-- ปุ่ม cancel upload -->
                      <v-icon
                        id="listStackFiles"
                        class="ml-2 pr-4"
                        @click="fnDeleteStackFile(item)"
                        color="red"
                        >mdi-close</v-icon
                      >
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
                <div class="mb-n6 dropzoneupload" id="listStackFiles">
                  <span
                    id="titleTextUploadtitle"
                    class="mr-2 textdropzone"
                    style="font-size:16px;"
                    >{{ $t("smartinput.clicktouploadnew") }}</span
                  >
                </div>
                <div>
                  <span id="titleTextUploadsubtitle" class="textdropzone" style="font-size:14px;">{{
                    $t("smartinput.maxsizeuploadtext")
                  }}</span>
                </div>
              </div>
              <div
                v-else
                :style="uploadLayout + dropzoneuploadfiles"
                class="text-center mt-3 pt-12 pb-6  mx-auto dropzoneupload"
                @click="ImportFiles"
                id="dropzoneuploadfiles"
              >
                <div
                  :style="layouthoveruploadfiles"
                  id="layouthoveruploadfiles"
                  class="dropzoneupload"
                  style="line-height: 1.5; display: inline-block; vertical-align: middle;"
                >
                  <input
                    ref="importdoc"
                    class="d-none dropzoneupload"
                    type="file"
                    @change="fnStackFile"
                    multiple
                    style="display:none"
                  />
                  <v-img
                    max-width="240"
                    max-height="210"
                    class="mx-auto dropzoneupload noselect"
                    :src="require('@/assets/img/uploadfiles.png')"
                  />
                  <span id="titleTextUploadtitle" class="textdropzone noselect" style="font-size:16px">{{
                    $t("smartinput.clicktouploadnew")
                  }}</span>
                  <br />
                  <span id="titleTextUploadsubtitle" class="textdropzone noselect" style="font-size:14px">{{
                    $t("smartinput.maxsizeuploadtext")
                  }}</span>
                  <br />
                  <br />
                </div>
              </div>
            </v-flex>
            <v-divider vertical></v-divider>
            <!-- !listbizsymbolsmartupload -->
            <v-flex v-if="detailstemplate.aspect_data !== undefined" xl5 lg5 md5>
              <div
                v-if="
                  loadingdatatemplate === false &&
                    (detailstemplate.aspect_data.length > 0 &&
                    detailstemplate.aspect_data.filter(item => item.readfilename === 'N').length > 0 &&
                    !manageAI && ['null', null, ''].includes(currenttemplate.structure_change_file_name) 
                    )
                "
              >
                <v-list
                  dense
                  v-for="(item, i) in detailstemplate.aspect_data"
                  :key="i"
                  :class="item.readfilename === 'N' ? 'mb-n6' : 'mb-n4'"
                >
                  <v-list-item v-if="item.readfilename === 'N'" class="mt-n3">
                    <v-list-item-content>
                      <v-list-item-title
                        style="font-size:16px; line-height: 24px"
                      >
                        <span
                          v-if="item.aspect_null === 'Y'"
                          style="font-size:18px; line-height: 24px; color: red;"
                          >*</span
                        >
                        {{ item.aspect_label }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="item.readfilename === 'N'" class="mt-n1">
                    <v-list-item-content
                      v-if="
                        item.aspect_type === 'DROPDOWN' &&
                          item.status_value === 'Y'
                      "
                    >
                      <v-select
                        v-model="item.value"
                        :items="item.aspect_fix_key_extra"
                        outlined
                        dense
                        item-color="color.theme"
                        :color="color.theme"
                        prepend-icon="mdi-format-list-bulleted-type"
                        :item-value="item.aspect_fix_key_extra[0]"
                        :disabled="isloadingChecking"
                      >
                        <template v-slot:item="{ item }">{{
                          item === "notselecttemplate"
                            ? $t("smartinput.notchose")
                            : `${item} ${getFindValueObject(item, i) === "" ? '' : `(${getFindValueObject(item, i)})`}`
                        }}</template>
                        <template v-slot:selection="{ item }">{{
                          item === "notselecttemplate"
                            ? $t("smartinput.notchose")
                            : `${item} ${getFindValueObject(item, i) === "" ? '' : `(${getFindValueObject(item, i)})`}`
                        }}</template>
                      </v-select>
                    </v-list-item-content>
                    <v-list-item-content
                      v-else-if="
                        item.aspect_type === 'DATE' && item.status_value === 'Y'
                      "
                    >
                      <v-dialog
                        persistent
                        v-model="item.menudate"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :color="color.theme"
                            prepend-icon="event"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            dense
                            outlined
                            clearable
                            :disabled="isloadingChecking"
                            @click:clear="
                              item.aspect_null === 'Y'
                                ? (item.fixvalue = '')
                                : (item.value = '')
                            "
                            :value="item.showdate"
                            :rules="aspectDataRequired"
                            :error-messages="item.erroraspectmessages"
                            @input="
                              item.aspect_null === 'Y'
                                ? $v.detailstemplate.aspect_data.$each[
                                    i
                                  ].fixvalue.$touch()
                                : $v.detailstemplate.aspect_data.$each[
                                    i
                                  ].value.$touch()
                            "
                            @blur="
                              item.aspect_null === 'Y'
                                ? $v.detailstemplate.aspect_data.$each[
                                    i
                                  ].fixvalue.$touch()
                                : $v.detailstemplate.aspect_data.$each[
                                    i
                                  ].value.$touch()
                            "
                          >
                          </v-text-field>
                        </template>
                        <v-date-picker
                          v-model="item.showdate"
                          :locale="$t('default')"
                          @input="
                            (item.menudate = false),
                              item.aspect_null === 'Y'
                                ? (item.fixvalue = changeDateFormat(item))
                                : (item.value = changeDateFormat(item))
                          "
                          :color="color.theme"
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            dark
                            color="error"
                            @click="item.menudate = false"
                          >
                            {{ $t("sharefile.closedatepiker") }}
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-list-item-content>
                    <v-list-item-content
                      v-else-if="
                        item.aspect_type === 'TEXT' && item.status_value === 'Y'
                      "
                    >
                      <v-text-field
                        v-if="item.aspect_null === 'Y'"
                        height="35px"
                        class="textFieldClass"
                        v-model.trim="item.fixvalue"
                        maxlength="50"
                        outlined
                        dense
                        :color="color.theme"
                        prepend-icon="mdi-format-text"
                        :disabled="item.status_fix === 'Y' || isloadingChecking"
                        :rules="aspectDataRequired"
                        :error-messages="item.erroraspectmessages"
                        @input="
                          $v.detailstemplate.aspect_data.$each[
                            i
                          ].fixvalue.$touch()
                        "
                        @blur="
                          $v.detailstemplate.aspect_data.$each[
                            i
                          ].fixvalue.$touch()
                        "
                      >
                      </v-text-field>
                      <v-text-field
                        v-else
                        height="35px"
                        class="textFieldClass"
                        v-model.trim="item.value"
                        maxlength="50"
                        outlined
                        dense
                        :color="color.theme"
                        :disabled="item.status_fix === 'Y' || isloadingChecking"
                        prepend-icon="mdi-format-text"
                        :rules="aspectDataRequired"
                        :error-messages="item.erroraspectmessages"
                        @input="
                          $v.detailstemplate.aspect_data.$each[i].value.$touch()
                        "
                        @blur="
                          $v.detailstemplate.aspect_data.$each[i].value.$touch()
                        "
                      >
                      </v-text-field>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-divider v-if="listaspectsymbol.length > 0"></v-divider>
                <v-list
                  dense
                  v-for="item in listaspectsymbol"
                  :key="item.aspect_name"
                  class="mb-3 ml-4 pr-10 mt-3"
                  :style="
                    $vuetify.theme.dark
                      ? 'background-color:#474747'
                      : 'background-color:#f5f5f5'
                  "
                  style="width: 90%; border-radius: 10px;"
                >
                  <v-list-item class="" style="">
                    <v-list-item-content>
                      <v-list-item-title
                        style="font-size:16px; line-height: 24px"
                      >
                        {{ item.aspect_label }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item class="mt-n4">
                    <v-list-item-content>
                      <span>{{
                        $t("smartinput.fomatnamefile") +
                          " : " +
                          item.aspect_name +
                          item.aspect_symbol +
                          "XXXXXXXXXX"
                      }}</span>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>
              <div v-else-if="
              loadingdatatemplate === false && 
              (detailstemplate.aspect_data.length > 0 &&
                    detailstemplate.aspect_data.filter(item => item.readfilename === 'N').length > 0 &&
                    !manageAI && !['null', null, ''].includes(currenttemplate.structure_change_file_name) ||
                    this.detailstemplate.aspect_data.some((itemFind) => itemFind.aspect_condition === 'Y')
                    )" >
              <v-list >
                <!-- <span>{{ this.selectedItem }}</span> -->
                <v-list-item>
                  <v-list-item-content >
                    <v-list-item-title
                        style="font-size:16px; line-height: 24px"
                      >
                        <span>Pattern Filename </span> <span class="font-weight-bold">{{ selectedItem ? `(${selectedItem.backup_filename})` : '' }}</span>
                      </v-list-item-title>
                    <v-text-field
                        v-if="selectedItem !== null && [null, '', 'null'].includes(currenttemplate.structure_change_file_name)"
                        height="35px"
                        class="textFieldClass"
                        maxlength="50"
                        outlined
                        v-model.trim="filenameWithoutExtension"
                        dense
                        :color="color.theme"
                        prepend-icon="mdi-format-text"
                        disabled
                      >
                      </v-text-field>
                      <v-text-field
                        v-else-if="selectedItem !== null && ![null, '', 'null'].includes(currenttemplate.structure_change_file_name)"
                        height="35px"
                        class="textFieldClass"
                        maxlength="50"
                        outlined
                        v-model.trim="selectedItem.pattern_filename"
                        dense
                        :color="color.theme"
                        prepend-icon="mdi-format-text"
                        disabled
                      >
                      </v-text-field>
                      <v-text-field
                        v-else
                        height="35px"
                        class="textFieldClass"
                        v-model.trim="currenttemplate.structure_change_file_name"
                        maxlength="50"
                        outlined
                        dense
                        disabled
                        :color="color.theme"
                        prepend-icon="mdi-format-text"
                      >
                      </v-text-field>
                  </v-list-item-content>
                  </v-list-item>
              </v-list>
              <!-- Vlist -->
               <div>
                <v-list
                    dense
                    v-for="(item, i) in ![null, undefined].includes(selectedItem) ? selectedItem.aspect_data_patternfilename_template : detailstemplate.aspect_data"
                    :key="i"
                    :class="item.readfilename === 'N' ? 'mb-n6' : 'mb-n4'"
                  >
                  <v-list-item class="mt-n3">
                      <v-list-item-content>
                        <v-list-item-title
                          style="font-size:16px; line-height: 24px"
                        >
                          <span
                            v-if="item.aspect_null === 'Y'"
                            style="font-size:18px; line-height: 24px; color: red;"
                            >*</span
                          >
                          {{ item.aspect_label }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="mt-n1">
                      <v-list-item-content
                        v-if="
                          item.aspect_type === 'DROPDOWN' &&
                            item.status_value === 'Y'
                        "
                      >
                        <v-select
                          v-model="item.value"
                          :items="item.aspect_fix_key_extra"
                          outlined
                          dense
                          item-color="color.theme"
                          :color="color.theme"
                          prepend-icon="mdi-format-list-bulleted-type"
                          :item-value="item.aspect_fix_key_extra[0]"
                          :disabled="isloadingChecking || isloadingFetchOCR || !selectedItem"
                        >
                          <template v-slot:item="{ item }">{{
                            item === "notselecttemplate"
                              ? $t("smartinput.notchose")
                              : `${item} ${getFindValueObject(item, i) === "" ? '' : `(${getFindValueObject(item, i)})`}`
                          }}</template>
                          <template v-slot:selection="{ item }">{{
                            item === "notselecttemplate"
                              ? $t("smartinput.notchose")
                              : `${item} ${getFindValueObject(item, i) === "" ? '' : `(${getFindValueObject(item, i)})`}`
                          }}</template>
                        </v-select>
                      </v-list-item-content>
                      <v-list-item-content
                        v-else-if="
                          item.aspect_type === 'DATE' && item.status_value === 'Y'
                        "
                      >
                        <v-dialog
                          persistent
                          v-model="item.menudate"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              :color="color.theme"
                              prepend-icon="event"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              dense
                              outlined
                              :clearable="item.aspect_null === 'N' ? true : false"
                              :disabled="isloadingChecking || isloadingFetchOCR || !selectedItem"
                              @click:clear="
                                item.aspect_null === 'Y'
                                  ? (item.fixvalue = '')
                                  : (item.value = '')
                              "
                              :value="item.showdate"
                              :rules="aspectDataPatternRequired"
                              :error-messages="item.erroraspectmessages"
                              @input="
                                item.aspect_null === 'Y'
                                  ? $v.selectedItem.aspect_data_patternfilename_template.$each[
                                      i
                                    ].fixvalue.$touch()
                                  : $v.selectedItem.aspect_data_patternfilename_template.$each[
                                      i
                                    ].value.$touch()
                              "
                              @blur="
                                item.aspect_null === 'Y'
                                  ? $v.selectedItem.aspect_data_patternfilename_template.$each[
                                      i
                                    ].fixvalue.$touch()
                                  : $v.selectedItem.aspect_data_patternfilename_template.$each[
                                      i
                                    ].value.$touch()
                              "
                            >
                            </v-text-field>
                          </template>
                          <v-date-picker
                            v-model="item.showdate"
                            :locale="$t('default')"
                            @input="
                              (item.menudate = false),
                                item.aspect_null === 'Y'
                                  ? (item.fixvalue = changeDateFormat(item))
                                  : (item.value = changeDateFormat(item))
                            "
                            :color="color.theme"
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              dark
                              color="error"
                              @click="item.menudate = false"
                            >
                              {{ $t("sharefile.closedatepiker") }}
                            </v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-list-item-content>
                      <v-list-item-content
                        v-else-if="
                          item.aspect_type === 'TEXT' && item.status_value === 'Y'
                        "
                      >
                        <v-text-field
                          v-if="item.aspect_null === 'Y'"
                          height="35px"
                          class="textFieldClass"
                          v-model.trim="item.fixvalue"
                          maxlength="50"
                          outlined
                          dense
                          :color="color.theme"
                          prepend-icon="mdi-format-text"
                          :disabled="item.status_fix === 'Y' || isloadingChecking || isloadingFetchOCR || !selectedItem"
                          :rules="aspectDataPatternRequired"
                          :error-messages="item.erroraspectmessages"
                          @input="
                            !selectedItem ? null : $v.selectedItem.aspect_data_patternfilename_template.$each[
                              i
                            ].fixvalue.$touch()
                          "
                          @blur="
                            !selectedItem ? null : $v.selectedItem.aspect_data_patternfilename_template.$each[
                              i
                            ].fixvalue.$touch()
                          "
                        >
                        </v-text-field>
                        <v-text-field
                          v-else
                          height="35px"
                          class="textFieldClass"
                          v-model.trim="item.value"
                          maxlength="50"
                          outlined
                          dense
                          :color="color.theme"
                          :disabled="item.status_fix === 'Y' || isloadingChecking || isloadingFetchOCR || !selectedItem"
                          prepend-icon="mdi-format-text"
                          :rules="aspectDataPatternRequired"
                          :error-messages="item.erroraspectmessages"
                          @input="
                            !selectedItem ? null : $v.selectedItem.aspect_data_patternfilename_template.$each[i].value.$touch()
                          "
                          @blur="
                            !selectedItem ? null : $v.selectedItem.aspect_data_patternfilename_template.$each[i].value.$touch()
                          "
                        >
                        </v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                </v-list>
              </div>
              </div>
              <div
                v-else-if="
                  loadingdatatemplate === false &&
                    detailstemplate.aspect_data.length === 0 ||
                    detailstemplate.aspect_data.filter(item => item.readfilename === 'N').length === 0 &&
                    !manageAI
                "
                style="overflow:hidden;"
              >
                <v-layout row wrap class="text-center mt-12">
                  <v-flex class="text-center">
                    <span style="font-size: 24px">
                      {{ $t("smartinput.emptry_aspect") }}
                    </span>
                  </v-flex>
                </v-layout>
              </div>
              <div v-else style="text-align: center;">
                <div
                  style="display: inline-block;vertical-align: middle;line-height: 1.5;"
                >
                  <v-progress-circular
                    :width="10"
                    :color="color.theme"
                    indeterminate
                    :size="100"
                  ></v-progress-circular>
                </div>
              </div>
            </v-flex>
            <!-- <v-flex xl5 lg5 md5 v-else style="overflow-y: scroll; max-height: 600px">
              <div
                v-if="
                  loadingdatatemplate === false &&
                    detailstemplate.aspect_data.length > 0
                "
              >
                <v-list
                  dense
                  v-for="(item, i) in detailstemplate.aspect_data"
                  :key="i"
                  class="mb-3 ml-4 pr-10"
                  :style="
                    $vuetify.theme.dark
                      ? 'background-color:#474747'
                      : 'background-color:#f5f5f5'
                  "
                  style="width: 90%; border-radius: 10px;"
                >
                  <v-list-item class="" style="">
                    <v-list-item-content>
                      <v-list-item-title
                        style="font-size:16px; line-height: 24px"
                      >
                        {{ item.aspect_label }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item class="mt-n4">
                    <v-list-item-content>
                      <span>{{
                        $t("smartinput.fomatnamefile") +
                          " : " +
                          item.aspect_name +
                          item.aspect_symbol +
                          "XXXXXXXXXX"
                      }}</span>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>
              <div
                v-else-if="
                  loadingdatatemplate === false &&
                    detailstemplate.aspect_data.length === 0
                "
                style="overflow:hidden;"
              >
                <v-layout row wrap class="text-center mt-12">
                  <v-flex class="text-center">
                    <span style="font-size: 24px">
                      {{ $t("smartinput.emptry_aspect") }}
                    </span>
                  </v-flex>
                </v-layout>
              </div>
              <div v-else style="text-align: center;">
                <div
                  style="display: inline-block;vertical-align: middle;line-height: 1.5;"
                >
                  <v-progress-circular
                    :width="10"
                    :color="color.theme"
                    indeterminate
                    :size="100"
                  ></v-progress-circular>
                </div>
              </div>
            </v-flex> -->
          </v-layout>
        </v-card-text>
        <v-card-text v-else>
          <div>
            <v-divider></v-divider>
            <v-list
              two-line
              v-for="(item, i) in temparraydataupload"
              :key="item.id"
            >
              <v-list-item>
                <v-list-item-action class="mr-4 ml-n4 d-flex flex-row">
                  <div style="position: absolute; bottom: 30px;" v-if="['warning', 'fail', 'cancel'].includes(item.status) && !length_uploading >= 1" >
                    <v-checkbox dense hide-details :value="item" :key="i" v-model="selected_reupload" /> 
                  </div>
                  <v-icon size="55" :color="item.icon[1]" class="ml-8">{{
                    item.icon[0]
                  }}</v-icon>
                </v-list-item-action>
                <v-list-item-content class="mr-n2">
                  <v-list-item-title style="font-size: 14px;line-height:24px;">
                    <v-text-field
                      v-if="item.checkfailformat === true"
                      v-model="item.name"
                      outlined
                      dense
                      :color="color.theme"
                      :value="item.name"
                      :suffix="'.' + item.typefile"
                      :rules="filenameRequired"
                      :error-messages="item.errorfailformat"
                      @input="$v.temparraydataupload.$each[i].name.$touch()"
                      @blur="$v.temparraydataupload.$each[i].name.$touch()"
                    >
                    </v-text-field>
                    <!-- <span v-else>{{ item.name + "." + item.typefile }}</span> -->
                    <span v-else>{{ item.name }}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle style="font-size: 12px;">
                    <p>
                      {{ calculatesize(item.size) }}
                      <span v-if="item.status === 'start'" class="float-right"
                        >{{ Math.floor(item.value) }} %</span
                      >
                      <span
                        v-else-if="item.status === 'success'"
                        style="color:green;"
                        class="float-right"
                        >{{ item.msg }}</span
                      >
                      <span
                        v-else-if="item.status === 'fail'"
                        style="color:red;"
                        class="float-right"
                        >{{ item.msg }}</span
                      >
                      <span
                        v-else-if="item.status === 'skip'"
                        style="color:red;"
                        class="float-right"
                        >{{ item.msg }}</span
                      >
                      <span
                        v-else-if="item.status === 'cancel'"
                        style="color:red;"
                        class="float-right"
                        >{{ item.msg }}</span
                      >
                      <span
                        v-else-if="item.status === 'warning'"
                        style="color: #FFA726;"
                        class="float-right"
                        >{{ item.msg }}</span
                      >
                      <!-- <span
                        v-else-if="item.status === 'duplicate'"
                        style="color:#fb8c00;"
                        class="float-right"
                        >{{ item.msg }}</span
                      > -->
                    </p>
                  </v-list-item-subtitle>
                  <v-progress-linear
                    :color="item.colorupload"
                    :value="item.value"
                  ></v-progress-linear>
                  <p class="pt-3 font-weight-bold" v-if="item.status === 'duplicate'" style="color:#fb8c00;">
                    {{item.msg}}
                  </p>
                </v-list-item-content>
                <v-list-item-action
                  class="text-right mr-n6"
                  style="width: 90px"
                >
                  <!-- ปุ่ม replace -->
                  <!-- <v-btn
                    v-if="
                      (item.status === 'duplicate' &&
                        length_processing === temparraydataupload.length) ||
                        (item.status === 'duplicate' &&
                          checkstatusduplicate === true)
                    "
                    @click="
                      (checkstatusduplicate = true),
                        setStatusFileDuplicate('replace', item.id)
                    "
                    :color="$vuetify.theme.dark ? 'white' : 'primary'"
                    outlined
                    small
                    width="80px"
                  >
                    {{ $t("fileduplicate.filereplace") }}
                  </v-btn> -->
                  <!-- ปุ่ม copy -->
                  <!-- <v-btn
                    v-if="
                      (item.status === 'duplicate' &&
                        length_processing === temparraydataupload.length) ||
                        (item.status === 'duplicate' &&
                          checkstatusduplicate === true)
                    "
                    @click="
                      (checkstatusduplicate = true),
                        setStatusFileDuplicate('copy', item.id)
                    "
                    :color="$vuetify.theme.dark ? 'white' : 'success'"
                    outlined
                    small
                    width="80px"
                    class="mt-1"
                  >
                    {{ $t("fileduplicate.filecopy") }}
                  </v-btn> -->
                  <!-- ปุ่ม fileskip -->
                  <!-- <v-btn
                    v-if="
                      (item.status === 'duplicate' &&
                        length_processing === temparraydataupload.length) ||
                        (item.status === 'duplicate' &&
                          checkstatusduplicate === true)
                    "
                    @click="
                      (checkstatusduplicate = true),
                        setStatusFileDuplicate('', item.id)
                    "
                    :color="$vuetify.theme.dark ? 'white' : 'error'"
                    outlined
                    small
                    width="80px"
                    class="mt-1"
                  >
                    {{ $t("fileduplicate.fileskip") }}
                  </v-btn> -->
                  <!-- ปุ่ม reupload -->
                  <v-icon
                    v-if="item.status === 'fail' || item.status === 'cancel' || item.status === 'warning'"
                    @click="(reloadId = item.id), fnLoopUploadFile_v3()"
                    :color="$vuetify.theme.dark ? 'white' : color.theme"
                    :disabled="length_uploading >= 1"
                    class="ml-8"
                    >mdi-reload</v-icon
                  >
                  <!-- ปุ่ม cancel upload -->
                  <v-icon
                    v-if="item.status === 'start'"
                    class="ml-8"
                    @click="cacelUpload_v2(i)"
                    :color="$vuetify.theme.dark ? 'white' : 'error'"
                    >mdi-close</v-icon
                  >
                  <!-- ไอคอนอัปโหลดสำเร็จ -->
                  <v-icon
                    v-if="item.status === 'success'"
                    class="ml-8"
                    :color="$vuetify.theme.dark ? 'white' : 'success'"
                    >mdi-check</v-icon
                  >
                  <!-- ไอคอนยกเลิก -->
                  <v-icon
                    v-if="item.status === 'skip'"
                    class="ml-8"
                    :color="$vuetify.theme.dark ? 'white' : 'red'"
                    >mdi-cancel</v-icon
                  >
                  <v-progress-circular 
                    v-if="item.status === 'wait'"
                    size="28"
                    :color="color.theme"
                    indeterminate

                  />
                  <!-- ปุ่ม major and minor -->
                  <div v-if="item.status === 'duplicate'" class="d-flex flex-column" style="gap: 5px;" >
                    <v-tooltip left open-delay="200">
                      <template v-slot:activator="{ on, attrs }">
                      <v-btn :disabled="item.unique_number !== undefined ? temparraydataupload.find((itemID) => itemID.id === item.unique_number).status === 'success' ? false : temparraydataupload.every((itemCheck) => itemCheck.status === 'duplicate') ? false : true : false" 
                        @click="(reloadId = item.id), fnLoopMajorMinor('major', item)" color="success" v-bind="attrs" v-on="on" small rounded class="text-center d-flex align-center">
                        <span  class="font-weight-bold" >
                          {{ $t('smartinput.major') }}
                        </span>
                      </v-btn>
                      </template>
                      <span> {{ $t('smartinput.major_tooltip') }} </span>
                    </v-tooltip>
                    <v-tooltip left open-delay="200">
                      <template v-slot:activator="{ on, attrs }">
                      <v-btn :disabled="item.unique_number !== undefined ? temparraydataupload.find((itemID) => itemID.id === item.unique_number).status === 'success' ? false : temparraydataupload.every((itemCheck) => itemCheck.status === 'duplicate') ? false : true : false" 
                        @click="(reloadId = item.id), fnLoopMajorMinor('minor', item)" v-bind="attrs" v-on="on" color="warning" small rounded class="text-center d-flex align-center" >
                        <span  class="font-weight-bold" >
                          {{ $t('smartinput.minor') }}
                        </span>
                      </v-btn>
                      </template>
                      <span> {{ $t('smartinput.minor_tooltip') }} </span>
                    </v-tooltip>
                  </div>

                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
            </v-list>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="red"
            class="white--text"
            @click="
              checkstatusupload === false
                ? ($emit('close'), $emit('opendragselect'), (alertSomeFolder = false))
                : $emit('closemobile')
            "
            :disabled="length_uploading >= 1"
            >{{ $t("uploadfile.buttonclose") }}</v-btn
          >

          <v-btn
            v-if="statusuploading"
            class="white--text"
            :color="$vuetify.theme.dark ? 'white' : color.theme"
            @click="cleardataNoclose()"
            :disabled="length_uploading >= 1"
          >
          {{ $t("default") === 'th' ? 'ย้อนกลับ' : 'Back' }}
          </v-btn>

          <v-btn
            color="red"
            class="white--text"
            :disabled="createprogress || statusuploading || isloadingChecking"
            @click="cleardata()"
          >
            {{ $t("direct_upload.clearfile") }}
          </v-btn>
          <v-btn
          v-if="!statusuploading"
            color="#23526c"
            @click="fnLoopUploadFile_v3()"
            class="white--text"
            :disabled="
              createprogress ||
                statusuploading ||
                stackfileloading ||
                datatemplate.length === 0
            "
          >
            {{ $t("direct_upload.uploadfile") }}
          </v-btn>
          <v-btn
            v-else-if="statusuploading && !length_uploading >= 1 && temparraydataupload.filter((items) => ['warning', 'fail', 'cancel'].includes(items.status)).length >= 1"
            color="#23526c"
            @click="fn_reupload_smartupload()"
            class="white--text"
            :disabled="selected_reupload.length <= 0"
          >
            {{ $t('default') === 'th' ? 'อัปโหลดอีกครั้ง' : 'Upload Again' }}
            <v-icon
              right
              dark
            >
              mdi-reload
            </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- หน้าจอมือถือ -->
    <v-dialog
      v-model="shower"
      scrollable
      persistent
      :max-width="maxWidthOnMobile"
      content-class="rounded-lg"
      v-else
    >
      <v-card>
        <v-card-text class="px-5 pt-4 pb-2" style="overflow-y:hidden">
          <v-layout class="pt-2 pb-1">
            <v-flex d-flex justify-center class="ml-8">
              <span :style="headerPage">{{ $t("uploadfile.name") }}</span>
            </v-flex>
            <v-flex xs1 d-flex justify-end>
              <v-icon
                :color="$vuetify.theme.dark ? 'white' : color.theme"
                @click="
                  checkstatusupload === false
                    ? ($emit('close'), $emit('opendragselect'))
                    : $emit('closemobile')
                "
                :disabled="length_uploading >= 1"
                >mdi-close</v-icon
              >
            </v-flex>
          </v-layout>
          <v-layout class="pt-4" v-if="statusuploading === true" row wrap>
            <v-flex xs2>
              <v-btn
                elevation="1"
                fab
                x-small
                class="text-center ml-4"
                :color="$vuetify.theme.dark ? 'white' : color.theme"
                @click="cleardataNoclose()"
                :disabled="createprogress"
              >
                <v-icon
                  :color="$vuetify.theme.dark ? '#989898' : 'white'"
                  dark
                  size="20"
                  >keyboard_backspace</v-icon
                >
              </v-btn>
            </v-flex>
            <v-flex xs10 class="text-right pr-2">
              <v-chip outlined
                >{{
                  $t("uploadfile.uploadingfile") + " " + length_uploading + " "
                }}
                {{
                  length_uploading > 1
                    ? $t("uploadfile.files")
                    : $t("uploadfile.file")
                }}</v-chip
              >
              <v-chip outlined
                >{{
                  $t("uploadfile.duplicate") + " " + length_duplicate + " "
                }}
                {{
                  length_duplicate > 1
                    ? $t("uploadfile.files")
                    : $t("uploadfile.file")
                }}</v-chip
              >
            </v-flex>
            <v-flex xs12 class="text-right pr-2">
              <v-chip outlined
                >{{ $t("uploadfile.success") + " " + length_success + " " }}
                {{
                  length_success > 1
                    ? $t("uploadfile.files")
                    : $t("uploadfile.file")
                }}</v-chip
              >
              <v-chip outlined
                >{{ $t("uploadfile.fail") + " " + length_fail + " " }}
                {{
                  length_fail > 1
                    ? $t("uploadfile.files")
                    : $t("uploadfile.file")
                }}</v-chip
              >
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-text
          :style="'max-height: ' + maxHeightOnMobile + '; height: auto;'"
        >
          <div class="text-right" v-if="statusuploading === false">
            <v-layout row class="mx-1 mt-2">
              <v-flex>
                <v-autocomplete
                  :items="datatemplate"
                  solo
                  v-model="selectdatatemplate"
                  :label="$t('smartinput.template')"
                  dense
                  prepend-icon="layers"
                  item-value="id"
                  item-text="template_name"
                  :color="color.theme"
                  outlined
                  :item-color="`${color.theme}`"
                  return-object
                  @change="
                    $v.$reset(),
                      getDetailsTemplate(
                        selectdatatemplate.id,
                        selectdatatemplate.structure_data,
                        selectdatatemplate
                      )
                  "
                  :no-data-text="$t('smartinput.no_data_templates')"
                  :disabled="isloadingChecking"
                >
                  <!-- fn_check_smup_specific() ? '' :  -->
                  <template :color="color.theme" v-slot:item="{ item }">
                    <span style="">{{ item.template_name }}</span>
                  </template>
                </v-autocomplete>
                <!-- <v-select
                  :items="datatemplate"
                  v-model="selectdatatemplate"
                  :label="$t('smartinput.template')"
                  outlined
                  dense
                  prepend-icon="layers"
                  return-object
                  item-value="template_id"
                  item-text="template_name"
                  :color="color.theme"
                  :item-color="`${color.theme}`"
                  @change="$v.$reset(),getDetailsTemplate(selectdatatemplate.template_id)"
                >
                  <template :color="color.theme" v-slot:item="{ item }">
                    <span style="">{{ item.template_name }}</span>
                  </template>
                </v-select> -->
              </v-flex>
            </v-layout>
          </div>
          <div v-if="statusuploading === false">
            <v-layout v-if="datatemplate.length > 0" row wrap class="mx-1 mt-6">
              <v-flex lg12>
                <v-card-actions class="mx-n3 mt-0">
                  <div
                    class="pa-1 px-3 text-left"
                    :style="
                      $vuetify.theme.dark
                        ? 'background-color:#474747'
                        : 'background-color:#f5f5f5'
                    "
                    style="width: 100%; border-radius: 10px;"
                  >
                    <v-skeleton-loader
                      v-if="loadingdatatemplate === true"
                      :style="
                        $vuetify.theme.dark
                          ? 'background-color:#474747'
                          : 'background-color:#f5f5f5'
                      "
                      type="text"
                    ></v-skeleton-loader>
                    <span
                      v-else
                      class="font-weight-bold"
                      style="font-size: 14px;"
                    >
                      {{ $t("smartinput.fileto") }}
                     
                      <span>
                        {{ 
                            ((!['null', null, ''].includes(currenttemplate.structure_change_file_name) ||
                            detailstemplate.aspect_data.map((itemMap) => { return itemMap.aspect_condition }).some((itemFind) => itemFind === 'Y')) && !manageAI) 
                             ? structure_data_v3 : structure_data_v2 }}
                        <!-- {{ structure_symbol_data }} -->
                      </span>
                      <p v-if="currenttemplate.structure_file_name !== '' && currenttemplate.structure_file_name !== null" class="mb-0">
                        {{ $t("smartinput.exemplefilename") }}
                        {{ fn_extractFormat(currenttemplate.structure_file_name) }}
                      </p>
                    </span>
                  </div>
                </v-card-actions>
              </v-flex>
            </v-layout>
          </div>
          <div v-if="statusuploading === false" class="mt-3">
            <div
              v-if="
                loadingdatatemplate === false &&
                  detailstemplate.aspect_data.length === 0 ||
                  detailstemplate.aspect_data.filter(item => item.readfilename === 'N').length === 0
              "
              style="overflow:hidden;"
            >
              <v-layout row wrap class="text-center my-6 mb-12">
                <v-flex class="text-center">
                  <span style="font-size: 18px">
                    {{ $t("smartinput.emptry_aspect") }}
                  </span>
                </v-flex>
              </v-layout>
            </div>
            <v-expansion-panels v-else>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <p class="pt-2">
                    <span
                      v-if="checkdetailmobile === true"
                      style="font-size:18px; line-height: 24px; color: red;"
                      >*</span
                    >
                    {{ $t("smartinput.tampletedetail") }}
                  </p>
                </v-expansion-panel-header>
                <v-expansion-panel-content v-if="loadingdatatemplate === false">
                  <!-- v-if="!listbizsymbolsmartupload.includes(
                  dataAccountActive.business_info.taxid
                  )" -->
                  <div v-if="
                  loadingdatatemplate === false &&
                    (detailstemplate.aspect_data.length > 0 &&
                    detailstemplate.aspect_data.filter(item => item.readfilename === 'N').length > 0 &&
                    !manageAI && ['null', null, ''].includes(currenttemplate.structure_change_file_name) 
                    )
                  ">
                    <v-list
                      dense
                      v-for="(item, i) in detailstemplate.aspect_data"
                      :key="i"
                      :class="item.readfilename === 'N' ? 'mb-3' : ''"
                    >
                      <v-list-item v-if="item.readfilename === 'N'" class="mt-n3">
                        <v-list-item-content>
                          <v-list-item-title
                            style="font-size:16px; line-height: 24px"
                          >
                            <span
                              v-if="item.aspect_null === 'Y'"
                              style="font-size:18px; line-height: 24px; color: red;"
                              >*</span
                            >
                            {{ item.aspect_label }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item v-if="item.readfilename === 'N'" class="mt-n1 mb-n6">
                        <v-list-item-content
                          v-if="
                            item.aspect_type === 'DROPDOWN' &&
                              item.status_value === 'Y'
                          "
                        >
                          <v-select
                            v-model="item.value"
                            :items="item.aspect_fix_key_extra"
                            outlined
                            dense
                            item-color="color.theme"
                            :color="color.theme"
                            prepend-icon="mdi-format-list-bulleted-type"
                            :item-value="item.aspect_fix_key_extra[0]"
                            :disabled="isloadingChecking"
                          >
                            <template v-slot:item="{ item }">{{
                              item === "notselecttemplate"
                                ? $t("smartinput.notchose")
                                : `${item} ${getFindValueObject(item, i) === "" ? '' : `(${getFindValueObject(item, i)})`}`
                            }}</template>
                            <template v-slot:selection="{ item }">{{
                              item === "notselecttemplate"
                                ? $t("smartinput.notchose")
                                : `${item} ${getFindValueObject(item, i) === "" ? '' : `(${getFindValueObject(item, i)})`}`
                            }}</template>
                          </v-select>
                        </v-list-item-content>
                        <v-list-item-content
                          v-else-if="
                            item.aspect_type === 'DATE' &&
                              item.status_value === 'Y'
                          "
                        >
                          <v-dialog
                            persistent
                            v-model="item.menudate"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                :color="color.theme"
                                prepend-icon="event"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                dense
                                outlined
                                clearable
                                @click:clear="
                                  item.aspect_null === 'Y'
                                    ? (item.fixvalue = '')
                                    : (item.value = '')
                                "
                                :value="item.showdate"
                                :rules="aspectDataRequired"
                                :error-messages="item.erroraspectmessages"
                                @input="
                                  item.aspect_null === 'Y'
                                    ? $v.detailstemplate.aspect_data.$each[
                                        i
                                      ].fixvalue.$touch()
                                    : $v.detailstemplate.aspect_data.$each[
                                        i
                                      ].value.$touch()
                                "
                                @blur="
                                  item.aspect_null === 'Y'
                                    ? $v.detailstemplate.aspect_data.$each[
                                        i
                                      ].fixvalue.$touch()
                                    : $v.detailstemplate.aspect_data.$each[
                                        i
                                      ].value.$touch()
                                "
                                :disabled="isloadingChecking"
                              >
                              </v-text-field>
                            </template>
                            <v-date-picker
                              v-model="item.showdate"
                              :locale="$t('default')"
                              @input="
                                (item.menudate = false),
                                  item.aspect_null === 'Y'
                                    ? (item.fixvalue = changeDateFormat(item))
                                    : (item.value = changeDateFormat(item))
                              "
                              :color="color.theme"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                dark
                                color="error"
                                @click="item.menudate = false"
                              >
                                {{ $t("sharefile.closedatepiker") }}
                              </v-btn>
                            </v-date-picker>
                          </v-dialog>
                        </v-list-item-content>
                        <v-list-item-content
                          v-else-if="
                            item.aspect_type === 'TEXT' &&
                              item.status_value === 'Y'
                          "
                        >
                          <v-text-field
                            v-if="item.aspect_null === 'Y'"
                            height="35px"
                            class="textFieldClass"
                            v-model.trim="item.fixvalue"
                            maxlength="50"
                            outlined
                            dense
                            :color="color.theme"
                            prepend-icon="mdi-format-text"
                            :rules="aspectDataRequired"
                            :error-messages="item.erroraspectmessages"
                            @input="
                              $v.detailstemplate.aspect_data.$each[
                                i
                              ].fixvalue.$touch()
                            "
                            @blur="
                              $v.detailstemplate.aspect_data.$each[
                                i
                              ].fixvalue.$touch()
                            "
                            :disabled="isloadingChecking"
                          >
                          </v-text-field>
                          <v-text-field
                            v-else
                            height="35px"
                            class="textFieldClass"
                            v-model.trim="item.value"
                            maxlength="50"
                            outlined
                            dense
                            :color="color.theme"
                            prepend-icon="mdi-format-text"
                            :rules="aspectDataRequired"
                            :error-messages="item.erroraspectmessages"
                            @input="
                              $v.detailstemplate.aspect_data.$each[
                                i
                              ].value.$touch()
                            "
                            @blur="
                              $v.detailstemplate.aspect_data.$each[
                                i
                              ].value.$touch()
                            "
                            :disabled="isloadingChecking"
                          >
                          </v-text-field>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </div>
                  <div v-else-if="
                    loadingdatatemplate === false && 
                    (detailstemplate.aspect_data.length > 0 &&
                    detailstemplate.aspect_data.filter(item => item.readfilename === 'N').length > 0 &&
                    !manageAI && !['null', null, ''].includes(currenttemplate.structure_change_file_name) ||
                    this.detailstemplate.aspect_data.some((itemFind) => itemFind.aspect_condition === 'Y')
                    )" >
                      <v-list>
                        <v-list-item>
                          <v-list-item-content >
                            <v-list-item-title
                              style="font-size:16px; line-height: 24px"
                            >
                              <span>Pattern Filename </span> <span class="font-weight-bold">{{ selectedItem ? `(${selectedItem.backup_filename})` : '' }}</span>
                            </v-list-item-title>
                            <v-text-field
                            v-if="selectedItem !== null && [null, '', 'null'].includes(currenttemplate.structure_change_file_name)"
                            height="35px"
                            class="textFieldClass"
                            maxlength="50"
                            outlined
                            v-model.trim="filenameWithoutExtension"
                            dense
                            :color="color.theme"
                            prepend-icon="mdi-format-text"
                            disabled
                            >
                            </v-text-field>
                            <v-text-field
                              v-else-if="selectedItem !== null && ![null, '', 'null'].includes(currenttemplate.structure_change_file_name)"
                              height="35px"
                              class="textFieldClass"
                              maxlength="50"
                              outlined
                              v-model.trim="selectedItem.pattern_filename"
                              dense
                              :color="color.theme"
                              prepend-icon="mdi-format-text"
                              disabled
                            >
                            </v-text-field>
                            <v-text-field
                              v-else
                              height="35px"
                              class="textFieldClass"
                              v-model.trim="currenttemplate.structure_change_file_name"
                              maxlength="50"
                              outlined
                              dense
                              disabled
                              :color="color.theme"
                              prepend-icon="mdi-format-text"
                            >
                            </v-text-field>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    
                      <v-list
                      dense
                      v-for="(item, i) in ![null, undefined].includes(selectedItem) ? selectedItem.aspect_data_patternfilename_template : detailstemplate.aspect_data"
                      :key="i"
                      :class="item.readfilename === 'N' ? 'mb-3' : ''"
                    >
                      <v-list-item v-if="item.readfilename === 'N'" class="mt-n3">
                        <v-list-item-content>
                          <v-list-item-title
                            style="font-size:16px; line-height: 24px"
                          >
                            <span
                              v-if="item.aspect_null === 'Y'"
                              style="font-size:18px; line-height: 24px; color: red;"
                              >*</span
                            >
                            {{ item.aspect_label }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item v-if="item.readfilename === 'N'" class="mt-n1 mb-n6">
                        <v-list-item-content
                          v-if="
                            item.aspect_type === 'DROPDOWN' &&
                              item.status_value === 'Y'
                          "
                        >
                          <v-select
                            v-model="item.value"
                            :items="item.aspect_fix_key_extra"
                            outlined
                            dense
                            item-color="color.theme"
                            :color="color.theme"
                            prepend-icon="mdi-format-list-bulleted-type"
                            :item-value="item.aspect_fix_key_extra[0]"
                            :disabled="isloadingChecking || isloadingFetchOCR || !selectedItem"
                          >
                            <template v-slot:item="{ item }">{{
                              item === "notselecttemplate"
                                ? $t("smartinput.notchose")
                                : `${item} ${getFindValueObject(item, i) === "" ? '' : `(${getFindValueObject(item, i)})`}`
                            }}</template>
                            <template v-slot:selection="{ item }">{{
                              item === "notselecttemplate"
                                ? $t("smartinput.notchose")
                                : `${item} ${getFindValueObject(item, i) === "" ? '' : `(${getFindValueObject(item, i)})`}`
                            }}</template>
                          </v-select>
                        </v-list-item-content>
                        <v-list-item-content
                          v-else-if="
                            item.aspect_type === 'DATE' &&
                              item.status_value === 'Y'
                          "
                        >
                          <v-dialog
                            persistent
                            v-model="item.menudate"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                :color="color.theme"
                                prepend-icon="event"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                dense
                                outlined
                                clearable
                                @click:clear="
                                  item.aspect_null === 'Y'
                                    ? (item.fixvalue = '')
                                    : (item.value = '')
                                "
                                :value="item.showdate"
                                :rules="aspectDataRequired"
                                :error-messages="item.erroraspectmessages"
                                  @input="
                                  item.aspect_null === 'Y'
                                    ? $v.selectedItem.aspect_data_patternfilename_template.$each[
                                        i
                                      ].fixvalue.$touch()
                                    : $v.selectedItem.aspect_data_patternfilename_template.$each[
                                        i
                                      ].value.$touch()
                                "
                                @blur="
                                  item.aspect_null === 'Y'
                                    ? $v.selectedItem.aspect_data_patternfilename_template.$each[
                                        i
                                      ].fixvalue.$touch()
                                    : $v.selectedItem.aspect_data_patternfilename_template.$each[
                                        i
                                      ].value.$touch()
                                "
                                :disabled="isloadingChecking || isloadingFetchOCR || !selectedItem"
                              >
                              </v-text-field>
                            </template>
                            <v-date-picker
                              v-model="item.showdate"
                              :locale="$t('default')"
                              @input="
                                (item.menudate = false),
                                  item.aspect_null === 'Y'
                                    ? (item.fixvalue = changeDateFormat(item))
                                    : (item.value = changeDateFormat(item))
                              "
                              :color="color.theme"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                dark
                                color="error"
                                @click="item.menudate = false"
                              >
                                {{ $t("sharefile.closedatepiker") }}
                              </v-btn>
                            </v-date-picker>
                          </v-dialog>
                        </v-list-item-content>
                        <v-list-item-content
                          v-else-if="
                            item.aspect_type === 'TEXT' &&
                              item.status_value === 'Y'
                          "
                        >
                          <v-text-field
                            v-if="item.aspect_null === 'Y'"
                            height="35px"
                            class="textFieldClass"
                            v-model.trim="item.fixvalue"
                            maxlength="50"
                            outlined
                            dense
                            :color="color.theme"
                            prepend-icon="mdi-format-text"
                            :rules="aspectDataRequired"
                            :error-messages="item.erroraspectmessages"
                            @input="
                            !selectedItem ? null : $v.selectedItem.aspect_data_patternfilename_template.$each[
                              i
                            ].fixvalue.$touch()
                            "
                            @blur="
                              !selectedItem ? null : $v.selectedItem.aspect_data_patternfilename_template.$each[
                                i
                              ].fixvalue.$touch()
                            "
                            :disabled="item.status_fix === 'Y' || isloadingChecking || isloadingFetchOCR || !selectedItem"
                          >
                          </v-text-field>
                          <v-text-field
                            v-else
                            height="35px"
                            class="textFieldClass"
                            v-model.trim="item.value"
                            maxlength="50"
                            outlined
                            dense
                            :color="color.theme"
                            prepend-icon="mdi-format-text"
                            :rules="aspectDataRequired"
                            :error-messages="item.erroraspectmessages"
                            @input="
                            !selectedItem ? null : $v.selectedItem.aspect_data_patternfilename_template.$each[i].value.$touch()
                            "
                            @blur="
                              !selectedItem ? null : $v.selectedItem.aspect_data_patternfilename_template.$each[i].value.$touch()
                            "
                            :disabled="item.status_fix === 'Y' || isloadingChecking || isloadingFetchOCR || !selectedItem"
                          >
                          </v-text-field>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </div>
                  <div v-else >
                    <v-layout row wrap class="text-center py-4">
                      <v-flex class="text-center">
                        <span style="font-size: 24px" class="">
                          {{ $t('default') === 'en' ? 'Read file contents with AI' : 'อ่านเนื้อหาไฟล์ด้วย AI' }}
                        </span>
                      </v-flex>
                  </v-layout>
                  </div>
                  <div>
                    <v-list
                      dense
                      v-for="(item, i) in listaspectsymbol"
                      :key="i"
                      class="mb-3"
                      :style="
                        $vuetify.theme.dark
                          ? 'background-color:#474747'
                          : 'background-color:#f5f5f5'
                      "
                      style="width: 100%; border-radius: 10px;"
                    >
                      <v-list-item class="mb-n4">
                        <v-list-item-content>
                          <v-list-item-title
                            style="font-size:16px; line-height: 24px"
                          >
                            {{ item.aspect_label }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item class="mt-0">
                        <v-list-item-content>
                          <span>{{ $t("smartinput.fomatnamefile") }} </span
                          ><br />
                          <span>{{
                            item.aspect_name + item.aspect_symbol + "XXXXXXXXXX"
                          }}</span>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </div>
                </v-expansion-panel-content>
                <v-expansion-panel-content v-else>
                  <div
                    style="display: inline-block;vertical-align: middle;line-height: 1.5;"
                  >
                    <v-progress-circular
                      :width="10"
                      :color="color.theme"
                      indeterminate
                      :size="100"
                    ></v-progress-circular>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
          
          <div class="text-right" v-if="statusuploading === false">
            <v-layout row wrap class="mx-1 mt-6">
              <v-flex lg12 v-if="totalstackfile <= 0">
                <v-chip outlined color="#FFA000">
                  <p style="font-size: 16px; font-weight: 600;" class="mt-4">
                    {{ $t("direct_upload.nofilewaitupload") }}
                  </p>
                </v-chip>
              </v-flex>
              <v-flex lg12 v-else>
                <v-chip color="success">
                  <p style="font-size: 16px" class="mt-4">
                    <span style="font-weight: 600;">
                      {{ totalstackfile }}
                    </span>
                    {{
                      totalstackfile > 1
                        ? $t("direct_upload.files")
                        : $t("direct_upload.file")
                    }}
                  </p>
                </v-chip>
              </v-flex>
            </v-layout>
          </div>
          <!-- alert folder -->
          <div v-if="alertSomeFolder">
            <span style="color: red" class="font-weight-bold">
              * {{ $t('smartinput.smartupload_type_error') }}
            </span>
          </div>
          <!-- upload layout -->
          <v-card-text
            :style="uploadLayoutMobile"
            class="text-center mt-3 dropzoneupload"
            id="dropzoneuploadfiles"
            v-if="statusuploading === false"
          >
            <div
              style="border-radius: 24px; position: relative;"
              class="text-center mt-4 mx-auto dropzoneupload"
              v-if="totalstackfile > 0"
              id="dropzoneuploadfiles"
            >
              <div
                @click="ImportFiles"
                id="inputuploadfiles"
                style="opacity: 0;"
                class="dropzoneupload"
              >
                <input
                  ref="importdoc"
                  type="file"
                  @change="fnStackFile"
                  multiple
                  class="d-none dropzoneupload"
                />
              </div>
              <v-overlay
                :value="stackfileloading"
                absolute
                class="mx-n4 mt-n3 mb-n5"
              >
                <v-progress-circular indeterminate></v-progress-circular>
              </v-overlay>
              <v-list
                class="pt-2 mx-n4 mt-n6 dropzoneupload"
                dense
                style="z-index:3; overflow-y: scroll; height: 320px;"
                id="listStackFiles layouthoveruploadfiles"
              >
                <v-list-item
                  class="dropzoneupload"
                  v-for="item in arraydataupload"
                  :key="item.id"
                  :ripple="false"
                  id="listStackFiles dropzoneupload"
                  @click="!['null', null, ''].includes(currenttemplate.structure_change_file_name) || detailstemplate.aspect_data.some((itemSome) => itemSome.aspect_condition === 'Y') ? (selectedItem = item) : (selectedItem = null)"
                >
                  <v-list-item-action class="mr-4 dropzoneupload">
                    <v-icon large :color="item.icon[1]" class="dropzoneupload">{{
                      item.icon[0]
                    }}</v-icon>
                    <v-icon class="mt-1 ml-5 dropzoneupload" 
                      v-if="selectedItem !== null && selectedItem.id === item.id && checkSelectedItem" 
                      style="position: absolute; left: 25px">
                        mdi-circle-small
                      </v-icon>
                  </v-list-item-action>
                  <v-list-item-content class="mr-n2 text-left dropzoneupload">
                    <v-list-item-title style="font-size: 14px;" class="dropzoneupload">
                      <!-- {{ item.name + "." + item.typefile }} -->
                      {{ item.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle
                      class="dropzoneupload"
                        id="listStackFiles"
                        style="color:red;"
                        v-if="item.errorSize"
                      >
                        {{$t("smartinput.maxSizeFile")}}
                      </v-list-item-subtitle>
                    <v-list-item-subtitle
                      class="dropzoneupload"
                      style="color:red;"
                      v-else-if="
                        item.errorduplicate === 'nonapi' ||
                          item.errorduplicate === 'api'
                      "
                    >
                      {{ $t("uploadfile.fileduplicate") }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action class="text-right dropzoneupload">
                    <!-- ปุ่ม cancel upload -->
                    <v-icon
                      class="ml-2"
                      @click="fnDeleteStackFile(item)"
                      color="red"
                      >mdi-close</v-icon
                    >
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              <div class="mb-0 dropzoneupload">
                <span
                  id="titleTextUploadtitle"
                  class="mr-2 textdropzone"
                  style="font-size:14px;"
                  >{{ $t("smartinput.clicktouploadnew") }}</span
                >
              </div>
              <div>
                <span id="titleTextUploadsubtitle" class="textdropzone" style="font-size:12px;">{{
                  $t("smartinput.maxsizeuploadtext")
                }}</span>
              </div>
            </div>
            <div
              v-else
              :style="uploadLayout"
              class="text-center mt-3 pt-6 pb-6  mx-auto dropzoneupload"
              @click="ImportFiles"
              id="dropzoneuploadfiles"
            >
              <div class="dropzoneupload" id="dropzoneuploadfiles">
                <input
                  ref="importdoc"
                  class="d-none dropzoneupload"
                  type="file"
                  @change="fnStackFile"
                  multiple
                  style="display:none"
                />
                <v-img
                  id="listStackFiles"
                  max-width="220"
                  max-height="210"
                  class="mx-auto dropzoneupload noselect"
                  :src="require('@/assets/img/uploadfiles.png')"
                />
                <span id="titleTextUploadtitle" class="textdropzone noselect" style="font-size:14px">{{
                  $t("smartinput.clicktouploadnew")
                }}</span>
                <!-- <br /> -->
                <span id="titleTextUploadsubtitle" class="textdropzone noselect" style="font-size:12px">{{
                  $t("smartinput.maxsizeuploadtext")
                }}</span>
                <!-- <br />
                <br /> -->
              </div>
            </div>
          </v-card-text>
          <div v-else>
            <v-divider></v-divider>
            <v-list
              two-line
              v-for="(item, i) in temparraydataupload"
              :key="item.id"
              class="mt-n2"
            >
              <v-list-item>
                <v-list-item-action class="mr-4 ml-n4">
                  <v-icon large :color="item.icon[1]">{{
                    item.icon[0]
                  }}</v-icon>
                </v-list-item-action>
                <v-list-item-content class="mr-n2">
                  <v-list-item-title style="font-size: 14px;">
                    <v-text-field
                      v-if="item.checkfailformat === true"
                      v-model="item.name"
                      outlined
                      dense
                      :color="color.theme"
                      :value="item.name"
                      :suffix="'.' + item.typefile"
                      :rules="filenameRequired"
                      :error-messages="item.errorfailformat"
                      @input="$v.temparraydataupload.$each[i].name.$touch()"
                      @blur="$v.temparraydataupload.$each[i].name.$touch()"
                    >
                    </v-text-field>
                    <!-- <span v-else>{{ item.name + "." + item.typefile }}</span> -->
                    <span v-else>{{ item.name }}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle style="font-size: 12px;">
                    <p>
                      {{ calculatesize(item.size) }}
                    </p>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <span v-if="item.status === 'start'" class="float-right"
                      >{{ Math.floor(item.value) }} %</span
                    >
                    <span
                      v-else-if="item.status === 'success'"
                      style="color:green;"
                      class="float-right"
                      >{{ item.msg }}</span
                    >
                    <span
                      v-else-if="item.status === 'fail'"
                      style="color:red;"
                      class="float-right"
                      >{{ item.msg }}</span
                    >
                    <span
                      v-else-if="item.status === 'skip'"
                      style="color:red;"
                      class="float-right"
                      >{{ item.msg }}</span
                    >
                    <span
                      v-else-if="item.status === 'cancel'"
                      style="color:red;"
                      class="float-right"
                      >{{ item.msg }}</span
                    >
                    <span
                        v-else-if="item.status === 'warning'"
                        style="color: #FFA726;"
                        class="float-right"
                        >{{ item.msg }}</span
                      >
                    <!-- <span
                      v-else-if="item.status === 'duplicate'"
                      style="color:#fb8c00;"
                      class="float-right"
                      >{{ item.msg }}</span
                    > -->
                  </v-list-item-subtitle>
                  <v-progress-linear
                    :color="item.colorupload"
                    class="mt-0"
                    :value="item.value"
                  >
                  </v-progress-linear>
                  <p class="pt-3 font-weight-bold" v-if="item.status === 'duplicate'" style="color:#fb8c00;">
                    {{item.msg}}
                  </p>
                </v-list-item-content>
                <v-list-item-action
                  class="text-right mr-n4"
                  style="width: 70px"
                >
                  <!-- ปุ่ม replace -->
                  <!-- <v-btn
                    v-if="
                      (item.status === 'duplicate' &&
                        length_processing === temparraydataupload.length) ||
                        (item.status === 'duplicate' &&
                          checkstatusduplicate === true)
                    "
                    small
                    @click="
                      (checkstatusduplicate = true),
                        setStatusFileDuplicate('replace', item.id)
                    "
                    :color="$vuetify.theme.dark ? 'white' : 'primary'"
                    outlined
                    width="60px"
                  >
                    {{ $t("fileduplicate.filereplace") }}
                  </v-btn> -->
                  <!-- ปุ่ม copy -->
                  <!-- <v-btn
                    v-if="
                      (item.status === 'duplicate' &&
                        length_processing === temparraydataupload.length) ||
                        (item.status === 'duplicate' &&
                          checkstatusduplicate === true)
                    "
                    small
                    @click="
                      (checkstatusduplicate = true),
                        setStatusFileDuplicate('copy', item.id)
                    "
                    :color="$vuetify.theme.dark ? 'white' : 'success'"
                    outlined
                    width="60px"
                    class="mt-1"
                  >
                    {{ $t("fileduplicate.filecopy") }}
                  </v-btn> -->
                  <!-- ปุ่ม fileskip -->
                  <!-- <v-btn
                    v-if="
                      (item.status === 'duplicate' &&
                        length_processing === temparraydataupload.length) ||
                        (item.status === 'duplicate' &&
                          checkstatusduplicate === true)
                    "
                    small
                    @click="
                      (checkstatusduplicate = true),
                        setStatusFileDuplicate('', item.id)
                    "
                    :color="$vuetify.theme.dark ? 'white' : 'error'"
                    outlined
                    width="60px"
                    class="mt-1"
                  >
                    {{ $t("fileduplicate.fileskip") }}
                  </v-btn> -->
                  <!-- ปุ่ม reupload -->
                  <v-icon
                    v-if="item.status === 'fail' || item.status === 'cancel' || item.status === 'warning'"
                    @click="
                      (checkstatusduplicate = true),
                        (reloadId = item.id),
                        fnLoopUploadFile_v3()
                    "
                    :color="$vuetify.theme.dark ? 'white' : color.theme"
                    :disabled="length_uploading >= 1"
                    class="ml-7"
                    >mdi-reload</v-icon
                  >
                  <!-- ปุ่ม cancel upload -->
                  <v-icon
                    v-if="item.status === 'start'"
                    class="ml-7"
                    @click="cacelUpload_v2(i)"
                    :color="$vuetify.theme.dark ? 'white' : 'error'"
                    >mdi-close</v-icon
                  >
                  <!-- ไอคอนอัปโหลดสำเร็จ -->
                  <v-icon
                    v-if="item.status === 'success'"
                    class="ml-7"
                    :color="$vuetify.theme.dark ? 'white' : 'success'"
                    >mdi-check</v-icon
                  >
                  <!-- ไอคอนยกเลิก -->
                  <v-icon
                    v-if="item.status === 'skip'"
                    class="ml-7"
                    :color="$vuetify.theme.dark ? 'white' : 'red'"
                    >mdi-cancel</v-icon
                  >

                  <!-- ปุ่ม major and minor -->
                  <div v-if="item.status === 'duplicate'" class="d-flex flex-column" style="gap: 5px;" >
                    <v-tooltip left open-delay="200">
                      <template v-slot:activator="{ on, attrs }">
                      <v-btn :disabled="item.unique_number !== undefined ? temparraydataupload.find((itemID) => itemID.id === item.unique_number).status === 'success' ? false : temparraydataupload.every((itemCheck) => itemCheck.status === 'duplicate') ? false : true : false" @click="(reloadId = item.id), fnLoopMajorMinor('major')" color="success" v-bind="attrs" v-on="on" small rounded class="text-center d-flex align-center">
                        <span  class="font-weight-bold" >
                          {{ $t('smartinput.major') }}
                        </span>
                      </v-btn>
                      </template>
                      <span> {{ $t('smartinput.major_tooltip') }} </span>
                    </v-tooltip>
                    <v-tooltip left open-delay="200">
                      <template v-slot:activator="{ on, attrs }">
                      <v-btn :disabled="item.unique_number !== undefined ? temparraydataupload.find((itemID) => itemID.id === item.unique_number).status === 'success' ? false : temparraydataupload.every((itemCheck) => itemCheck.status === 'duplicate') ? false : true : false" @click="(reloadId = item.id), fnLoopMajorMinor('minor')" v-bind="attrs" v-on="on" color="warning" small rounded class="text-center d-flex align-center" >
                        <span  class="font-weight-bold" >
                          {{ $t('smartinput.minor') }}
                        </span>
                      </v-btn>
                      </template>
                      <span> {{ $t('smartinput.minor_tooltip') }} </span>
                    </v-tooltip>
                  </div>
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
            </v-list>
          </div>
        </v-card-text>
        <div class="text-center my-4">
          <v-btn
            color="red"
            height="45px"
            width="35%"
            outlined
            style="font-size: 16px; font-weight: lighter;"
            :disabled="createprogress || statusuploading || isloadingChecking"
            @click="cleardata()"
            class="mr-6"
          >
            {{ $t("direct_upload.clearfile") }}
          </v-btn>
          <v-btn
            class="white--text"
            color="#23526c"
            style="font-size: 16px; font-weight: lighter;"
            height="45px"
            width="35%"
            :disabled="
              createprogress ||
                statusuploading ||
                stackfileloading ||
                datatemplate.length === 0 || isloadingChecking
            "
            @click="fnLoopUploadFile_v3()"
          >
            {{ $t("direct_upload.uploadfile") }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <div>
      <dialogselectmainfoldertemplate
        :show="openselectmainfoldertemplate"
        :newfolder="datafoldercreate"
        @closenoreload="openselectmainfoldertemplate = false"
        @createfolder="preparingCreateFolder"
        @submitfoldertemplate="addFolderTemplate"
      ></dialogselectmainfoldertemplate>
      <dialogcreatefoldertemplate
        :show="opencreatefoldertemplate"
        @closenoreload="opencreatefoldertemplate = false"
        @createsuccess="preparingNewFolder"
        :parentfolder="foldercreateid"
      ></dialogcreatefoldertemplate>
    </div>
  </v-row>
</template>

<script>
import gbfGenerate from "@/globalFunctions/generateAuthorize";

import { mapState, mapGetters } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { validationMixin } from "vuelidate";
import { required, maxLength, email, helpers } from "vuelidate/lib/validators";
import sizeDataConverter from "@/globalFunctions/sizeDataConverter";
import checkCharacter from "@/globalFunctions/checkCharacter";
import setIconFiles from "@/globalFunctions/setIconFiles";
import format from "date-fns/format";
import formatDatetime from '../../globalFunctions/formatDatetime'
import { v4 as uuidv4 } from "uuid";
import gb_fileFilter from "@/globalFunctions/fileFilter";

const dialogselectmainfoldertemplate = () =>
  import("@/components/optional/dialog-selectmainfoldertemplate.vue");
const dialogcreatefoldertemplate = () =>
  import("@/components/upload/dialog-createfoldertemplate.vue");

const SpecialCharacterForFoldernameValidator = helpers.regex(
  "SpecialCharacterForFoldername",
  checkCharacter.checkSpecialCharacterForFoldername()
);
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  mixins: [validationMixin],
  validations: {
    detailstemplate: {
      aspect_data: {
        $each: {
          value: { SpecialCharacterForFoldernameValidator },
          fixvalue: { required, SpecialCharacterForFoldernameValidator },
        },
      },
    },
    selectedItem: {
      aspect_data_patternfilename_template: {
        $each: {
          value: { SpecialCharacterForFoldernameValidator },
          fixvalue: { required, SpecialCharacterForFoldernameValidator },
        },
      },
    },
    temparraydataupload: {
      $each: {
        name: { required, SpecialCharacterForFoldernameValidator },
      },
    },
  },
  components: {
    dialogselectmainfoldertemplate,
    dialogcreatefoldertemplate,
  },
  props: [
    "show",
    "parentfolder",
    "switchapiupload",
    "remark",
    "oldactivefile",
    "departmentid",
  ],
  watch: {
    selected_reupload: {
      deep: true,
      handler (newVal, oldVal) {
        if (newVal.length < this.temparraydataupload.length) {
          this.selectAll_reupload = false
        } else if (newVal.length === this.temparraydataupload.length) {
          console.log("do firsttimmme ")
          this.selectAll_reupload = true
        }
      },

    },
    slot_uploading: {
      deep: true,
      handler (newVal, oldVal) {
        console.log('newValll ', newVal)
        if (newVal.length > 0) {
          
        }
      }
    },
    length_uploading(val) { 
      console.log('Length upload ', val)
    },
    selectedItem: {
      deep: true,
      handler (newval, oldval) {
        // ทำการเพิ่มค่าที่ได้ใส่ใน Pattern filenmae
        //console.log('newValll ', newval)
        if (newval === null) {
          return
        }
          if (!['', null, undefined].includes(newval.backup_pattern_filename)) {
            if (newval.pattern_filename !== '') {
                console.log('newww Valll ', newval)
                let replace_filename = newval.pattern_filename.replace(/{{(.*?)}}/g, (_, key) => {
                  const match = newval.aspect_data_patternfilename_template.find(
                    (aspect) => {return aspect.aspect_name === key}
                  );
                  console.log('matchhh ', match)
                  if (match.aspect_null === 'Y') {
                    return match.aspect_type === 'DROPDOWN' ? `${match?.value || `[${match.aspect_label}]`}` : `${match?.fixvalue || match?.value || `[${match.aspect_label}]`}`;
                  } else {
                    return `${match?.value || `[${match.aspect_label}]`}`;
                  }
                  //return `${match?.fixvalue || match?.value || `[${match.aspect_label}]`}.${newval.typefile}`;
              })
              newval.name = `${replace_filename}.${newval.typefile}`
            }
           
          } else {
            //console.log('ทดสอบบบบบการใชเงานนนน current 222', this.currenttemplate.structurefile_by_patternname)

          }
          //console.log('neww vall ', newval, this.currenttemplate.structure_change_file_name)

      }
    }
  },
  data: function() {
    return {
      clickFetchDB: false,
      isloadingFetchOCR: false,
      backup_detail_aspect: [],
      fetch_db_itemFile: [],
      check_errormessage: [],
      selectedItem: null,
      selectAll_reupload: false,
      selected_reupload: [],
      disableManageAI: false,
      manageAI: false,
      check_manageAI: false,
      type_upload_reload: "major",
      slot_uploading_state: [],
      slot_preparefile_for_upload: [],
      slot_first_chunckUpload: [],
      slot_uploading: [],
      bucketFiles_after_checking: [],
      queueFileUploading: [],
      queuePreparingFiles: [],
      isloadingChecking: false,
      alertSomeFolder: false,
      openselectmainfoldertemplate: false,
      opencreatefoldertemplate: false,
      createprogress: false,
      selectingimportFiles: false,
      fileImport: null,
      percentfileuploading: 0,
      arraydataupload: [],
      statusuploading: false,
      reloadId: "",
      countupload: 0,
      checkstatusduplicate: false,
      openalertduplicatefile: false,
      checkstatusupload: false,
      totalstackfile: 0,
      temparraydataupload: [],
      stackfileloading: false,
      userdata: {},
      overdragfile: false,
      uniqueidfile: 0,
      loadingdatatemplate: true,
      datatemplate: [],
      detailstemplate: {},
      selectdatatemplate: {},
      checkdetailmobile: false,
      foldercreateid: "",
      datafoldercreate: "",
      mainfolderselect: "",
      checktemplatefolder: false,
      datafoldertemplate: {},
      listbizsymbolsmartupload: ["7222712565067", "0105496000831"],
      checkbizsymbolsmartupload: false,
      listaspectsymbol: [],
      currenttemplate: {},
    };
  },
  computed: {
    ...mapState(["username", "authorize", "account_active", "color"]),
    ...mapState({ processloader: "loading" }),
    ...mapGetters([
      "dataUsername",
      "dataAuthorize",
      "dataAccountActive",
      "dataAccesstoken",
      "dataBusinessProfile",
      "dataCitizenProfile",
      "dataDepartmentAccessId",
      "dataAccountId",
      "dataCheckPackage",
    ]),
    // cssVars() {
    //   return {
    //     '--bg-color': this.color.BG,
    //     '--theme-color': this.color.theme
    //   }
    // },
    checkSelectedItem () {
      return !['null', null, ''].includes(this.currenttemplate.structure_change_file_name) || this.detailstemplate.aspect_data.some((itemSome) => itemSome.aspect_condition === 'Y')
    }, 
    // ทำการเช็คว่า value ทีเราใส่มา
    checkOCRorFetchDB () {
      return !this.selectedItem ? false : 
      this.detailstemplate.aspect_data.every((items) => items.aspect_condition_type === 'filled') ? 
      // ถ้าเป็น Template ที่มีการใช้งานดึงค่าข้อมูลจากฐานข้อมูล
      this.selectedItem.aspect_data_patternfilename_template.filter((item) => item.aspect_condition !== 'Y')
      .map((valueFilter) => { return valueFilter.aspect_null === 'Y' ? [valueFilter.aspect_label, valueFilter.fixvalue] : [valueFilter.aspect_label, valueFilter.value] })
      .map((valueCheck) => { return  !['', null, undefined].includes(valueCheck[1]) ? true : false })
      // .every((checkValue) => checkValue === true) ? false : true
      :
      // ต้องเป็น Template ที่มีการใช้งาน ocr จากเอกสาร
      false
    },
    // ทำการเช็คว่า check_errormessage มีค่าหรือไม่ ถ้ามี
    checkDisabledFetchData () {
      
    //   console.log('checkkvakuueee ', 
    // )

    return !this.selectedItem ? true : this.selectedItem.aspect_data_patternfilename_template
      .filter((itemFilter) => itemFilter.aspect_condition_type === 'filled' && itemFilter.aspect_condition === 'Y')
      .map((valueFilter) => { return valueFilter.aspect_null === 'Y' ? [valueFilter.aspect_label, valueFilter.fixvalue] : [valueFilter.aspect_label, valueFilter.value] })
      .map((valueCheck) => { return  !['', null, undefined].includes(valueCheck[1]) ? true : false })
      .every((checkValue) => checkValue === true) ? false : true

      // return this.selectedItem ? 
      // this.selectedItem.aspect_data_patternfilename_template
      // .filter((itemFilter) => itemFilter.aspect_condition_type === 'filled' && itemFilter.aspect_condition === 'Y')
      // .map((valueFilter) => )
      // .every((checkValue) => !['', null].includes(checkValue.fixvalue)) : true
    },
    error_message () {
      let errors = [];
      if (this.check_errormessage.length >= 1) {
        errors.push("แหม่มมม error เห็ยม่ายย");
        console.log('error message 1')
      } else {
        errors = []
        console.log('error message 2')

      }
      return errors

    },
    filenameWithoutExtension: {
      get() {
        if (!this.selectedItem?.name) return '';
        return this.selectedItem.name.replace(/\.[^/.]+$/, ''); // ลบนามสกุล .xxx ออก
      },
      set(val) {
        const ext = this.selectedItem.name?.split('.').pop(); // หานามสกุลเก่า
        if (ext) {
          this.selectedItem.name = `${val}.${ext}`;
        } else {
          this.selectedItem.name = val;
        }
      }
    },
    aspectDataRequired() {
      if (this.loadingdatatemplate === false) {
        for (let i = 0; i < this.detailstemplate.aspect_data.length; i++) {
          if (this.detailstemplate.aspect_data[i].aspect_null === "Y") {
            if (!this.$v.detailstemplate.aspect_data.$each[i].fixvalue.$dirty) {
              this.detailstemplate.aspect_data[i].erroraspectmessages = "";
            } else if (
              this.detailstemplate.aspect_data[i].fixvalue === "" ||
              this.detailstemplate.aspect_data[i].fixvalue === null ||
              this.detailstemplate.aspect_data[i].fixvalue === undefined
            ) {
              this.detailstemplate.aspect_data[i].erroraspectmessages = this.$t(
                "smartinput.emptyaspectnull"
              );
            } else if (
              this.$v.detailstemplate.aspect_data.$each[i].fixvalue.$error
            ) {
              this.detailstemplate.aspect_data[i].erroraspectmessages = this.$t(
                "smartinput.special_aspect_error"
              );
            } else {
              this.detailstemplate.aspect_data[i].erroraspectmessages = "";
            }
          } else {
            if (!this.$v.detailstemplate.aspect_data.$each[i].value.$dirty) {
              this.detailstemplate.aspect_data[i].erroraspectmessages = "";
            } else if (
              this.$v.detailstemplate.aspect_data.$each[i].value.$error
            ) {
              this.detailstemplate.aspect_data[i].erroraspectmessages = this.$t(
                "smartinput.special_aspect_error"
              );
            } else {
              this.detailstemplate.aspect_data[i].erroraspectmessages = "";
            }
          }
        }
      }
    },
    aspectDataPatternRequired () {
      if (this.loadingdatatemplate === false && ![null, undefined].includes(this.selectedItem)) {
        for (let i = 0; i < this.selectedItem.aspect_data_patternfilename_template.length; i++) {
          if (this.selectedItem.aspect_data_patternfilename_template[i].aspect_null === "Y") {
            if (!this.$v.selectedItem.aspect_data_patternfilename_template.$each[i].fixvalue.$dirty) {
              this.selectedItem.aspect_data_patternfilename_template[i].erroraspectmessages = "";
            } else if (
              this.selectedItem.aspect_data_patternfilename_template[i].fixvalue === "" ||
              this.selectedItem.aspect_data_patternfilename_template[i].fixvalue === null ||
              this.selectedItem.aspect_data_patternfilename_template[i].fixvalue === undefined
            ) {
              this.selectedItem.aspect_data_patternfilename_template[i].erroraspectmessages = this.$t(
                "smartinput.emptyaspectnull"
              );
            } else if (
              this.$v.selectedItem.aspect_data_patternfilename_template.$each[i].fixvalue.$error
            ) {
              this.selectedItem.aspect_data_patternfilename_template[i].erroraspectmessages = this.$t(
                "smartinput.special_aspect_error"
              );
            } else {
              this.selectedItem.aspect_data_patternfilename_template[i].erroraspectmessages = "";
            }
          } else {
            console.log("aspectData Requiredd ", this.$v.selectedItem.aspect_data_patternfilename_template)
            if (!this.$v.selectedItem.aspect_data_patternfilename_template.$each[i].value.$dirty) {
              this.selectedItem.aspect_data_patternfilename_template[i].erroraspectmessages = "";
            } else if (
              this.$v.selectedItem.aspect_data_patternfilename_template.$each[i].value.$invalid
            ) {
              this.selectedItem.aspect_data_patternfilename_template[i].erroraspectmessages = this.$t(
                "smartinput.special_aspect_error"
              );
            } else {
              this.selectedItem.aspect_data_patternfilename_template[i].erroraspectmessages = "";
            }
          }
        }
      }
    },
    filenameRequired() {
      if (this.loadingdatatemplate === false) {
        for (let i = 0; i < this.temparraydataupload.length; i++) {
          if (this.temparraydataupload[i].checkfailformat === true) {
            console.log(
              "this.$v.temparraydataupload.$each[i]",
              this.$v.temparraydataupload.$each[i]
            );
            if (!this.$v.temparraydataupload.$each[i].name.$dirty) {
              this.temparraydataupload[i].errorfailformat = "";
            } else if (
              this.temparraydataupload[i].name === "" ||
              this.temparraydataupload[i].name === null ||
              this.temparraydataupload[i].name === undefined
            ) {
              this.temparraydataupload[i].errorfailformat = this.$t(
                "smartinput.emptyaspectnull"
              );
            } else if (this.$v.temparraydataupload.$each[i].name.$error) {
              this.temparraydataupload[i].errorfailformat = this.$t(
                "smartinput.special_aspect_error"
              );
            } else {
              this.temparraydataupload[i].errorfailformat = "";
            }
          }
        }
      }
    },
    shower: {
      get() {
        if (this.show === true) {
          this.addEventUploadfiles();
          this.getDataTemplate();
          this.$emit("closeDrag");
        } else {
          this.checkstatusupload = false;
          this.cleardata();
          this.removeEventUploadfiles();
        }
        console.log("this.show", this.show);
        return this.show;
      },
      set(value) {
        if (!value) {
          this.removeEventUploadfiles();
          this.$emit("openDrag");
          this.$emit("close");
        }
      },
    },
    structure_data() {
      try {
        // !this.listbizsymbolsmartupload.includes(this.dataAccountActive.business_info.taxid)
        if (this.detailstemplate) {
          console.log("this.detailstemplate", this.detailstemplate);
          console.log(
            "this.detailstemplate.structure_data.split",
            this.detailstemplate.structure_data.split("/")
          );
          let listsplitstructrue = !this.detailstemplate.structure_data
            ? ""
            : this.detailstemplate.structure_data.split("/");
          let structrue = "";
          for (let index = 0; index < listsplitstructrue.length; index++) {
              let texttest = "";
              for (
                let indexid = 0;
                indexid < this.detailstemplate.aspect_data.length;
                indexid++
              ) {
                let texttestsplit;
                let checkyear;
                let checkmonth;
                let checkday;
                console.log("this.detailstemplate.aspect_data[indexid].aspect_type", this.detailstemplate.aspect_data[indexid].aspect_type);
                if (this.detailstemplate.aspect_data[indexid].aspect_type === "DATE") {
                  checkyear = listsplitstructrue[index].split(
                    "{{" +
                      this.detailstemplate.aspect_data[indexid].aspect_name +
                      ".year" +
                      "}}"
                  );
                  checkmonth = listsplitstructrue[index].split(
                    "{{" +
                      this.detailstemplate.aspect_data[indexid].aspect_name +
                      ".month" +
                      "}}"
                  );
                  checkday = listsplitstructrue[index].split(
                    "{{" +
                      this.detailstemplate.aspect_data[indexid].aspect_name +
                      ".day" +
                      "}}"
                  );
                  console.log("checkyear", checkyear);
                  console.log("checkmonthr", checkmonth);
                  console.log("checkday", checkday);
                  if (checkyear.length > 1) {
                    texttestsplit = checkyear;
                  } else if (checkmonth.length > 1) {
                    texttestsplit = checkmonth;
                  } else if (checkday.length > 1) {
                    texttestsplit = checkday;
                  } else {
                    texttestsplit = listsplitstructrue[index].split(
                      "{{" +
                        this.detailstemplate.aspect_data[indexid].aspect_name +
                        "}}"
                    );
                  }
                } else {
                  texttestsplit = listsplitstructrue[index].split(
                    "{{" +
                      this.detailstemplate.aspect_data[indexid].aspect_name +
                      "}}"
                  );
                }
                console.log(
                  "this.detailstemplate.aspect_data",
                  this.detailstemplate.aspect_data[indexid]
                );
                console.log("texttestsplit startt", texttestsplit);
                if (texttestsplit.length > 1) {
                  if (
                    this.detailstemplate.aspect_data[indexid].aspect_null ===
                    "Y"
                  ) {
                    if (
                      this.detailstemplate.aspect_data[indexid].fixvalue === ""
                    ) {
                      console.log("this.detailstemplate.aspect_data[indexid].aspect_type fixxx", this.detailstemplate.aspect_data[indexid].aspect_type);
                      if (this.detailstemplate.aspect_data[indexid].aspect_type === "DATE") {
                        if (texttest === "") {
                          texttest = listsplitstructrue[index].replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + "}}", this.detailstemplate.aspect_data[indexid].aspect_label)
                          texttest = texttest.replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".year" + "}}", this.detailstemplate.aspect_data[indexid].aspect_label)
                          texttest = texttest.replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".month" + "}}", this.detailstemplate.aspect_data[indexid].aspect_label)
                          texttest = texttest.replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".day" + "}}", this.detailstemplate.aspect_data[indexid].aspect_label)
                        } else {
                          texttest = texttest.replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + "}}", this.detailstemplate.aspect_data[indexid].aspect_label)
                          texttest = texttest.replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".year" + "}}", this.detailstemplate.aspect_data[indexid].aspect_label)
                          texttest = texttest.replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".month" + "}}", this.detailstemplate.aspect_data[indexid].aspect_label)
                          texttest = texttest.replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".day" + "}}", this.detailstemplate.aspect_data[indexid].aspect_label)
                        }
                      } else {
                        texttest === ""
                          ? (texttest = listsplitstructrue[index].replace(
                              "{{" +
                                this.detailstemplate.aspect_data[indexid]
                                  .aspect_name +
                                "}}",
                              this.detailstemplate.aspect_data[indexid]
                                .aspect_label
                            ))
                          : (texttest = texttest.replace(
                              "{{" +
                                this.detailstemplate.aspect_data[indexid]
                                  .aspect_name +
                                "}}",
                              this.detailstemplate.aspect_data[indexid]
                                .aspect_label
                            ));
                      }
                      console.log("texttest 1", texttest);
                    } else {
                      if (
                        this.detailstemplate.aspect_data[indexid]
                          .aspect_fix_value.length > 0
                      ) {
                        if (this.detailstemplate.aspect_data[indexid].aspect_type === "DATE") {
                          if (texttest === "") {
                            texttest = listsplitstructrue[index].replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + "}}", this.changeDateFormat(this.detailstemplate.aspect_data[indexid]))
                            texttest = texttest.replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".year" + "}}", this.setDateselect("year",this.detailstemplate.aspect_data[indexid]))
                            texttest = texttest.replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".month" + "}}", this.setDateselect("year",this.detailstemplate.aspect_data[indexid]))
                            texttest = texttest.replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".day" + "}}", this.setDateselect("year",this.detailstemplate.aspect_data[indexid]))
                          } else {
                            texttest = texttest.replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + "}}", this.changeDateFormat(this.detailstemplate.aspect_data[indexid]))
                            texttest = texttest.replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".year" + "}}", this.setDateselect("year",this.detailstemplate.aspect_data[indexid]))
                            texttest = texttest.replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".month" + "}}", this.setDateselect("year",this.detailstemplate.aspect_data[indexid]))
                            texttest = texttest.replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".day" + "}}", this.setDateselect("year",this.detailstemplate.aspect_data[indexid]))
                          }
                        } else {
                          texttest === ""
                            ? (texttest = listsplitstructrue[index].replace(
                                "{{" +
                                  this.detailstemplate.aspect_data[indexid]
                                    .aspect_name +
                                  "}}",
                                this.detailstemplate.aspect_data[indexid].value
                              ))
                            : (texttest = texttest.replace(
                                "{{" +
                                  this.detailstemplate.aspect_data[indexid]
                                    .aspect_name +
                                  "}}",
                                this.detailstemplate.aspect_data[indexid].value
                              ));
                          console.log("texttest 2", texttest);
                        }
                      } else {
                        if (texttest === "") {
                          if (this.detailstemplate.aspect_data[indexid].aspect_type === "DATE") {
                            texttest = listsplitstructrue[index].replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + "}}", this.changeDateFormat(this.detailstemplate.aspect_data[indexid]))
                            texttest = texttest.replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".year" + "}}", this.setDateselect("year",this.detailstemplate.aspect_data[indexid]))
                            texttest = texttest.replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".month" + "}}", this.setDateselect("month",this.detailstemplate.aspect_data[indexid]))
                            texttest = texttest.replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".day" + "}}", this.setDateselect("day",this.detailstemplate.aspect_data[indexid]))
                          } else {
                            console.log("fefef");
                            texttest = listsplitstructrue[index].replace(
                              "{{" +
                                this.detailstemplate.aspect_data[indexid]
                                  .aspect_name +
                                "}}",
                              this.detailstemplate.aspect_data[indexid]
                                .fixvalue
                            )
                          }
                        } else {
                          if (this.detailstemplate.aspect_data[indexid].aspect_type === "DATE") {
                            texttest = texttest.replace(
                              "{{" +
                                this.detailstemplate.aspect_data[indexid]
                                  .aspect_name +
                                "}}",
                              this.changeDateFormat(
                                this.detailstemplate.aspect_data[indexid]
                              )
                            ),
                            texttest = texttest.replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".year" + "}}", this.setDateselect("year",this.detailstemplate.aspect_data[indexid]))
                            texttest = texttest.replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".month" + "}}", this.setDateselect("month",this.detailstemplate.aspect_data[indexid]))
                            texttest = texttest.replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".day" + "}}", this.setDateselect("day",this.detailstemplate.aspect_data[indexid]))
                          } else {
                            console.log("fefef");
                            texttest = texttest.replace(
                              "{{" +
                                this.detailstemplate.aspect_data[indexid]
                                  .aspect_name +
                                "}}",
                              this.detailstemplate.aspect_data[indexid].fixvalue
                            )
                          }
                        }
                        // texttest === ""
                        //   ? this.detailstemplate.aspect_data[indexid]
                        //       .aspect_type === "DATE"
                        //     ? (
                        //       texttest = listsplitstructrue[index].replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + "}}", this.changeDateFormat(this.detailstemplate.aspect_data[indexid])),
                        //       texttest = listsplitstructrue[index].replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".year" + "}}", this.setDateselect("year",this.detailstemplate.aspect_data[indexid])),
                        //       texttest = listsplitstructrue[index].replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".month" + "}}", this.setDateselect("month",this.detailstemplate.aspect_data[indexid])),
                        //       texttest = listsplitstructrue[index].replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".day" + "}}", this.setDateselect("day",this.detailstemplate.aspect_data[indexid]))
                        //       )
                        //     : (texttest = listsplitstructrue[index].replace(
                        //         "{{" +
                        //           this.detailstemplate.aspect_data[indexid]
                        //             .aspect_name +
                        //           "}}",
                        //         this.detailstemplate.aspect_data[indexid]
                        //           .fixvalue
                        //       ))
                        //   : this.detailstemplate.aspect_data[indexid]
                        //       .aspect_type === "DATE"
                        //   ? (texttest = texttest.replace(
                        //       "{{" +
                        //         this.detailstemplate.aspect_data[indexid]
                        //           .aspect_name +
                        //         "}}",
                        //       this.changeDateFormat(
                        //         this.detailstemplate.aspect_data[indexid]
                        //       )
                        //     ),
                        //       texttest = listsplitstructrue[index].replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".year" + "}}", this.setDateselect("year",this.detailstemplate.aspect_data[indexid])),
                        //       texttest = listsplitstructrue[index].replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".month" + "}}", this.setDateselect("month",this.detailstemplate.aspect_data[indexid])),
                        //       texttest = listsplitstructrue[index].replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".day" + "}}", this.setDateselect("day",this.detailstemplate.aspect_data[indexid]))
                        //     )
                        //   : (texttest = texttest.replace(
                        //       "{{" +
                        //         this.detailstemplate.aspect_data[indexid]
                        //           .aspect_name +
                        //         "}}",
                        //       this.detailstemplate.aspect_data[indexid].fixvalue
                        //     ));
                        console.log("texttest 3", texttest);
                        // structrue =
                        //   structrue +
                        //   "/" +
                        //   (this.detailstemplate.aspect_data[indexid].aspect_type ===
                        //   "DATE"
                        //     ? this.changeDateFormat(
                        //         this.detailstemplate.aspect_data[indexid]
                        //       )
                        //     : this.detailstemplate.aspect_data[indexid].fixvalue);
                      }
                    }
                  } else {
                    if (
                      this.detailstemplate.aspect_data[indexid].value !== ""
                    ) {
                      if (
                        this.detailstemplate.aspect_data[indexid]
                          .aspect_fix_value.length > 0
                          // .aspect_fix_value !== "{}"
                      ) {
                        if (
                          this.detailstemplate.aspect_data[indexid].value !==
                          "notselecttemplate"
                        ) {
                          texttest === ""
                            ? (texttest = listsplitstructrue[index].replace(
                                "{{" +
                                  this.detailstemplate.aspect_data[indexid]
                                    .aspect_name +
                                  "}}",
                                this.detailstemplate.aspect_data[indexid].value
                              ))
                            : (texttest = texttest.replace(
                                "{{" +
                                  this.detailstemplate.aspect_data[indexid]
                                    .aspect_name +
                                  "}}",
                                this.detailstemplate.aspect_data[indexid].value
                              ));
                          console.log("texttest 4", texttest);
                          // structrue =
                          //   structrue +
                          //   "/" +
                          //   this.detailstemplate.aspect_data[indexid].value;
                        } else {
                          texttest === ""
                            ? (texttest = listsplitstructrue[index].replace(
                                "{{" +
                                  this.detailstemplate.aspect_data[indexid]
                                    .aspect_name +
                                  "}}",
                                "ไม่ระบุ"
                              ))
                            : (texttest = texttest.replace(
                                "{{" +
                                  this.detailstemplate.aspect_data[indexid]
                                    .aspect_name +
                                  "}}",
                                "ไม่ระบุ"
                              ));
                        }
                      } else {
                        if (texttest === "") {
                          if (this.detailstemplate.aspect_data[indexid].aspect_type === "DATE") {
                            console.log("maaaa3",  this.setDateselect("year",this.detailstemplate.aspect_data[indexid]));
                            texttest = listsplitstructrue[index].replace(
                              "{{" +
                                this.detailstemplate.aspect_data[indexid]
                                  .aspect_name +
                                "}}",
                              this.changeDateFormat(
                                this.detailstemplate.aspect_data[indexid]
                              )
                            ),
                            texttest = listsplitstructrue[index].replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".year" + "}}", this.setDateselect("year",this.detailstemplate.aspect_data[indexid])),
                            texttest = listsplitstructrue[index].replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".month" + "}}", this.setDateselect("month",this.detailstemplate.aspect_data[indexid])),
                            texttest = listsplitstructrue[index].replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".day" + "}}", this.setDateselect("day",this.detailstemplate.aspect_data[indexid]))
                          } else {
                            texttest = listsplitstructrue[index].replace(
                              "{{" +
                                this.detailstemplate.aspect_data[indexid]
                                  .aspect_name +
                                "}}",
                              this.detailstemplate.aspect_data[indexid].value
                            )
                          }
                        } else {
                          if (this.detailstemplate.aspect_data[indexid].aspect_type === "DATE") {
                            console.log("maaaa4",  this.setDateselect("year",this.detailstemplate.aspect_data[indexid]));
                            texttest = texttest.replace(
                            "{{" +
                              this.detailstemplate.aspect_data[indexid]
                                .aspect_name +
                              "}}",
                            this.changeDateFormat(
                              this.detailstemplate.aspect_data[indexid]
                            )
                          ),texttest = texttest.replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".year" + "}}", this.setDateselect("year",this.detailstemplate.aspect_data[indexid])),
                            texttest = texttest.replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".month" + "}}", this.setDateselect("month",this.detailstemplate.aspect_data[indexid])),
                            texttest = texttest.replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".day" + "}}", this.setDateselect("day",this.detailstemplate.aspect_data[indexid]))
                          } else {
                            texttest = texttest.replace(
                              "{{" +
                                this.detailstemplate.aspect_data[indexid]
                                  .aspect_name +
                                "}}",
                              this.detailstemplate.aspect_data[indexid].value
                            )
                          }
                        }
                        // texttest === ""
                        //   ? this.detailstemplate.aspect_data[indexid]
                        //       .aspect_type === "DATE"
                        //     ? (texttest = listsplitstructrue[index].replace(
                        //         "{{" +
                        //           this.detailstemplate.aspect_data[indexid]
                        //             .aspect_name +
                        //           "}}",
                        //         this.changeDateFormat(
                        //           this.detailstemplate.aspect_data[indexid]
                        //         )
                        //       ),
                        //       texttest = listsplitstructrue[index].replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".year" + "}}", this.setDateselect("year",this.detailstemplate.aspect_data[indexid])),
                        //       texttest = listsplitstructrue[index].replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".month" + "}}", this.setDateselect("month",this.detailstemplate.aspect_data[indexid])),
                        //       texttest = listsplitstructrue[index].replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".day" + "}}", this.setDateselect("day",this.detailstemplate.aspect_data[indexid]))
                        //       )
                        //     : (texttest = listsplitstructrue[index].replace(
                        //         "{{" +
                        //           this.detailstemplate.aspect_data[indexid]
                        //             .aspect_name +
                        //           "}}",
                        //         this.detailstemplate.aspect_data[indexid].value
                        //       ))
                        //   : this.detailstemplate.aspect_data[indexid]
                        //       .aspect_type === "DATE"
                        //   ? (texttest = texttest.replace(
                        //       "{{" +
                        //         this.detailstemplate.aspect_data[indexid]
                        //           .aspect_name +
                        //         "}}",
                        //       this.changeDateFormat(
                        //         this.detailstemplate.aspect_data[indexid]
                        //       )
                        //     ),texttest = listsplitstructrue[index].replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".year" + "}}", this.setDateselect("year",this.detailstemplate.aspect_data[indexid])),
                        //       texttest = listsplitstructrue[index].replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".month" + "}}", this.setDateselect("month",this.detailstemplate.aspect_data[indexid])),
                        //       texttest = listsplitstructrue[index].replace("{{" + this.detailstemplate.aspect_data[indexid].aspect_name + ".day" + "}}", this.setDateselect("day",this.detailstemplate.aspect_data[indexid]))
                        //     )
                        //   : (texttest = texttest.replace(
                        //       "{{" +
                        //         this.detailstemplate.aspect_data[indexid]
                        //           .aspect_name +
                        //         "}}",
                        //       this.detailstemplate.aspect_data[indexid].value
                        //     ));
                        console.log("texttest 5", texttest);
                        // structrue =
                        //   structrue +
                        //   "/" +
                        //   (this.detailstemplate.aspect_data[indexid].aspect_type ===
                        //   "DATE"
                        //     ? this.changeDateFormat(
                        //         this.detailstemplate.aspect_data[indexid]
                        //       )
                        //     : this.detailstemplate.aspect_data[indexid].value);
                      }
                    } else {
                      texttest === ""
                        ? (texttest = listsplitstructrue[index].replace(
                            "{{" +
                              this.detailstemplate.aspect_data[indexid]
                                .aspect_name +
                              "}}",
                            "ไม่ระบุ"
                          ))
                        : (texttest = texttest.replace(
                            "{{" +
                              this.detailstemplate.aspect_data[indexid]
                                .aspect_name +
                              "}}",
                            "ไม่ระบุ"
                          ));
                    }
                  }
                }
                console.log("texttest", texttest);
                if (indexid + 1 === this.detailstemplate.aspect_data.length) {
                  if (texttest === "") {
                    if (structrue === "") {
                      structrue += listsplitstructrue[index];
                    } else {
                      structrue += "/" + listsplitstructrue[index];
                    }
                  } else {
                    if (structrue === "") {
                      structrue += texttest;
                    } else {
                      structrue += "/" + texttest;
                    }
                  }
                }
              }
              // }
            // }
            // }
            // structrue += listsplitstructrue[index];
            // countduptemplatename -= 1;
            // if (countduptemplatename === 0) {
            //   break;
            // } else {
            //   structrue += "/";
            // }
          }
          console.log("structrue", structrue);
          if (this.listaspectsymbol.length > 0) {
            return structrue + "/XXXXXXXXXX";
          } else {
            return structrue;
          }
          // return this.detailstemplate.structure_data;
          // let listsplitstructrue = !this.detailstemplate.structure_data
          //   ? ""
          //   : this.detailstemplate.structure_data.split("/");
          // let structrue = "";
          // let countduptemplatename = listsplitstructrue.filter(
          //   (item) => item === this.detailstemplate.template_name
          // ).length;
          // for (let index = 0; index < listsplitstructrue.length; index++) {
          //   if (
          //     listsplitstructrue[index] === this.detailstemplate.template_name
          //   ) {
          //     structrue += listsplitstructrue[index];
          //     countduptemplatename -= 1;
          //     if (countduptemplatename === 0) {
          //       break;
          //     } else {
          //       structrue += "/";
          //     }
          //   }
          // }
          // for (let i = 0; i < listsplitstructrue.length; i++) {
          //   if (this.detailstemplate.aspect_data[i]) {
          //     if (this.detailstemplate.aspect_data[i].aspect_null === "Y") {
          //       if (this.detailstemplate.aspect_data[i].fixvalue === "") {
          //         structrue =
          //           structrue +
          //           "/" +
          //           this.detailstemplate.aspect_data[i].aspect_label;
          //       } else {
          //         if (
          //           this.detailstemplate.aspect_data[i].aspect_fix_value
          //             .length > 0
          //         ) {
          //           structrue =
          //             structrue +
          //             "/" +
          //             this.detailstemplate.aspect_data[i].value;
          //         } else {
          //           structrue =
          //             structrue +
          //             "/" +
          //             (this.detailstemplate.aspect_data[i].aspect_type ===
          //             "DATE"
          //               ? this.changeDateFormat(
          //                   this.detailstemplate.aspect_data[i]
          //                 )
          //               : this.detailstemplate.aspect_data[i].fixvalue);
          //         }
          //       }
          //     } else {
          //       if (this.detailstemplate.aspect_data[i].value !== "") {
          //         if (
          //           this.detailstemplate.aspect_data[i].aspect_fix_value
          //             .length > 0
          //         ) {
          //           if (
          //             this.detailstemplate.aspect_data[i].value !==
          //             "notselecttemplate"
          //           ) {
          //             structrue =
          //               structrue +
          //               "/" +
          //               this.detailstemplate.aspect_data[i].value;
          //           }
          //         } else {
          //           structrue =
          //             structrue +
          //             "/" +
          //             (this.detailstemplate.aspect_data[i].aspect_type ===
          //             "DATE"
          //               ? this.changeDateFormat(
          //                   this.detailstemplate.aspect_data[i]
          //                 )
          //               : this.detailstemplate.aspect_data[i].value);
          //         }
          //       }
          //     }
          //   }
          // }
          // if (this.checktemplatefolder === true) {
          //   if (this.datafoldertemplate.path === undefined) {
          //     return structrue;
          //   } else {
          //     return this.datafoldertemplate.path + structrue;
          //   }
          // } else {
          //   return structrue;
          // }
        }
      } catch (err) {
        console.log("Still fine", err);
      }
    },
    structure_symbol_data() {
      if (this.detailstemplate) {
        if (this.checktemplatefolder === true) {
          if (this.datafoldertemplate.path === undefined) {
            // return this.detailstemplate.template_name + "/XXXXXXXXXX";
            return "XXXXXXXXXX";
          } else {
            // return this.datafoldertemplate.path + this.detailstemplate.template_name + "/XXXXXXXXXX";
            return this.datafoldertemplate.path + "XXXXXXXXXX";
          }
        } else {
          // return this.detailstemplate.template_name + "/XXXXXXXXXX";
          return "XXXXXXXXXX";
        }
      }
    },
    structure_data_v2 () {
      let textStructure = this.currenttemplate.structure_data
      let findAspect = this.currenttemplate.structure_data.match(/{{(.*?)}}/g).map(match => match.replace(/[{}]/g, ''));
      console.log('HELLLO Asopect ', findAspect)
      findAspect = findAspect.map((itemMap) => {return {ref: `{{${itemMap}}}`, value: itemMap.replace(/[%$&#]/g, '')}})
      console.log("findAspetc ", findAspect)
      console.log("detaillaspect ", this.detailstemplate.aspect_data);
      this.detailstemplate.aspect_data.forEach((itemEach, index) => {
        if (itemEach.aspect_type === 'TEXT') {
          let findAspect_by_detail = findAspect.find((itemM) => itemM.value === itemEach.aspect_name)
          if (findAspect_by_detail !== undefined) {
            console.log("findd Aspectt dataaa ", findAspect_by_detail)
            textStructure = textStructure.replace(
            findAspect.find(
              (itemM) => itemM.value === itemEach.aspect_name).ref, 
              itemEach.readfilename === 'Y' || itemEach.fixvalue === "" ? itemEach.aspect_label :  itemEach.fixvalue)
          }
        } else if (itemEach.aspect_type === 'DATE') {
          let findAspect_by_detail = findAspect.find((itemM) => itemM.value.split('.')[0] === itemEach.aspect_name)
          if (findAspect_by_detail !== undefined) {
            let filtered_ = findAspect.filter((itemFilter) => itemFilter.value.split('.')[0] === itemEach.aspect_name)
            filtered_.forEach((itemFilter) => {
                textStructure = textStructure.replace(
                  itemFilter.ref, 
                  itemEach.readfilename === 'Y' || itemEach.fixvalue === "" ? itemEach.aspect_label : 
                  itemFilter.value.split('.').length > 1 ? 
                  itemFilter.value.split('.')[1] === 'year' ?
                  format(new Date(this.fn_convertDate(formatDatetime.formatdatetime(itemEach.fixvalue).split(' ')[0])), 'yyyy') :
                  itemFilter.value.split('.')[1] === 'month' ?
                  format(new Date(this.fn_convertDate(formatDatetime.formatdatetime(itemEach.fixvalue).split(' ')[0])), 'MM') :
                  format(new Date(this.fn_convertDate(formatDatetime.formatdatetime(itemEach.fixvalue).split(' ')[0])), 'dd')
                  :
                  itemEach.fixvalue
                )
            })
          }
        } else {
          
          let findAspect_by_detail = findAspect.find((itemM) => itemM.value === itemEach.aspect_name)
          //console.log('find Aspectt detaill ', findAspect_by_detail, itemEach)
          if (findAspect_by_detail !== undefined) {
            textStructure = textStructure.replace(
            findAspect.find(
              (itemM) => itemM.value === itemEach.aspect_name).ref, 
              itemEach.readfilename === 'Y' || itemEach.value === "notselecttemplate" ? itemEach.aspect_label :  this.manageAI ? itemEach.aspect_label : `${itemEach.value} ${this.getFindValueObject(itemEach.value, index) === '' ? '' : `(${this.getFindValueObject(itemEach.value, index)})`}`)
          }
        }
      })
      return textStructure
    },
    structure_data_v3 () {
      if (this.selectedItem?.structurefile_by_patternname) {
        console.log('structuree data ', this.selectedItem, this.selectedItem.structurefile_by_patternname)
        let textStructure = this.selectedItem.structurefile_by_patternname
        const hasVariables = /{{.*?}}/.test(textStructure); // ตรวจว่ามี {{...}} มั้ย
        if (!hasVariables) {
          return textStructure; // ถ้าไม่มีตัวแปร ก็คืนค่า string เดิม
        }
        console.log("check {{}} hasVariables",!hasVariables);
        let findAspect = this.selectedItem.structurefile_by_patternname.match(/{{(.*?)}}/g).map(match => match.replace(/[{}]/g, ''));
        findAspect = findAspect.map((itemMap) => {return {ref: `{{${itemMap}}}`, value: itemMap.replace(/[%$&#]/g, '')}})
        
        this.selectedItem?.aspect_data_patternfilename_template.forEach((itemEach, index) => {
          if (itemEach.aspect_type === 'TEXT') {
            let findAspect_by_detail = findAspect.find((itemM) => itemM.value === itemEach.aspect_name)
            if (findAspect_by_detail !== undefined) {
              textStructure = textStructure.replace(
              findAspect.find(
                (itemM) => itemM.value === itemEach.aspect_name).ref, 
                itemEach.readfilename === 'Y' || itemEach.fixvalue === "" ? itemEach.aspect_label :  itemEach.fixvalue)
            }
          } else if (itemEach.aspect_type === 'DATE') {
            let findAspect_by_detail = findAspect.find((itemM) => itemM.value.split('.')[0] === itemEach.aspect_name)
            if (findAspect_by_detail !== undefined) {
              let filtered_ = findAspect.filter((itemFilter) => itemFilter.value.split('.')[0] === itemEach.aspect_name)
              filtered_.forEach((itemFilter) => {
                  textStructure = textStructure.replace(
                    itemFilter.ref, 
                    itemEach.readfilename === 'Y' || itemEach.fixvalue === "" ? itemEach.aspect_label : 
                    itemFilter.value.split('.').length > 1 ? 
                    itemFilter.value.split('.')[1] === 'year' ?
                    format(new Date(this.fn_convertDate(formatDatetime.formatdatetime(itemEach.fixvalue).split(' ')[0])), 'yyyy') :
                    itemFilter.value.split('.')[1] === 'month' ?
                    format(new Date(this.fn_convertDate(formatDatetime.formatdatetime(itemEach.fixvalue).split(' ')[0])), 'MM') :
                    format(new Date(this.fn_convertDate(formatDatetime.formatdatetime(itemEach.fixvalue).split(' ')[0])), 'dd')
                    :
                    itemEach.fixvalue
                  )
              })
            }
          } else {
            
            let findAspect_by_detail = findAspect.find((itemM) => itemM.value === itemEach.aspect_name)
            //console.log('find Aspectt detaill ', findAspect_by_detail, itemEach)
            if (findAspect_by_detail !== undefined) {
              textStructure = textStructure.replace(
              findAspect.find(
                (itemM) => itemM.value === itemEach.aspect_name).ref, 
                itemEach.readfilename === 'Y' || itemEach.value === "notselecttemplate" ? itemEach.aspect_label :  this.manageAI ? itemEach.aspect_label : `${itemEach.value} ${this.getFindValueObject(itemEach.value, index) === '' ? '' : `(${this.getFindValueObject(itemEach.value, index)})`}`)
            }
          }
        })
        return textStructure
      } else {
        console.log('structyree ', this.selectedItem)
        return null
      }
      
    },
    length_processing() {
      return (
        this.temparraydataupload.filter((item) => {
          return (
            item.status === "fail" ||
            item.status === "success" ||
            item.status === "duplicate" ||
            item.status === "skip" ||
            item.status === "cancel"
          );
        }).length ||
        this.arraydataupload.filter((item) => {
          return (
            item.status === "fail" ||
            item.status === "success" ||
            item.status === "duplicate" ||
            item.status === "skip" ||
            item.status === "cancel"
          );
        }).length ||
        0
      );
    },

    length_processing_v2() {
      return (
        this.temparraydataupload.filter((item) => {
          return (
            item.status === "fail" ||
            item.status === "success" ||
            item.status === "duplicate" ||
            item.status === "skip" ||
            item.status === "cancel"
          );
        }).length);
    },
    length_fail() {
      return (
        this.temparraydataupload.filter((item) => {
          return (
            item.status === "fail" ||
            item.status === "skip" ||
            item.status === "cancel"
          );
        }).length ||
        this.arraydataupload.filter((item) => {
          return (
            item.status === "fail" ||
            item.status === "skip" ||
            item.status === "cancel"
          );
        }).length ||
        0
      );
    },
    length_success() {
      return (
        this.temparraydataupload.filter((item) => {
          return item.status === "success";
        }).length ||
        this.arraydataupload.filter((item) => {
          return item.status === "success";
        }).length ||
        0
      );
    },
    length_duplicate() {
      return (
        this.temparraydataupload.filter((item) => {
          return item.status === "duplicate";
        }).length ||
        this.arraydataupload.filter((item) => {
          return item.status === "duplicate";
        }).length ||
        0
      );
    },
    length_uploading() {
      return (
        this.temparraydataupload.filter((item) => {
          return item.status === "start";
        }).length  
        // ||
        // this.arraydataupload.filter((item) => {
        //   return item.status === "start";
        // }).length ||
        // 0
      );
    },
    resolutionScreen() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 220;
        case "sm":
          return 400;
        case "md":
          return 500;
        case "lg":
          return 600;
        case "xl":
          return 800;
      }
    },
    headerPage() {
      return (
        "color:" +
        this.color.theme +
        ";" +
        "font-size: 16px; font-weight: 600; font-weight: bold; letter-spacing: 0px;"
      );
    },
    //style อักษรของ text ใหญ่ ใน upload layout ของ mobile
    titleTextUploadTitle() {
      if (this.resolutionScreen >= 500) {
        return "color:black; font-size: 18px; line-height: 24px;";
      } else {
        return "color:black; font-size: 14px; line-height: 24px;";
      }
    },
    //style อักษรของ text เล็ก ใน upload layout ของ mobile
    titleTextUploadSubtitle() {
      if (this.resolutionScreen >= 500) {
        return "color:red; font-size: 16px; line-height: 24px;";
      } else {
        return "color:red; font-size: 12px; line-height: 24px;";
      }
    },
    //style upload layout ของ mobile
    uploadLayoutMobile() {
      if (this.overdragfile === false) { 
      // return "background: #F0F6FB; border: 4px dashed #71B5D8; border-radius: 24px;";
      return (
        "background: " +
        this.color.BG +
        "; border: 4px dashed " +
        this.color.theme +
        "; border-radius: 24px; cursor: pointer;"
      );
      } else {
        // return (
        //   "background: red;" +
        //   "; border: 4px dashed " +
        //   this.color.theme +
        //   "; border-radius: 24px; cursor: pointer;"
        // );
        return (
          "border: 4px dashed " +
          this.color.theme +
          "; border-radius: 24px;" +
          "font: bold 42px Sarabun, system-ui, Tahoma, sans-serif; background: #aeb3b5; transition: background 200ms, opacity 200ms, height 175ms, width 175ms, border 300ms;"
        );
      }
    },
    uploadLayout() {
      if (this.createprogress === true) {
        return "border-radius: 24px; cursor: not-allowed;";
      } else {
        return "border-radius: 24px; cursor: pointer;";
      }
    },
    // ความกว้างของ dialog ของ ipad และ mobile
    maxWidthOnMobile() {
      if (this.resolutionScreen >= 400) {
        return 600;
      } else {
        return 346;
      }
    },
    maxHeightOnMobile() {
      if (this.statusuploading === false) {
        return "700px";
      } else {
        return "400px";
      }
    },
    layouthoveruploadfiles() {
      if (this.overdragfile === false) {
        return "background: none; border-radius: 25px; transition: background 150ms, opacity 150ms, height 175ms, width 175ms, border 300ms; opacity: 1; position: realtive;";
      } else {
        return "background: #aeb3b5; border-radius: 25px; transition: background 350ms, opacity 350ms, height 175ms, width 175ms, border 300ms; opacity: 0.4; position: realtive;";
      }
    },
    dropzoneuploadfiles() {
      if (this.overdragfile === false) {
        return (
          "border: 4px dashed " +
          this.color.theme +
          "; font: bold 30px Sarabun, system-ui, Tahoma, sans-serif; background: " +
          this.color.BG +
          "; transition: background 200ms, opacity 200ms, height 175ms, width 175ms, border 300ms;"
        );
      } else {
        return (
          "border: 4px dashed " +
          this.color.theme +
          "; font: bold 42px Sarabun, system-ui, Tahoma, sans-serif; background: #aeb3b5; transition: background 200ms, opacity 200ms, height 175ms, width 175ms, border 300ms;"
        );
      }
    },
  },
  // filters: {
  //   subStr: function(string) {
  //     if (string == null || string == "" || string == undefined) {
  //       return string;
  //     } else {
  //       if (string.length > 15) return string.substring(0, 15) + "...";
  //       else return string;
  //     }
  //   },
  // },
  methods: {
    fn_selectAllItems () {
      if (this.selectAll_reupload === false) {
        this.selected_reupload = []
      } else {
        this.selected_reupload = [...this.temparraydataupload.filter((items) => ['warning', 'fail', 'cancel'].includes(items.status))]
      }
      console.log('selectAll reuploadd ', this.selectAll_reupload)
      
    },
   async fn_reupload_smartupload () {
      let reload_item = [...this.selected_reupload]
      // ต้องทำการเรียง ให้เหมือนกับ temparray
      // สร้างแผนที่ลำดับจาก B
      let orderMap = new Map(this.temparraydataupload.map((item, index) => [item.id, index]));

      // เรียง A ตามลำดับใน B
      reload_item.sort((a, b) => orderMap.get(a.id) - orderMap.get(b.id));
      console.log('sorted ', this.temparraydataupload, reload_item)
      // 
      let first_time = false
      for (let i = 0; i < reload_item.length; i++) {
        try{
          console.log('reloadd_itemmm ', reload_item[i])
          let index_reload = this.temparraydataupload.findIndex(
          (item) => item.id === reload_item[i].id
          ); 
          console.log("index_reloaddd ", index_reload)
          // check chunck file
        if (this.temparraydataupload[index_reload].status_chunk) {
          this.temparraydataupload[index_reload].status = "start";
          this.temparraydataupload[index_reload].msg = "";
          this.temparraydataupload[index_reload].colorupload = "primary";
          this.temparraydataupload[index_reload].value = 0;
          this.temparraydataupload[index_reload].checkfailformat = false
          await this.fnCheckStorage()
          if (this.userdata.remain_storage < this.temparraydataupload[index_reload].size) {
              this.statusstorage = true;
              this.temparraydataupload[index_reload].status = "fail";
              this.temparraydataupload[index_reload].msg = this.$t(
                "dragdrop.yourspacenotenough"
              );
              this.temparraydataupload[index_reload].colorupload = "error";
              this.createprogress = false;
              return
          }
          await this.checkDuplicateMajorMinor(this.temparraydataupload[i], this.currenttemplate.id, i)
          .then(async (response) => {
            if (response.status === 'fail') {
              this.temparraydataupload[index_reload].status = 'duplicate'
              this.temparraydataupload[index_reload].msg = this.$t('smartinput.duplicate_upload')
              this.temparraydataupload[index_reload].colorupload = 'warning'
              this.temparraydataupload[index_reload].value = 0
            } else if (response.status === 'warning') { 
              this.temparraydataupload[index_reload].status = 'warning'
              this.temparraydataupload[index_reload].msg = response.msg
              this.temparraydataupload[index_reload].colorupload = 'warning'
              this.temparraydataupload[index_reload].value = 99
            } else if (response.status === 'fail_checked') { 
              this.temparraydataupload[index_reload].status = 'fail'
              this.temparraydataupload[index_reload].msg = this.$t('uploadFile.cannotupload')
              this.temparraydataupload[index_reload].colorupload = 'error'
              this.temparraydataupload[index_reload].value = 99
            } else {
              this.temparraydataupload[index_reload].status = 'start'
              await this.fnCheckStorage()
              let index_tempa = this.temparraydataupload.findIndex((itemFind) => itemFind.id === this.temparraydataupload[index_reload].id)
              await this.fn_checkfileChunck_v2(this.temparraydataupload[index_reload], index_tempa, this.type_upload_reload)
              .then((response) => {
                  if (response.status === 'cancel upload') {
                    this.temparraydataupload[index_reload].status = "fail";
                    this.temparraydataupload[index_reload].colorupload = "error";
                  } else {

                  }
                  console.log("response ", response);
                })
            }
          })
          .catch ((err) => {
            console.log("errorr ", err)
          })


          
        } else {
        this.temparraydataupload[index_reload].status = "start";
        this.temparraydataupload[index_reload].msg = "";
        this.temparraydataupload[index_reload].colorupload = "primary";
        this.temparraydataupload[index_reload].value = 0;
        this.temparraydataupload[index_reload].formData = new FormData()
        this.temparraydataupload[index_reload].formData.set("structure_data",this.structure_data);
        this.temparraydataupload[index_reload].formData.set("user_id", this.dataUsername);
        this.temparraydataupload[index_reload].formData.set("account_id", this.dataAccountId);
        this.temparraydataupload[index_reload].formData.set("business_id",this.dataAccountActive.business_info.business_id);
        this.temparraydataupload[index_reload].formData.set("file", this.temparraydataupload[index_reload].file);
        this.temparraydataupload[index_reload].formData.set("filename", this.temparraydataupload[index_reload].name);
        this.temparraydataupload[index_reload].formData.set("template_id", this.currenttemplate.id);
        this.temparraydataupload[index_reload].formData.set("type_version", "major");
        this.temparraydataupload[index_reload].formData.set("manage_ai_status", this.manageAI ? 'Y' : 'N')
        if (!this.manageAI) {
        for ( let j = 0; j < this.temparraydataupload[index_reload].aspect_data.length; j++) {
          this.temparraydataupload[index_reload].formData.append("aspect_data", JSON.stringify(this.temparraydataupload[index_reload].aspect_data[j]))
        }
        } else {
          this.temparraydataupload[index_reload].formData.set("file_manage_ai", this.temparraydataupload[index_reload].file)
        }
        await this.fnCheckStorage()
        if (this.temparraydataupload.filter((items) => items.status === 'success').length >= 1) {
          this.fnUploadExtraReload(this.temparraydataupload[index_reload].id);
        } else {
          let count_file = 0
          if (first_time === false) { // ยิงแค่ตัวแรกก่อน
            await this.fnUploadExtraFirst(index_reload).then((response) => {
              console.log("responsee status ", response)
              if (response.status === 'OK') {
                first_time = true
              }
            })
            
          } else {
            if (count_file <= 5) {
            this.fnUploadExtraReload(this.temparraydataupload[index_reload].id);
            count_file += 1;
            } else {
              await this.fnUploadExtraReload(this.temparraydataupload[index_reload].id);
              count_file = 0;
            }
          }
        }
        }
        } catch (err) {

        }
      }
    },
    getFindValueObject (item, index) {
      //console.log("aspecttt dara ", this.detailstemplate.aspect_data, item)
      let findIndex_ = this.detailstemplate.aspect_data[index].aspect_fix_key_extra.indexOf(item)
      //console.log("findIndexx ", findIndex_)
      let findValue_ = findIndex_ !== -1 ?  this.detailstemplate.aspect_data[index].aspect_fix_value_extra[findIndex_]  : ""
      return findValue_
    },
    fn_convertDate (date) {
      const [day, month, year] = date.split("/");
      const formattedDate = `${month}/${day}/${year}`; // "10/15/2024"
      return formattedDate
    },
    fn_extractFormat (structure) {
      const result_w = structure.replace(/{{(.*?)}}/g, (_, p1) => {
        let findName = this.detailstemplate.aspect_data.find((itemName) => itemName.aspect_name === p1.split('&')[0].split('.')[0])
        return findName.aspect_label
      })
      return result_w
    },
    setDateselect(status, item) {
      console.log("status", status);
      console.log("item", item);
      let rawdate = item.showdate.split("-").join("")
      if (item.showdate) {
        if (status === "day") {
          return rawdate.substring(6, 8);
        } else if (status === "month") {
          return rawdate.substring(4, 6);
        } else if (status === "year") {
          return rawdate.substring(0, 4);
        } else {
          let value = item.showdate.split("-").join("");
          return value;
        }
      } else {
        return item.aspect_label;
      }
    },
    fn_check_smup_specific() {
      try {
        if (
          this.listbizsymbolsmartupload.includes(
            this.dataAccountActive.business_info.taxid
          )
        ) {
          return true;
        } else {
          return false;
        }
      } catch (err) {
        return false;
      }
    },
    addFolderTemplate(data) {
      this.datafoldertemplate = data;
    },
    preparingNewFolder(item) {
      this.datafoldercreate = item;
    },
    preparingCreateFolder(id) {
      this.foldercreateid = id;
      this.opencreatefoldertemplate = true;
    },
    changeDateFormat(item) {
      if (item.showdate) {
        let value = item.showdate.split("-").join("");
        return value;
      } else {
        return "";
      }
    },
    async getDataTemplate() {
      console.log(
        "dataAccountActive",
        this.dataAccountActive.business_info.business_id
      );
      console.log("dataAccountActive", this.dataAccountId);
      let auth = await gbfGenerate.generateToken();
      let payload = {
        business_id: this.dataAccountActive.business_info.business_id,
        account_id: this.dataAccountId,
      };
      this.axios({
        method: "POST",
        url:
          process.env.VUE_APP_SERVICE_UPLOAD_API +
          "/api/v2/smart_box/get_template",
        data: payload,
        headers: { Authorization: auth.code },
      })
        .then((response) => {
          if (response.data.status === "OK") {
            console.log("response.data.data", response.data.data);
            this.datatemplate = response.data.data.filter((itemSearch) => itemSearch.status_search === 'N');
            if (response.data.data.length === 0) {
              this.detailstemplate = {
                aspect_data: [],
              };
              if (
                !this.listbizsymbolsmartupload.includes(
                  this.dataAccountActive.business_info.taxid
                )
              ) {
                this.$v.$reset();
              }
              this.loadingdatatemplate = false;
            } else {
              console.log("response.data.data", response.data.data);
              this.selectdatatemplate = this.datatemplate[0];
              console.log("this.datatemplate[0]", this.datatemplate[0]);
              this.getDetailsTemplate(
                response.data.data.filter((itemSearch) => itemSearch.status_search === 'N')[0].id,
                response.data.data.filter((itemSearch) => itemSearch.status_search === 'N')[0].structure_data,
                response.data.data.filter((itemSearch) => itemSearch.status_search === 'N')[0]
              );
            }
          } else {
            Toast.fire({
              icon: "error",
              title: this.$t("smartinput.cannotgettemplate"),
            });
          }
        })
        .catch((err) => {
          console.log(err);
          Toast.fire({
            icon: "error",
            title: this.$t("smartinput.cannotgettemplate"),
          });
        });
    },
    async getDetailsTemplate(template_id, structure_data, current_template) {
      this.clickFetchDB = false
      this.manageAI = false
      this.loadingdatatemplate = true;
      this.currenttemplate = current_template;
      this.listaspectsymbol = [];
      let auth = await gbfGenerate.generateToken();
      let payload = {
        template_id: template_id,
      };
      this.axios({
        method: "POST",
        url:
          process.env.VUE_APP_SERVICE_UPLOAD_API +
          "/api/v2/smart_box/get_template_details",
        data: payload,
        headers: { Authorization: auth.code },
      })
        .then((response) => {
          if (response.data.status === "OK") {
            if (response.data.data.length === 0) {
              this.loadingdatatemplate = false;
              this.detailstemplate = {
                aspect_data: response.data.data,
                structure_data: structure_data,
              };
            } else {
              let listdetailvalue = [];
              for (let i = 0; i < response.data.data.length; i++) {
                response.data.data[i].showdate = "";
                response.data.data[i].menudate = false;
                response.data.data[i].erroraspectmessages = "";
                //  ทดสอบ aspect_fix_value
                let aspect_type_extra = Object.keys(response.data.data[i].aspect_fix_value)
                let aspect_value_new = Object.values(response.data.data[i].aspect_fix_value)
                //this.manageAI = response.data.data[i].manage_ai_status === 'Y' ? true : false // check manage AI
                console.log("aspecttt ", aspect_type_extra)
                // อันใหม่
                if (aspect_type_extra.length > 0) {
                  if (response.data.data[i].aspect_null !== "Y") {
                    response.data.data[i].value = aspect_type_extra[aspect_type_extra.length - 1] ;
                    response.data.data[i]['aspect_fix_key_extra'] = aspect_type_extra
                    response.data.data[i]['aspect_fix_value_extra'] = aspect_value_new
                    response.data.data[i].fixvalue = aspect_type_extra[aspect_type_extra.length - 1];
                    listdetailvalue.push(response.data.data[i]);
                  } else {
                    response.data.data[i].fixvalue = aspect_type_extra[0];
                    response.data.data[i]['aspect_fix_key_extra'] = aspect_type_extra
                    response.data.data[i]['aspect_fix_value_extra'] = aspect_value_new
                    response.data.data[i].value = aspect_type_extra[0];
                    listdetailvalue.push(response.data.data[i]);
                  }
                  let check_structure_file_name = current_template.structure_file_name.search("{{" + response.data.data[i].aspect_name + "}}")
                  if (check_structure_file_name !== -1) {
                    response.data.data[i].readfilename = "Y"
                  } else {
                    response.data.data[i].readfilename = "N"
                  }
                } else {
                  let check_structure_file_name
                  if (current_template.structure_file_name === "") {
                    check_structure_file_name = current_template.structure_file_name.search("{{" + response.data.data[i].aspect_name + "}}")
                  } else {
                    let current_file = current_template.structure_file_name === "" ? [] : current_template.structure_file_name.match(/{{(.*?)}}/g).map(match => match.replace(/[{}]/g, ''))
                    console.log("current fille ", current_file)
                    let mapAspectData = current_file.map((itemMap) => { return {ref: itemMap, value: itemMap.split('&')[0] } })
                    console.log('mapAspectData ', mapAspectData)
                    let find_aspect = mapAspectData.find((itemAspect) => itemAspect.value === response.data.data[i].aspect_name)
                    console.log('find aspect ', find_aspect)
                    if (find_aspect !== undefined) {
                      check_structure_file_name = current_template.structure_file_name.search("{{" + find_aspect.ref + "}}")
                    } else {
                      check_structure_file_name = -1
                    }
                    
                  }

                  if (check_structure_file_name !== -1) {
                    response.data.data[i].readfilename = "Y"
                  } else {
                    response.data.data[i].readfilename = "N"
                  }
                  if (response.data.data[i].aspect_null === "Y" && response.data.data[i].readfilename === 'N') {
                    response.data.data[i].fixvalue = "";
                    if (response.data.data[i].aspect_default !== "") {
                      response.data.data[i].fixvalue = response.data.data[i].aspect_default;
                    } else {
                      response.data.data[i].fixvalue = "";
                      if (response.data.data[i].aspect_type === "DATE") {
                        let datenow = format(new Date(), "yyyy-MM-dd");
                        let datenownoformat = format(new Date(), "yyyyMMdd");
                        response.data.data[i].fixvalue = datenownoformat;
                        response.data.data[i].showdate = datenow;
                      }
                    }
                  } else {
                    response.data.data[i].fixvalue = "";
                    if (response.data.data[i].aspect_default !== "") {
                      response.data.data[i].value = response.data.data[i].aspect_default;
                    } else {
                      response.data.data[i].value = "";
                      // if (response.data.data[i].aspect_type === "DATE") {
                      //   let datenow = format(new Date(), "yyyy-MM-dd");
                      //   let datenownoformat = format(new Date(), "yyyyMMdd");
                      //   response.data.data[i].value = datenownoformat;
                      //   response.data.data[i].showdate = datenow;
                      // }
                    }
                    response.data.data[i].fixvalue = response.data.data[i].aspect_label;
                  }
                  listdetailvalue.push(response.data.data[i]);
                }
                console.log("response.data.data", response.data.data.length);
                if (i + 1 === response.data.data.length) {
                  console.log("this.listaspectsymbol", this.listaspectsymbol);
                  this.$v.$reset();
                  this.detailstemplate = {
                    aspect_data: listdetailvalue,
                    structure_data: structure_data,
                  };
                  this.backup_detail_aspect = JSON.stringify(this.detailstemplate)
                  if (this.arraydataupload.length > 0) {
                    this.arraydataupload.forEach((itemFor) => {
                      itemFor["aspect_data_patternfilename_template"] = this.detailstemplate.aspect_data.map(item => ({ ...item }));
                    });
                  }
                  this.loadingdatatemplate = false;
                }
              }
            }
            if (
                !['', null].includes(this.currenttemplate.structure_change_file_name )
              ) {
              this.arraydataupload.forEach((item) => {
                if (!['', null].includes(this.currenttemplate.structure_change_file_name )) {
                  item.pattern_filename = this.currenttemplate.structure_change_file_name
                  item.backup_pattern_filename = this.currenttemplate.structure_change_file_name
                  item.structurefile_by_patternname = this.currenttemplate.structure_data
                  // Replace Name
                  let replace_filename = item.pattern_filename.replace(/{{(.*?)}}/g, (_, key) => {
                    const match = item.aspect_data_patternfilename_template.find(
                      (aspect) => {return aspect.aspect_name === key}
                    );
                    if (match.aspect_null === 'Y') {
                      return match.aspect_type === 'DROPDOWN' ? `${match?.value || `[${match.aspect_label}]`}` : `${match?.fixvalue || match?.value || `[${match.aspect_label}]`}`;
                    } else {
                      return `${match?.value || `[${match.aspect_label}]`}`;
                    }
                    //return `${match?.fixvalue || match?.value || `[${match.aspect_label}]`}.${newval.typefile}`;
                   })
                  item.name = `${replace_filename}.${item.typefile}`
                } else {
                  item.pattern_filename = ""
                  item.backup_pattern_filename = ""
                  item.name = item.backup_filename
                  item.structurefile_by_patternname = this.currenttemplate.structure_data
                }
              })

            } else {
              this.arraydataupload.forEach((item) => {
                item.pattern_filename = ""
                item.backup_pattern_filename = ""
                item.name = item.backup_filename
                item.structurefile_by_patternname = this.currenttemplate.structure_data
              })
            }
            console.log("Finally datatemplate detail ", this.detailstemplate)
            // }
          } else {
            Toast.fire({
              icon: "error",
              title: this.$t("smartinput.cannotgetdetailtemplate"),
            });
          }
        })
        .catch((err) => {
          console.log(err);
          Toast.fire({
            icon: "error",
            title: this.$t("smartinput.cannotgetdetailtemplate"),
          });
        });
    },
    // ลูปการเก็บไฟล์ของการเลือกไฟล์
    async fnStackFile(e) {
      this.alertSomeFolder = false
      this.temparraydataupload = [];
      this.statusuploading = false;
      const MAX_SIZE = 450 * 1024 * 1024 * 1024; // 5 GB
      // 1. กรองเฉพาะไฟล์ที่ไม่เกินขนาด
      const allFiles = Array.from(e.target.files);
      const validFiles = allFiles.filter(file => {
        // ตรวจสอบไฟล์ที่ไม่ต้องการ
        if (gb_fileFilter.isUnwantedFile(file.name)) {
            console.log(`ข้ามไฟล์ที่ไม่ต้องการ: ${file.name}`);
            return false;
          }
        if (file.size > MAX_SIZE) {
          // ตรวจสอบขนาดไฟล์
          alert(`❌ ไฟล์ "${file.name}" ขนาดเกิน 450GB (${(file.size / (1024 ** 3)).toFixed(2)} GB) จะไม่ถูกอัปโหลด`);
          return false;
        }
        return true;
      });

      // ถ้าไม่มีไฟล์ที่ผ่านเลยก็ออก
      if (validFiles.length === 0) {
        this.stackfileloading = false;
        return;
      }
      this.fileImport = validFiles;
      let i = this.totalstackfile;
      let totalallfile = this.totalstackfile + this.fileImport.length;
      let numcreateformdata = 0;
      this.stackfileloading = true;
      for (i; i < totalallfile; i++) {
        let formData = await this.createPayloadUpload(i, numcreateformdata);
        this.arraydataupload[i].formData = formData;
        this.totalstackfile = this.totalstackfile + 1;
        numcreateformdata = numcreateformdata + 1;
        if (totalallfile === i + 1) {
          this.stackfileloading = false;
        }
      }
    },
    // ลูปการเก็บไฟล์ของการลากไฟล์
    async fnStackFileDrug(files) {
      this.temparraydataupload = [];
      this.statusuploading = false;
      const MAX_SIZE = 450 * 1024 * 1024 * 1024; // 450 GB

      // 🔹 แปลง FileList หรือ DataTransferItemList เป็น Array ก่อน
      const draggedFiles = Array.from(files);

      // 🔹 กรองไฟล์ที่ไม่เกินขนาด
      const validFiles = draggedFiles.filter(file => {
        // ตรวจสอบไฟล์ที่ไม่ต้องการ
        if (gb_fileFilter.isUnwantedFile(file.name)) {
          console.log(`ข้ามไฟล์ที่ไม่ต้องการ: ${file.name}`);
          return false;
        }
        
        // ตรวจสอบขนาดไฟล์
        if (file.size > MAX_SIZE) {
          alert(`❌ ไฟล์ "${file.name}" ขนาดเกิน 450GB (${(file.size / (1024 ** 3)).toFixed(2)} GB) จะไม่ถูกอัปโหลด`);
          return false;
        }
        return true;
      });

      // ถ้าไม่มีไฟล์ที่ผ่านเลยก็ออก
      if (validFiles.length === 0) {
        this.stackfileloading = false;
        return;
      }
      this.fileImport = validFiles;
      let i = this.totalstackfile;
      let totalallfile = this.totalstackfile + this.fileImport.length;
      let numcreateformdata = 0;
      this.stackfileloading = true;
      for (i; i < totalallfile; i++) {
        let formData = await this.createPayloadUpload(i, numcreateformdata);
        this.arraydataupload[i].formData = formData;
        this.totalstackfile = this.totalstackfile + 1;
        numcreateformdata = numcreateformdata + 1;
        if (totalallfile === i + 1) {
          this.stackfileloading = false;
        }
      }
    },
    // ลบไฟล์ที่เก็บ
    fnDeleteStackFile(filedata) {
      var index = this.arraydataupload.indexOf(filedata);
      this.arraydataupload.splice(index, 1);
      this.totalstackfile = this.totalstackfile - 1;
      if (
        !['', null].includes(this.currenttemplate.structure_change_file_name )
      ) {
        if (this.arraydataupload.length >= 1) {
          this.selectedItem = this.arraydataupload[0]
        } else {
          this.selectedItem = null
        }
      }
      let listitemduplicate = this.arraydataupload.filter(
        (item) => item.name === filedata.name
      );
      if (listitemduplicate.length > 0) {
        if (listitemduplicate[0].errorduplicate === "nonapi") {
          let indexduplicate = this.arraydataupload.indexOf(
            listitemduplicate[0]
          );
          this.arraydataupload[indexduplicate].errorduplicate = "not";
          this.arraydataupload[indexduplicate]["status"] = "start";
          this.arraydataupload[indexduplicate]["msg"] = "";
          this.arraydataupload[indexduplicate]["colorupload"] = "primary";
          this.arraydataupload[indexduplicate]["value"] = 0;
        }
      }
    },
    // ดักการรีโหลด
    forceDestroyEvent(status) {
      if (this.openalertduplicatefile === false) {
        if (status === true) {
          window.addEventListener("beforeunload", this.removeUser, true);
        } else {
          window.removeEventListener("beforeunload", this.removeUser, true);
        }
      }
    },
    // event
    removeUser(event) {
      event.returnValue = "Uploading folder";
    },
    // คำนวณขนาดไฟล์
    calculatesize(_sizefilebyte) {
      sizeDataConverter.convertStorageToKbMbGb(_sizefilebyte)
    },
    // ลบ event
    removeEventUploadfiles() {
      var self = this;
      console.log("removeEventUploadfiles");
      self.closeDragDrop = true;
      window.removeEventListener("dragenter", self.dragenteruploadfiles, true);
      window.removeEventListener("dragleave", self.dragleaveuploadfiles, true);
      window.removeEventListener("dragover", self.dragoveruploadfiles, true);
      window.removeEventListener("drop", self.dropuploadfiles, true);
      window
        .matchMedia("(orientation: portrait)")
        .removeListener(this.fnOrientation);
    },
    // เพิ่ม event dragdrop
    addEventUploadfiles() {
      console.log("addEventUploadfiles");
      if (true) {
        // ######### เช็คว่าหน้าจอเล็กไม่ให้ drag drop ได้ #########
        var self = this;
        self.closeDragDrop = false;
        window.addEventListener("dragenter", self.dragenteruploadfiles, true);
        window.addEventListener("dragleave", self.dragleaveuploadfiles, true);
        window.addEventListener("dragover", self.dragoveruploadfiles, true);
        window.addEventListener("drop", self.dropuploadfiles, true);
      }
    },
    // ลากเข้าไปโซน
    dragenteruploadfiles(e) {
      // ลองใช้หลายวิธีในการเช็ค
      const isDropzone = e.target.classList.contains('dropzoneupload') ||
                        e.target.classList.contains('textdropzone') ||
                        e.target.id === "inputuploadfiles" ||
                        e.target.id === "layouthoveruploadfiles" ||
                        e.target.id === "dropzoneuploadfiles" ||
                        e.target.id === "titleTextUploadtitle" ||
                        e.target.id === "titleTextUploadsubtitle" ||
                        e.target.id === "listStackFiles" ||
                        e.target.closest('.dropzoneupload') !== null;
      
      if (isDropzone) {
        if (this.createprogress === false) {
          console.log("overdragfile true");
          this.overdragfile = true;
        } else {
          console.log("createprogress is true, cannot drag");
        }
      } else {
        console.log("ไม่เข้าเงื่อนไข dragenter");
        console.log("isDropzone:", isDropzone);
        console.log("e.target.classList.contains('dropzoneupload'):", e.target.classList.contains('dropzoneupload'));
        console.log("e.target.closest('.dropzoneupload'):", e.target.closest('.dropzoneupload'));
      }
    },
    // ลากเข้าเช็คทุกๆ 200 milliseconds
    dragoveruploadfiles(e) {
      // ใช้วิธีเดียวกับ dragenter
      const isDropzone = e.target.classList.contains('dropzoneupload') ||
                        e.target.classList.contains('textdropzone') ||
                        e.target.id === "inputuploadfiles" ||
                        e.target.id === "layouthoveruploadfiles" ||
                        e.target.id === "dropzoneuploadfiles" ||
                        e.target.id === "titleTextUploadtitle" ||
                        e.target.id === "titleTextUploadsubtitle" ||
                        e.target.id === "listStackFiles" ||
                        e.target.closest('.dropzoneupload') !== null;
      
      if (isDropzone) {
        if (this.createprogress === false) {
          e.preventDefault();
          e.stopPropagation();
          // document.querySelector("#dropzoneuploadfiles").style.border = "4px dashed " + this.color.theme;
          // document.querySelector("#dropzoneuploadfiles").style.background =
          //   "#aeb3b5";
          // document.querySelector("#layouthoveruploadfiles").style.background =
          //   "#aeb3b5";
          // document.querySelector("#layouthoveruploadfiles").style.opacity = "0.4";
          this.overdragfile = true;
        } else {
          console.log("dragover - createprogress is true, cannot drag");
        }
      } else {
        console.log("dragover - ไม่เข้าเงื่อนไข");
        console.log("dragover - isDropzone:", isDropzone);
        console.log("dragover - e.target.classList.contains('dropzoneupload'):", e.target.classList.contains('dropzoneupload'));
        console.log("dragover - e.target.closest('.dropzoneupload'):", e.target.closest('.dropzoneupload'));
      }
    },
    // ลากออก
    dragleaveuploadfiles(e) {
      // console.log("dragleave dropzoneuploadfiles", e);
      // วิธีที่ 1: เช็ค relatedTarget ว่าไม่ได้อยู่ใน dropzone
      if (e.relatedTarget) {
        const isLeavingDropzone = !e.relatedTarget.closest('.dropzoneupload') && 
                                 !e.relatedTarget.classList.contains('dropzoneupload') &&
                                 !e.relatedTarget.classList.contains('textdropzone');
        
        if (isLeavingDropzone) {
          console.log("ออกจาก dropzone แล้ว");
          e.preventDefault();
          this.overdragfile = false;
        }
      } else {
        // ถ้าไม่มี relatedTarget (เช่น ออกจาก browser)
        console.log("ออกจาก browser หรือ window");
        e.preventDefault();
        this.overdragfile = false;
      }
    },
    // ลากแล้วปล่อยไฟล์
    async dropuploadfiles(e) {
      // ใช้วิธีเดียวกับ dragenter และ dragover
      const isDropzone = e.target.classList.contains('dropzoneupload') ||
                        e.target.classList.contains('textdropzone') ||
                        e.target.id === "inputuploadfiles" ||
                        e.target.id === "layouthoveruploadfiles" ||
                        e.target.id === "dropzoneuploadfiles" ||
                        e.target.id === "titleTextUploadtitle" ||
                        e.target.id === "titleTextUploadsubtitle" ||
                        e.target.id === "listStackFiles" ||
                        e.target.className === "v-responsive__content" ||
                        e.target.closest('.dropzoneupload') !== null;
      
      if (isDropzone) {
        if (this.createprogress === false) {
          e.preventDefault();
          e.stopPropagation();
          // document.querySelector("#dropzoneuploadfiles").style.border =
          //   "4px dashed #5fb588";
          // document.querySelector("#dropzoneuploadfiles").style.background =
          //   "#e8eff2";
          // document.querySelector("#layouthoveruploadfiles").style.background =
          //   "#e8eff2";
          // document.querySelector("#layouthoveruploadfiles").style.opacity = "1";
          let items = e.dataTransfer;
          this.overdragfile = false;

          // checkk allow only type as file
          let count_folder = 0
          for (let i = 0; i < items.items.length; i++) {
            const item = items.items[i].webkitGetAsEntry();
            if (item) {
                if (item.isDirectory) {
                   count_folder ++
                }
            }
            if (items.items.length - 1 === i) {
              if (count_folder > 0) {
                this.alertSomeFolder = true
                return 
              } else {
                this.alertSomeFolder = false
                this.fnStackFileDrug(items.files);
              }
            }
            
          }
          
          //this.fnStackFileDrug(items.files);
        } else {
          console.log("drop - createprogress is true, cannot drop");
        }
      } else {
        console.log("drop - ไม่เข้าเงื่อนไข");
        console.log("drop - isDropzone:", isDropzone);
        console.log("drop - e.target.classList.contains('dropzoneupload'):", e.target.classList.contains('dropzoneupload'));
        console.log("drop - e.target.closest('.dropzoneupload'):", e.target.closest('.dropzoneupload'));
      }
    },
    // เด้งให้เลือกไฟล์
    ImportFiles() {
      if (this.createprogress === false) {
        this.selectingImportFiles = true;
        this.fileImport = null;
        this.$refs.importdoc.value = null;
        window.addEventListener(
          "focus",
          () => {
            this.selectingImportFiles = false;
          },
          { once: true }
        );
        this.$refs.importdoc.click();
      }
    },
    // ทำงานตาม action ที่ผู้ใช้เลือกเมื่อไฟล์ซ้ำ (สำหรับโทรศัพท์)
    setStatusFileDuplicate(checkaction, id) {
      let i = this.temparraydataupload.findIndex((item) => item.id === id);
      if (checkaction !== "") {
        // แทนที่
        if (checkaction === "replace") {
          this.temparraydataupload[i].fileduplicate = "create_tag_version";
        }
        // คัดลอก
        else if (checkaction === "copy") {
          this.temparraydataupload[i].fileduplicate = "create_copy";
        }
        this.reloadId = id;
        this.fnLoopUploadFile_v2();
      } else {
        this.forceDestroyEvent(false);
        // console.log("test skip");
        this.temparraydataupload[i].status = "skip";
        this.temparraydataupload[i].msg = this.$t("fileduplicate.skipmsg");
        this.temparraydataupload[i].colorupload = "error";
        this.temparraydataupload[i].value = 100;
        if (this.length_processing === this.temparraydataupload.length) {
          this.createprogress = false;
        }
      }
    },
    // สร้าง payload สำหรับอัปโหลด
    async createPayloadUpload(i, numcreateformdata) {
      try {
        if (this.temparraydataupload.length !== 0) {
          // set data
          const formDataReload = new FormData();
          formDataReload.append("user_id", this.dataUsername);
          formDataReload.append("account_id", this.dataAccountId);
          formDataReload.append(
            "business_id",
            this.dataAccountActive.business_info.business_id
          );
          formDataReload.append("file", this.temparraydataupload[i].file);
          formDataReload.append("filename",this.temparraydataupload[i].name);
          // formDataReload.append(
          //   "filename",
          //   this.temparraydataupload[i].name +
          //     "." +
          //     this.temparraydataupload[i].typefile
          // );
          // เพิ่ม major and minor formData
          formDataReload.append("type_version", "major")
          return formDataReload;
        } else {
          let typefile;
          let filename;
          if (!this.arraydataupload[i]) {
            typefile = this.fileImport[numcreateformdata].name.split(".");
            typefile = typefile[typefile.length - 1];
            console.log("typefile", this.fileImport[numcreateformdata].name);
            filename = this.fileImport[numcreateformdata].name
              .split(".")
              .slice(0, -1);
            let iconfile = setIconFiles.fn_seticon(typefile);
            // ปั้นดาต้าใหม่
            let datafileupload = {};
            datafileupload["file"] = this.fileImport[numcreateformdata];
            datafileupload["icon"] = iconfile;
            datafileupload["name"] =  this.fileImport[numcreateformdata].name;
            datafileupload["backup_filename"] = this.fileImport[numcreateformdata].name;
            datafileupload["size"] = this.fileImport[numcreateformdata].size;
            datafileupload["canceltoken"] = null;
            datafileupload["id"] = this.uniqueidfile;
            datafileupload["typefile"] = typefile;
            datafileupload["type_version"] = "major"
            datafileupload["allchunk"] = []
            datafileupload["chunkkey"] = ""
            datafileupload["parts"] = []
            datafileupload["listxhr"] = []
            const aspect_data_custom = [...this.detailstemplate.aspect_data]
            datafileupload["aspect_data_patternfilename_template"] = this.detailstemplate.aspect_data.map(item => ({ ...item }));
            datafileupload['aspect_data'] = this.detailstemplate.aspect_data.map(item => ({ ...item }));
            datafileupload["pattern_filename"] = this.currenttemplate.structure_change_file_name
            datafileupload["backup_pattern_filename"] = this.currenttemplate.structure_change_file_name
            datafileupload["structurefile_by_patternname"] = this.currenttemplate.structure_data
            // ดัก size File
            let sizeFile = datafileupload["size"]
            datafileupload["errorSize"] = false;
            // if (sizeFile > 5368709120) { //ดัก size 5 gb
            //   datafileupload["errorSize"] = true;
            // } else {
            //   datafileupload["errorSize"] = false;
            // }

            let fileName = this.arraydataupload.find(
              (element) => element.name === datafileupload["name"]
            );
            if (fileName !== undefined) {
              if (fileName.errorduplicate === "api") {
                datafileupload["errorduplicate"] = fileName.errorduplicate;
              } else {
                datafileupload["errorduplicate"] = "nonapi";
              }
              datafileupload["status"] = "duplicate";
              datafileupload["msg"] = this.$t("uploadfile.fileduplicate");
              datafileupload["colorupload"] = "warning";
              datafileupload["value"] = 99;
              datafileupload["checkfailformat"] = false;
              datafileupload["unique_number"] = this.arraydataupload.filter((itemFile) => itemFile.name === this.fileImport[numcreateformdata].name)[0]['id']
            } else {
              datafileupload["errorduplicate"] = "not";
              datafileupload["status"] = "start";
              datafileupload["msg"] = "";
              datafileupload["colorupload"] = "primary";
              datafileupload["checkfailformat"] = false;
              datafileupload["value"] = 0;
            }
            this.arraydataupload.push(datafileupload);
            this.selectedItem = this.arraydataupload[this.arraydataupload.length - 1]
            this.uniqueidfile += 1;
          }
          // set data
          const formData = new FormData();
          // formData.append("user_id", this.dataUsername);
          // formData.append("account_id", this.dataAccountId);
          // formData.append(
          //   "business_id",
          //   this.dataAccountActive.business_info.business_id
          // );
          // formData.append("file", this.arraydataupload[i].file);
          // formData.append(
          //   "filename",
          //   this.arraydataupload[i].name +
          //     "." +
          //     this.arraydataupload[i].typefile
          // );
          return formData;
        }
      } catch (err) {
        console.log("err", err);
      }
    },
    // ลูปสำหรับการอัปโหลดไฟล์ **ยังไม่ได้ใช้งาน (ไม่มีการใช้งานเส้น chunk)
    async fnLoopUploadFile() {
      // if (this.checkbizsymbolsmartupload === false) {
      this.$v.$touch();
      // }
      if (this.checktemplatefolder === true) {
        console.log("feofjejf");
        if (this.datafoldertemplate.path === undefined) {
          Toast.fire({
            icon: "error",
            title: this.$t("smartinput.pleaseselectfoldertemplate"),
          });
          return;
        }
      }
      if (this.reloadId !== "") {
        this.createprogress = true;
        let i = this.temparraydataupload.findIndex(
          (item) => item.id === this.reloadId
        );
        console.log("this.reloadId", this.reloadId);
        console.log(
          "this.reloadId",
          this.temparraydataupload[i].checkfailformat
        );
        this.$v.$touch();
        this.temparraydataupload[i].status = "start";
        this.temparraydataupload[i].msg = "";
        this.temparraydataupload[i].colorupload = "primary";
        this.temparraydataupload[i].value = 0;
        this.reloadId = "";
        this.temparraydataupload[i].checkfailformat = false;
        let formDataDuplicate = await this.createPayloadUpload(i);
        this.temparraydataupload[i].formData = formDataDuplicate;
        await this.fnCheckStorage();
        let count_file = 0;
        if (count_file <= 5) {
          // if (this.temparraydataupload[i].size > 524288000) {
          //   this.fnUploadChunk(i);
          // } else {
          this.fnUploadFile(this.temparraydataupload[i].formData, i);
          // }
          count_file += 1;
        } else {
          // console.log("count_file else", count_file);
          // if (this.temparraydataupload[i].size > 524288000) {
          //   await this.fnUploadChunk(i);
          // } else {
          await this.fnUploadFile(this.temparraydataupload[i].formData, i);
          // }
          count_file = 0;
        }
      } else if (this.detailstemplate.aspect_data.filter(item => item.readfilename === 'N').length === 0 ) {
        // this.listbizsymbolsmartupload.includes(
        //   this.dataAccountActive.business_info.taxid
        // )
        // สลับ layout
        this.checkdetailmobile = false;
        this.totalstackfile = 0;
        this.statusuploading = true;
        this.createprogress = true;
        // เงื่อนไขการอัปโหลดจาก upload layout
        this.temparraydataupload = [...this.arraydataupload];
        this.checkhashtag = false;
        for (let i = 0; i < this.temparraydataupload.length; i++) {
          try {
            // if (this.checkbizsymbolsmartupload === true) {
            //   let arraystructuresymboldata = this.structure_symbol_data.split(
            //     "XXXXXXXXXX"
            //   );
            //   // "/XXXXXXXXXX"
            //   console.log(
            //     "arraystructuresymboldatat",
            //     arraystructuresymboldata[0]
            //   );
            //   this.temparraydataupload[i].formData.append(
            //     "structure_data",
            //     arraystructuresymboldata[0].slice(
            //       0,
            //       arraystructuresymboldata[0].length - 1
            //     )
            //   );
            //   this.temparraydataupload[i].formData.append(
            //     "template_id",
            //     this.selectdatatemplate.template_id
            //   );
            // } else {
            // this.temparraydataupload[i].formData.append(
            //   "structure_data",
            //   this.structure_data
            // );
            // }
            await this.fnCheckStorage();
            let count_file = 0;
            if (count_file <= 5) {
              // if (this.temparraydataupload[i].size > 524288000) {
              //   this.fnUploadChunk(i);
              // } else {
              this.fnUploadFile(this.temparraydataupload[i].formData, i);
              // }
              count_file += 1;
            } else {
              // console.log("count_file else", count_file);
              // if (this.temparraydataupload[i].size > 524288000) {
              //   await this.fnUploadChunk(i);
              // } else {
              await this.fnUploadFile(this.temparraydataupload[i].formData, i);
              // }
              count_file = 0;
            }
          } catch (err) {
            console.log("error", err);
            if (this.temparraydataupload[i].status !== "cancel") {
              this.temparraydataupload[i].status = "fail";
              this.temparraydataupload[i].msg = this.$t(
                "uploadfile.uploadfail"
              );
              this.temparraydataupload[i].colorupload = "error";
            } else {
              this.temparraydataupload[i].status = "cancel";
              this.temparraydataupload[i].msg = this.$t(
                "dragdrop.cancelupload"
              );
              this.temparraydataupload[i].colorupload = "error";
            }
            if (this.temparraydataupload.length === this.length_processing) {
              this.removeEventUploadfiles();
              this.addEventUploadfiles();
              this.createprogress = false;
            }
          }
        }
      } else if (
        !this.$v.$invalid &&
        this.totalstackfile > 0 &&
        !this.$v.$error
      ) {
        // สลับ layout
        this.checkdetailmobile = false;
        this.totalstackfile = 0;
        this.statusuploading = true;
        this.createprogress = true;
        // เงื่อนไขการอัปโหลดจาก upload layout
        this.temparraydataupload = [...this.arraydataupload];
        this.checkhashtag = false;
        for (let i = 0; i < this.temparraydataupload.length; i++) {
          try {
            this.temparraydataupload[i].formData.append(
              "structure_data",
              this.structure_data
            );
            await this.fnCheckStorage();
            let count_file = 0;
            if (count_file <= 5) {
              // if (this.temparraydataupload[i].size > 524288000) {
              //   this.fnUploadChunk(i);
              // } else {
              this.fnUploadFile(this.temparraydataupload[i].formData, i);
              // }
              count_file += 1;
            } else {
              // console.log("count_file else", count_file);
              // if (this.temparraydataupload[i].size > 524288000) {
              //   await this.fnUploadChunk(i);
              // } else {
              await this.fnUploadFile(this.temparraydataupload[i].formData, i);
              // }
              count_file = 0;
            }
          } catch (err) {
            console.log("error", err);
            if (this.temparraydataupload[i].status !== "cancel") {
              this.temparraydataupload[i].status = "fail";
              this.temparraydataupload[i].msg = this.$t(
                "uploadfile.uploadfail"
              );
              this.temparraydataupload[i].colorupload = "error";
            } else {
              this.temparraydataupload[i].status = "cancel";
              this.temparraydataupload[i].msg = this.$t(
                "dragdrop.cancelupload"
              );
              this.temparraydataupload[i].colorupload = "error";
            }
            if (this.temparraydataupload.length === this.length_processing) {
              this.removeEventUploadfiles();
              this.addEventUploadfiles();
              this.createprogress = false;
            }
          }
        }
      } else {
        console.log("ทำไมมาเข้านี้หล่ะะะ", this.$v, this.detailstemplate)
        if (this.$v.$invalid) {
          this.checkdetailmobile = true;
        }
        if (this.totalstackfile === 0) {
          Toast.fire({
            icon: "error",
            title: this.$t("smartinput.pleaseselectfile"),
          });
        }
      }
    },
    
    // ลูปสำหรับบการอัปโหลด v2 **ยังไม่ได้ใช้งาน (ไม่มีการใช้งานเส้น chunk)
    async fnLoopUploadFile_v2 () {
      this.$v.$touch();
      // Check Template ว่างเปล่า
      if (this.checktemplatefolder === true) {
        if (this.datafoldertemplate.path === undefined) {
          Toast.fire({
            icon: "error",
            title: this.$t("smartinput.pleaseselectfoldertemplate"),
          });
          return;
        }
      }

      // check reupload smartupload
      if (this.reloadId !== "") {
        this.createprogress = true;
        let i = this.temparraydataupload.findIndex(
          (item) => item.id === this.reloadId
        );
        this.$v.$touch();
        this.temparraydataupload[i].status = "start";
        this.temparraydataupload[i].msg = "";
        this.temparraydataupload[i].colorupload = "primary";
        this.temparraydataupload[i].value = 0;
        this.temparraydataupload[i].formData = new FormData()
        this.temparraydataupload[i].formData.append("structure_data",this.structure_data);
        this.temparraydataupload[i].formData.append("user_id", this.dataUsername);
        this.temparraydataupload[i].formData.append("account_id", this.dataAccountId);
        this.temparraydataupload[i].formData.append("business_id",this.dataAccountActive.business_info.business_id);
        this.temparraydataupload[i].formData.append("file", this.temparraydataupload[i].file);
        this.temparraydataupload[i].formData.append("filename", this.temparraydataupload[i].name);
        this.temparraydataupload[i].formData.append("template_id", this.currenttemplate.id);
        this.temparraydataupload[i].formData.append("type_version", "major");
        for ( let j = 0; j < this.temparraydataupload[i].aspect_data.length; j++) {
          this.temparraydataupload[i].formData.append("aspect_data", JSON.stringify(this.temparraydataupload[i].aspect_data[j]))
        }
        await this.fnCheckStorage();
        this.fnUploadExtraReload(this.reloadId);
      } 
      else if (this.$v.$invalid && this.totalstackfile > 0 && this.$v.$error) {
        return
      }
      // check upload invalid and error smart upload 
      else if (((!this.$v.$invalid && !this.$v.$error) || (this.detailstemplate.aspect_data.filter(item => item.readfilename === 'N').length === 0)) && this.totalstackfile >= 1) {
        
        this.temparraydataupload = [...this.arraydataupload.filter((itemSize) => !itemSize.errorSize)];
        if (this.temparraydataupload.length <= 0) {
          Toast.fire({
            icon: "error",
            title: this.$t("smartinput.pleaseselectfile"),
          });
          return
        }
        this.stackfileloading = true;
        // assign aspect_data in temparrayupload
        this.temparraydataupload.forEach((itemFor) => {
          itemFor['aspect_data'] = []
        for (let j = 0; j < this.detailstemplate.aspect_data.length; j++) {
            let raw_aspect_data = {
              aspect_id: this.detailstemplate.aspect_data[j].id,
              value: "ไม่ระบุ",
              aspect_name: this.detailstemplate.aspect_data[j].aspect_name,
            };
            if (
              this.detailstemplate.aspect_data[j]
              .aspect_fix_value.length > 0
            ) {
              if (this.detailstemplate.aspect_data[j].aspect_type === "") {
                raw_aspect_data.value = "ไม่ระบุ";
              } else if (
                this.detailstemplate.aspect_data[j].aspect_null !== "Y"
              ) {
                if (this.detailstemplate.aspect_data[
                  j
                ].value === "") {
                  raw_aspect_data.value = "ไม่ระบุ";
                } else {  
                  raw_aspect_data.value = this.detailstemplate.aspect_data[
                    j
                  ].value;
                }
              } else {
                if (this.detailstemplate.aspect_data[
                  j
                ].value === "") {
                  raw_aspect_data.value = "ไม่ระบุ";
                } else {  
                  raw_aspect_data.value = this.detailstemplate.aspect_data[
                    j
                  ].value;
                }
              }
            } else {
              if (this.detailstemplate.aspect_data[j].aspect_null === "Y") {
                raw_aspect_data.value = this.detailstemplate.aspect_data[j].readfilename === 'Y' ? "" : this.detailstemplate.aspect_data[ //ลบนี่
                  j
                ].fixvalue;
              } else {
                if (this.detailstemplate.aspect_data[
                  j
                ].value === "") {
                  raw_aspect_data.value = "ไม่ระบุ";
                } else {  
                  raw_aspect_data.value = this.detailstemplate.aspect_data[
                    j
                  ].value;
                }
              }
            }
            itemFor['aspect_data'].push(raw_aspect_data)
        }
        })
        // Check duplicate temparrayupload
        this.isloadingChecking = true
        for (let i = 0; i < this.temparraydataupload.length; i++) {
          if (this.temparraydataupload[i].status === 'duplicate') {
            this.temparraydataupload[i].status = 'duplicate'
            this.temparraydataupload[i].msg = this.$t('smartinput.duplicate_upload')
            this.temparraydataupload[i].colorupload = 'warning'
            this.temparraydataupload[i].value = 0
          } else if (this.temparraydataupload[i].errorSize) {
            this.temparraydataupload[i].status = 'max size'
            this.temparraydataupload[i].msg = this.$t('smartinput.maxSizeFile')
            this.temparraydataupload[i].colorupload = 'error'
            this.temparraydataupload[i].value = 0
          } else { 
          await this.checkDuplicateMajorMinor(this.temparraydataupload[i], this.currenttemplate.id, i)
          .then(async (response) => {
            if (response.status === 'fail') {
              this.temparraydataupload[i].status = 'duplicate'
              this.temparraydataupload[i].msg = this.$t('smartinput.duplicate_upload')
              this.temparraydataupload[i].colorupload = 'warning'
              this.temparraydataupload[i].value = 0
            } else if (response.status === 'warning') { 
              this.temparraydataupload[i].status = 'warning'
              this.temparraydataupload[i].msg = response.msg
              this.temparraydataupload[i].colorupload = 'warning'
              this.temparraydataupload[i].value = 99
            } else if (response.status === 'fail_checked') { 
              this.temparraydataupload[i].status = 'fail'
              this.temparraydataupload[i].msg = this.$t('uploadFile.cannotupload')
              this.temparraydataupload[i].colorupload = 'error'
              this.temparraydataupload[i].value = 99
            } else {
              this.temparraydataupload[i].status = 'start'
            }
          })
          .catch ((err) => {
            console.log("errorr ", err)
          })
          console.log("logg fillle ", this.temparraydataupload[i])
          }
        }
        this.isloadingChecking = false

        this.checkdetailmobile = false;
        this.totalstackfile = 0;
        this.statusuploading = true;
        this.createprogress = true;
        this.stackfileloading = false

        // State ของการอัปโหลด
        // sort start
        this.temparraydataupload.sort((a, b) => {
          if (a.status === 'start' && b.status !== 'start') {
            return -1; // 'start' comes first
          } else if (a.status !== 'start' && b.status === 'start') {
            return 1; // 'start' comes first
          } else {
            return 0; // maintain relative order of non-'start' items
          }
        });
        // sort size (Start)
        let status_start = this.temparraydataupload.filter((itemStatus) => itemStatus.status === 'start')
        status_start.sort((a, b) => a.size - b.size);
        // sort size (duplicate)
        let status_duplicate = this.temparraydataupload.filter((itemStatus) => itemStatus.status === 'duplicate')
        status_duplicate.sort((a, b) => a.size - b.size);
        // fail checked duplicate
        let status_fail = this.temparraydataupload.filter((itemStatus) => itemStatus.status === 'fail')

        this.temparraydataupload = [...status_start, ...status_duplicate, ...status_fail]
        let filter_start = this.temparraydataupload.filter((itemStatus) => itemStatus.status === 'start')
        if (filter_start.length > 0) {
          let first_time = false
          for (let i = 0; i < filter_start.length; i++) {
            try {
              filter_start[i].formData.append("structure_data",this.structure_data);
              filter_start[i].formData.append("user_id", this.dataUsername);
              filter_start[i].formData.append("account_id", this.dataAccountId);
              filter_start[i].formData.append("business_id",this.dataAccountActive.business_info.business_id);
              filter_start[i].formData.append("file", filter_start[i].file);
              filter_start[i].formData.append("filename", filter_start[i].name);
              filter_start[i].formData.append("template_id", this.currenttemplate.id);
              filter_start[i].formData.append("type_version", "major");
              for ( let j = 0; j < filter_start[i].aspect_data.length; j++) {
                filter_start[i].formData.append("aspect_data", JSON.stringify(filter_start[i].aspect_data[j]))
              }
              if (filter_start[i].status !== 'cancel') {
                await this.fnCheckStorage()
                let count_file = 0
                if (first_time === false) { // ยิงแค่ตัวแรกก่อน
                  await this.fnUploadExtraFirst(i).then((response) => {
                    console.log("responsee status ", response)
                    if (response.status === 'OK') {
                      first_time = true
                    }
                  })
                  
                } else {
                  if (count_file <= 5) {
                  this.fnUploadFile_V2(filter_start[i].formData, i);
                  count_file += 1;
                  } else {
                    await this.fnUploadFile_V2(filter_start[i].formData, i);
                    count_file = 0;
                  }
                }
              } else {
                if (filter_start[i].canceltoken !== null) {
                  filter_start[i].canceltoken.cancel();
                }
              }
              
            }
            catch (err) {
              console.log("errr ", err)
            }
          }
        } else {
          this.createprogress = false
        }
      } 
      // Other ในกรณีที่ไม่มีไฟล์ 
      else {
        console.log("ทำไมมาเข้านี้หล่ะะะ", this.$v, this.detailstemplate)
        if (this.$v.$invalid) {
          this.checkdetailmobile = true;
        }
        if (this.totalstackfile === 0) {
          Toast.fire({
            icon: "error",
            title: this.$t("smartinput.pleaseselectfile"),
          });
        }
      }

    },

    parseResponseHeaders(headerString) {
      const headers = {};
      const headerPairs = headerString.split("\r\n");
      headerPairs.forEach(function(headerPair) {
        const index = headerPair.indexOf(":");
        if (index > 0) {
          const key = headerPair.substring(0, index).trim();
          const value = headerPair.substring(index + 1).trim();
          headers[key] = value;
        }
      });
      return headers;
    },
    

    // check file ที่ต้องมีการ chunk
    async fn_checkfileChunck_v2 (datafile, i, type) {
      return new Promise (async (resolve, reject) => {
      if (this.userdata.remain_storage > this.temparraydataupload[i].size) {
        let auth = await gbfGenerate.generateToken();
        let payload = {
          user_id: this.dataUsername,
          account_id: this.dataAccountId,
          department_id: "",
          file_duplicate: "",
          size_file: datafile.size,
          filename: datafile.name,
          remark: "",
          hashtag: [],
          template_id: this.currenttemplate.id,
          type_version: type,
          aspect_data: [...datafile.aspect_data]
        }
        const CancelToken = this.axios.CancelToken;
        this.source = CancelToken.source();
        this.temparraydataupload[i].canceltoken = this.source;
        await this.axios({
            method: "POST",
            url:
              process.env.VUE_APP_SERVICE_UPLOAD_API +
              "/api/v1/checking_file_data/upload/smartbox",
            cancelToken: this.temparraydataupload[i].canceltoken.token,
            data: payload,
            headers: { Authorization: auth.code },
          })
          .then(async (response) => {
            if (response.data.status === "OK") {
              // response_bucket.push(response.data.data)
              // response_bucket.push({
              //   id_parent: uuidv4(), 
              //   status: 'start', 
              //   uploadChunk: response.data.data.uploadChunk,
              //   chunk_file: Object.keys(response.data.data.uploadChunk).length > 1 ? await this.create_chunk_new(this.temparraydataupload[i]) : [],  
              //   upload_obj: response.data.data, 
              //   data_detail: this.temparraydataupload[i],
              //   checkupload_first: response.data.data.create_folder_status  }) // true หมายถึง ต้องทำการอัปโหลดไฟล์แรกให้ false หมายถึง มีการสร้าง folder ไว้ก่อนแล้วว
              //   this.temparraydataupload[i]['allchunk'] = [...response_bucket[i]['chunk_file']]
              
              if (Object.keys(response.data.data.uploadChunk).length > 0) {
                  this.datachunkwaiting = this.temparraydataupload[i];
                  this.temparraydataupload[i]["datafile"] = response.data.data;
                  this.temparraydataupload[i]['uploadChunk'] = response.data.data.uploadChunk,
                  this.temparraydataupload[i]['allchunk'] = await this.create_chunk_new(this.temparraydataupload[i])
                  console.log("tempaartt data ", this.temparraydataupload);
                  await this.fnuploadChunks3(response.data.data, i, this.temparraydataupload[i])
                  .then(async (response) => {
                    // console.log("HELLLO S333 ",response)
                    if (response.status === 'upload success') {
                      await this.fnInsertFileData(this.temparraydataupload[i]["datafile"], i, "chunk").then((response_insert) => {
                        this.slot_uploading_state = []
                        console.log(response_insert);
                        resolve({status: 'insert success', msg: ""})
                      })
                    } else {
                      this.temparraydataupload[i].status = "fail";
                      this.temparraydataupload[i].msg = this.$t('smartinput.cancelupload');
                      this.temparraydataupload[i].colorupload = "error";
                      console.log('เข้าาตรงนี้ด้วย chunk')
                      resolve({status: 'cancel upload', msg: ""})
                    }
                  })
                  
                } else { 
                  await this.fn_uploadFileS3_nochunk(response.data.data, i)
                  console.log("HELLLO noChunl ",response)
                  .then(async (responses) => {
                    if (responses.status === 'success') {
                      await this.fnInsertFileData(response.data.data, i, "nochunk").then((response_insert) => {
                        return {status: 'insert success', msg: ""}
                      })
                    }
                  })
                }
            } else {
              if (
                response.data.errorMessage === "Value from file not same dropdown"
              ) {
                this.temparraydataupload[i].status = "fail";
                this.temparraydataupload[i].msg = this.$t(
                  "smartinput.valuesamedropdown"
                );
                this.temparraydataupload[i].colorupload = "error";
                this.temparraydataupload[i].checkfailformat = true;
              }else if (
                response.data.errorMessage === "Pettern file name wrong"
              ) {
                this.temparraydataupload[i].status = "fail";
                this.temparraydataupload[i].msg = this.$t(
                  "smartinput.yourfileformatwrong"
                );
                this.temparraydataupload[i].colorupload = "error";
                this.temparraydataupload[i].checkfailformat = true;
              }
              else if (
                response.data.errorMessage === "Your space not enough"
              ) {
                this.temparraydataupload[i].status = "fail";
                this.temparraydataupload[i].msg = this.$t(
                  "dragdrop.yourspacenotenough"
                );
                this.temparraydataupload[i].colorupload = "error";
              } else if (
                response.data.errorMessage === "File Size More Than 450GB"
              ) {
                this.temparraydataupload[i].status = "fail";
                this.temparraydataupload[i].msg = this.$t(
                  "smartinput.maxSizeFile"
                );
                this.temparraydataupload[i].colorupload = "error";
              } else {
                this.temparraydataupload[i].status = "fail";
                this.temparraydataupload[i].msg = this.$t(
                  "dragdrop.cannotdetailupload"
                );
                this.temparraydataupload[i].colorupload = "error";
              }
              resolve({status: 'not success', msg: ""})
            }
          })
          .catch((err) => {
            console.log("error what  ", err);
            resolve({status: 'not success', msg: ""})
            this.temparraydataupload[i].status = "fail";
              this.temparraydataupload[i].msg = this.$t('smartinput.cancelupload');
              this.temparraydataupload[i].colorupload = "error";
          })
      } else {
        this.statusstorage = true;
        this.temparraydataupload[i].status = "fail";
        this.temparraydataupload[i].msg = this.$t(
          "dragdrop.yourspacenotenough"
        );
        this.temparraydataupload[i].colorupload = "error";
        this.createprogress = false;
      } 

      })
      
    },
    // ลูแสำหรับการอัปโหลด v3
    async fnLoopUploadFile_v3 () {
      this.$v.$touch();
      // Check Template ว่างเปล่า
      if (this.checktemplatefolder === true) {
        if (this.datafoldertemplate.path === undefined) {
          Toast.fire({
            icon: "error",
            title: this.$t("smartinput.pleaseselectfoldertemplate"),
          });
          return;
        }
      }
      
      // check reupload smartupload
      if (this.reloadId !== "") {
        this.createprogress = true;
        let i = this.temparraydataupload.findIndex(
          (item) => item.id === this.reloadId
        );
        this.$v.$touch();
        // check chunck file
        if (this.temparraydataupload[i].status_chunk) {
          this.temparraydataupload[i].status = "start";
          this.temparraydataupload[i].msg = "";
          this.temparraydataupload[i].colorupload = "primary";
          this.temparraydataupload[i].value = 0;
          this.temparraydataupload[i].checkfailformat = false
          await this.fnCheckStorage()
          if (this.userdata.remain_storage < this.temparraydataupload[i].size) {
              this.statusstorage = true;
              this.temparraydataupload[index_tempa].status = "fail";
              this.temparraydataupload[index_tempa].msg = this.$t(
                "dragdrop.yourspacenotenough"
              );
              this.temparraydataupload[index_tempa].colorupload = "error";
              this.createprogress = false;
              return
          }
          await this.checkDuplicateMajorMinor(this.temparraydataupload[i], this.currenttemplate.id, i)
          .then(async (response) => {
            if (response.status === 'fail') {
              this.temparraydataupload[i].status = 'duplicate'
              this.temparraydataupload[i].msg = this.$t('smartinput.duplicate_upload')
              this.temparraydataupload[i].colorupload = 'warning'
              this.temparraydataupload[i].value = 0
            } else if (response.status === 'warning') { 
              this.temparraydataupload[i].status = 'warning'
              this.temparraydataupload[i].msg = response.msg
              this.temparraydataupload[i].colorupload = 'warning'
              this.temparraydataupload[i].value = 99
            } else if (response.status === 'fail_checked') { 
              this.temparraydataupload[i].status = 'fail'
              this.temparraydataupload[i].msg = this.$t('uploadFile.cannotupload')
              this.temparraydataupload[i].colorupload = 'error'
              this.temparraydataupload[i].value = 99
            } else {
              this.temparraydataupload[i].status = 'start'
              await this.fnCheckStorage()
              let index_tempa = this.temparraydataupload.findIndex((itemFind) => itemFind.id === this.temparraydataupload[i].id)
              await this.fn_checkfileChunck_v2(this.temparraydataupload[i], index_tempa, this.type_upload_reload)
              .then((response) => {
                  if (response.status === 'cancel upload') {
                    this.temparraydataupload[i].status = "fail";
                    this.temparraydataupload[i].colorupload = "error";
                  } else {

                  }
                  console.log("response ", response);
                })
            }
          })
          .catch ((err) => {
            console.log("errorr ", err)
          })


          
        } else {
        this.temparraydataupload[i].status = "start";
        this.temparraydataupload[i].msg = "";
        this.temparraydataupload[i].colorupload = "primary";
        this.temparraydataupload[i].value = 0;
        this.temparraydataupload[i].formData = new FormData()
        this.temparraydataupload[i].formData.set("structure_data",this.structure_data);
        this.temparraydataupload[i].formData.set("user_id", this.dataUsername);
        this.temparraydataupload[i].formData.set("account_id", this.dataAccountId);
        this.temparraydataupload[i].formData.set("business_id",this.dataAccountActive.business_info.business_id);
        this.temparraydataupload[i].formData.set("file", this.temparraydataupload[i].file);
        this.temparraydataupload[i].formData.set("filename", this.temparraydataupload[i].name);
        this.temparraydataupload[i].formData.set("template_id", this.currenttemplate.id);
        this.temparraydataupload[i].formData.set("type_version", "major");
        for ( let j = 0; j < this.temparraydataupload[i].aspect_data.length; j++) {
          this.temparraydataupload[i].formData.append("aspect_data", JSON.stringify(this.temparraydataupload[i].aspect_data[j]))
        }
        await this.fnCheckStorage();
        this.fnUploadExtraReload(this.reloadId);
        }
      }
      // ดักจับ template ที่ไม่มีการใช้งาน pattern filename และไม่มีดีการ config aspect_condition === Y เลยสักอัน
        else if ((this.$v.detailstemplate.$invalid && this.totalstackfile > 0 && this.$v.detailstemplate.$error) && (!this.currenttemplate.structure_change_file_name)  ) {
        return
      } else if (
        (this.currenttemplate.structure_change_file_name) && 
        this.$v.selectedItem.aspect_data_patternfilename_template.$error && this.$v.selectedItem.aspect_data_patternfilename_template.$invalid  
      ) {
        return
      }
      // check upload invalid and error smart upload 
      //else if (( this.manageAI || (!this.$v.$invalid && !this.$v.$error) || (this.detailstemplate.aspect_data.filter(item => item.readfilename === 'N').length === 0) || (this.currenttemplate.structure_change_file_name && !this.$v.selectedItem.$invalid && !this.$v.selectedItem.$error )) && this.totalstackfile >= 1) {
      else if ( 
          (
            (this.currenttemplate.structure_change_file_name) && 
            (!this.$v.selectedItem.aspect_data_patternfilename_template.$error && !this.$v.selectedItem.aspect_data_patternfilename_template.$invalid)
          ) ||
        (
          (!this.currenttemplate.structure_change_file_name) && 
          (!this.$v.detailstemplate.$invalid && this.totalstackfile > 0 && !this.$v.detailstemplate.$error)
        )
       ) {
        
        this.temparraydataupload = [...this.arraydataupload.filter((itemSize) => !itemSize.errorSize)]; 
        if (this.temparraydataupload.length <= 0) {
          Toast.fire({
            icon: "error",
            title: this.$t("smartinput.pleaseselectfile"),
          });
          return
        }
        // ทำการเช็คค่า aspect_null ก่อนว่าของแต่ละอันมันเป็น Y มั้ย ถ้าใช้ ก็ให้ทำการเช็คอีกว่า fixvalue มีการใส่ครบทั้หมดแล้วหรือยังง
        let checkAspectValue = false
        if (!this.manageAI && (this.currenttemplate.structure_change_file_name) ) {
          outerLoop: // 👉 ตั้งชื่อ label ให้ลูปนอก
          for (var i = 0; i < this.arraydataupload.length; i++) {
            for (let j = 0; j < this.arraydataupload[i].aspect_data_patternfilename_template.length; j++) {
              if (this.arraydataupload[i].aspect_data_patternfilename_template[j].aspect_null === 'Y') {
                if (this.arraydataupload[i].aspect_data_patternfilename_template[j].fixvalue === '') {
                  this.selectedItem = this.arraydataupload[i]
                  checkAspectValue = true
                  console.log('checkk aspectt data ', this.arraydataupload[i])
                  break outerLoop // 👉 ออกจากทั้ง 2 ลูป
                }
              }
            }
          }
          if (checkAspectValue) {
            console.log('SomeAspect is required ', this.arraydataupload)
            return
          }
        }
        this.stackfileloading = true;
        // assign aspect_data in temparrayupload
        if (!this.manageAI && !this.currenttemplate.structure_change_file_name) {
          this.temparraydataupload.forEach((itemFor) => {
            itemFor['aspect_data'] = []
          for (let j = 0; j < this.detailstemplate.aspect_data.length; j++) {
              let raw_aspect_data = {
                aspect_id: this.detailstemplate.aspect_data[j].id,
                value: "ไม่ระบุ",
                aspect_name: this.detailstemplate.aspect_data[j].aspect_name,
                aspect_type: this.detailstemplate.aspect_data[j].aspect_type
              };
              if (
                this.detailstemplate.aspect_data[j].aspect_type === 'DROPDOWN' &&
                this.detailstemplate.aspect_data[j]
                .aspect_fix_key_extra
                .length > 0
              ) {
                if (this.detailstemplate.aspect_data[j].aspect_type === "") {
                  raw_aspect_data.value = "ไม่ระบุ";
                } else if (
                  this.detailstemplate.aspect_data[j].aspect_null !== "Y"
                ) {
                  if (this.detailstemplate.aspect_data[
                    j
                  ].value === "") {
                    raw_aspect_data.value = "ไม่ระบุ";
                  } else {  
                    raw_aspect_data.value = this.detailstemplate.aspect_data[
                      j
                    ].value;
                  }
                } else {
                  if (this.detailstemplate.aspect_data[
                    j
                  ].value === "") {
                    raw_aspect_data.value = "ไม่ระบุ";
                  } else {  
                    raw_aspect_data.value = this.detailstemplate.aspect_data[
                      j
                    ].value;
                  }
                }
              } else {
                if (this.detailstemplate.aspect_data[j].aspect_null === "Y") {
                  raw_aspect_data.value = this.detailstemplate.aspect_data[j].readfilename === 'Y' ? "" : this.detailstemplate.aspect_data[ //ลบนี่
                    j
                  ].fixvalue;
                } else {
                  if (this.detailstemplate.aspect_data[
                    j
                  ].value === "") {
                    raw_aspect_data.value = "ไม่ระบุ";
                  } else {  
                    raw_aspect_data.value = this.detailstemplate.aspect_data[
                      j
                    ].value;
                  }
                }
              }
              itemFor['aspect_data'].push(raw_aspect_data)
          }
          })
        } else if (!this.manageAI && (this.currenttemplate.structure_change_file_name)) {
          console.log('dataarrayyuploaddd ', this.arraydataupload)
          //ถ้าหากมีการใช้งาน pattern filename ให้ทำการกรอง key และ value ของ aspect_data_patternfilename_template 
          this.temparraydataupload.forEach((itemFile) => {
            itemFile.aspect_data = itemFile.aspect_data_patternfilename_template.map((itemMap) => {
              let valueAspect
              if (itemMap.aspect_type === 'DROPDOWN') {
                valueAspect = itemMap.value === "" ? "ไม่ระบุ" : itemMap.value
              } else {
                valueAspect = itemMap.aspect_null === "Y" ? itemMap.readfilename === 'Y' ? "" : itemMap.fixvalue : itemMap.value === "" ? "ไม่ระบุ" : itemMap.value
              }
              return {
                aspect_id: itemMap.id,
                //value: itemMap.aspect_null === 'Y' ? itemMap.fixvalue  : itemMap.fixvalue === "" ? "ไม่ระบุ" : itemMap.fixvalue,
                value: valueAspect,
                aspect_name: itemMap.aspect_name,
                aspect_type: itemMap.aspect_type
              }
            })

          })


        }
        
      
        if (this.currenttemplate.structure_change_file_name !== '') {
          for (var i = 0; i < this.temparraydataupload.length; i++) {
            for (var j = i + 1; j < this.temparraydataupload.length; j++) {
              if (this.temparraydataupload[i].name === this.temparraydataupload[j].name && this.temparraydataupload[j].status === 'start' ) {
                this.temparraydataupload[j]["status"] = "duplicate";
                this.arraydataupload[j]["status"] = "duplicate";
                let checkDupBefore = this.temparraydataupload.slice(0, j).filter((itemFile) => itemFile.name === this.temparraydataupload[j].name)
                this.temparraydataupload[j]["unique_number"] = checkDupBefore[checkDupBefore.length - 1]['id']

              }
            }
          }
        }
        // Check duplicate temparrayupload
        this.isloadingChecking = true
        for (let i = 0; i < this.temparraydataupload.length; i++) {
          if (this.temparraydataupload[i].status === 'duplicate') {
            this.temparraydataupload[i].status = 'duplicate'
            this.temparraydataupload[i].msg = this.$t('smartinput.duplicate_upload')
            this.temparraydataupload[i].colorupload = 'warning'
            this.temparraydataupload[i].value = 0
          } else if (this.temparraydataupload[i].errorSize) {
            this.temparraydataupload[i].status = 'max size'
            this.temparraydataupload[i].msg = this.$t('smartinput.maxSizeFile')
            this.temparraydataupload[i].colorupload = 'error'
            this.temparraydataupload[i].value = 0
          } else { 
          await this.checkDuplicateMajorMinor(this.temparraydataupload[i], this.currenttemplate.id, i)
          .then(async (response) => {
            if (response.status === 'fail') {
              this.temparraydataupload[i].status = 'duplicate'
              this.temparraydataupload[i].msg = this.$t('smartinput.duplicate_upload')
              this.temparraydataupload[i].colorupload = 'warning'
              this.temparraydataupload[i].value = 0
            } else if (response.status === 'fail_checked') { 
              this.temparraydataupload[i].status = 'fail'
              this.temparraydataupload[i].msg = this.$t('uploadFile.cannotupload')
              this.temparraydataupload[i].colorupload = 'error'
              this.temparraydataupload[i].value = 99
            } else if (response.status === 'warning') { 
              this.temparraydataupload[i].status = 'warning'
              this.temparraydataupload[i].msg = response.msg
              this.temparraydataupload[i].colorupload = 'warning'
              this.temparraydataupload[i].value = 99
            } else {
              this.temparraydataupload[i].status = 'start'
            }
          })
          .catch ((err) => {
            console.log("errorr ", err)
          })
          console.log("logg fillle ", this.temparraydataupload[i])
          }
        }
        this.isloadingChecking = false

        this.checkdetailmobile = false;
        this.totalstackfile = 0;
        this.statusuploading = true;
        this.createprogress = true;
        this.stackfileloading = false

        // State ของการอัปโหลด
        // sort start
        this.temparraydataupload.sort((a, b) => {
          if (a.status === 'start' && b.status !== 'start') {
            return -1; // 'start' comes first
          } else if (a.status !== 'start' && b.status === 'start') {
            return 1; // 'start' comes first
          } else {
            return 0; // maintain relative order of non-'start' items
          }
        });
        // sort size (Start)
        let status_start = this.temparraydataupload.filter((itemStatus) => itemStatus.status === 'start' && itemStatus.size < 1073741824)
        status_start.sort((a, b) => a.size - b.size);
        // sort size (duplicate)
        let status_duplicate = this.temparraydataupload.filter((itemStatus) => itemStatus.status === 'duplicate' && itemStatus.size < 1073741824)
        status_duplicate.sort((a, b) => a.size - b.size);
        // fail checked duplicate
        let status_fail = this.temparraydataupload.filter((itemStatus) => itemStatus.status === 'fail' && itemStatus.size < 1073741824)
        // warning checked Manage AI
        let status_warning = this.temparraydataupload.filter((itemStatus) => itemStatus.status === 'warning' && itemStatus.size < 1073741824)
        // check file size more than && itemStatus.size < 1073741824
        let file_chunk = this.temparraydataupload.filter((itemStatus) => itemStatus.size >= 1073741824)
        file_chunk = file_chunk.map((item) => ({
          ...item, // คัดลอก key-value เดิมใน object
          status_chunk: true, // เพิ่มหรือปรับ key "msg"
        }));

        this.temparraydataupload = [...status_start, ...status_duplicate, ...status_warning, ...status_fail, ...file_chunk]
        console.log("tempaarrr ", this.temparraydataupload);
        // ทำการแยกไฟล์ทีมี size เกิน 1 GB ออกไป เพื่อให้ยิงเส้น chunk_file
        
        let filter_start = this.temparraydataupload.filter((itemStatus) => itemStatus.status === 'start').filter((itemFilter) => !itemFilter.status_chunk)
        if (filter_start.length > 0) {
          let first_time = false
          for (let i = 0; i < filter_start.length; i++) {
            try {
              filter_start[i].formData.append("structure_data",this.structure_data);
              filter_start[i].formData.append("user_id", this.dataUsername);
              filter_start[i].formData.append("account_id", this.dataAccountId);
              filter_start[i].formData.append("business_id",this.dataAccountActive.business_info.business_id);
              filter_start[i].formData.append("file", filter_start[i].file);
              filter_start[i].formData.append("filename", filter_start[i].name);
              filter_start[i].formData.append("template_id", this.currenttemplate.id);
              filter_start[i].formData.append("type_version", "major");
              for ( let j = 0; j < filter_start[i].aspect_data.length; j++) {
                filter_start[i].formData.append("aspect_data", JSON.stringify(filter_start[i].aspect_data[j]))
              }
              if (filter_start[i].status !== 'cancel') {
                await this.fnCheckStorage()
                let count_file = 0
                if (first_time === false) { // ยิงแค่ตัวแรกก่อน
                  await this.fnUploadExtraFirst(i).then((response) => {
                    console.log("responsee status ", response)
                    if (response.status === 'OK') {
                      first_time = true
                    }
                  })
                  
                } else {
                  if (count_file <= 5) {
                  this.fnUploadFile_V2(filter_start[i].formData, i);
                  count_file += 1;
                  } else {
                    await this.fnUploadFile_V2(filter_start[i].formData, i);
                    count_file = 0;
                  }
                }
              } else {
                if (filter_start[i].canceltoken !== null) {
                  filter_start[i].canceltoken.cancel();
                }
              }
              
            }
            catch (err) {
              console.log("errr ", err)
            }
          }
        } else {
          this.createprogress = false
        }

        
        let filterChunk = this.temparraydataupload.filter((itemFilter) => itemFilter.status_chunk && itemFilter.status === 'start')
        console.log('เสร็ตสิ้นขบวนการรร ', filterChunk)
        if (filterChunk.length > 0) {
          for (let i = 0; i < filterChunk.length; i++) {
            let index_tempa = this.temparraydataupload.findIndex((itemFind) => itemFind.id === filterChunk[i].id)
            if (['fail', 'cancel'].includes(this.temparraydataupload[index_tempa].status)) {
              continue
              return
            }
            await this.fnCheckStorage()
            if (this.userdata.remain_storage < filterChunk[i].size) {
              this.statusstorage = true;
              this.temparraydataupload[index_tempa].status = "fail";
              this.temparraydataupload[index_tempa].msg = this.$t(
                "dragdrop.yourspacenotenough"
              );
              this.temparraydataupload[index_tempa].colorupload = "error";
              this.createprogress = false;
              return
            }
            this.type_upload_reload = "major"
            await this.fn_checkfileChunck_v2(filterChunk[i], index_tempa, "major")
            .then((response) => {
              console.log('responsee ', response)
            })

            if (i ===  filterChunk.length - 1) {
              console.log("เข้าตรงนี้มั้ยยย --")
              this.createprogress = false
            }

          }
        }

      } 
      // Other ในกรณีที่ไม่มีไฟล์ 
      else {
        console.log("ทำไมมาเข้านี้หล่ะะะ", this.$v, this.detailstemplate)
        if (this.$v.$invalid) {
          this.checkdetailmobile = true;
        }
        if (this.totalstackfile === 0) {
          Toast.fire({
            icon: "error",
            title: this.$t("smartinput.pleaseselectfile"),
          });
        }
      }

    },
    // Insert file chunk
    async fnInsertFileData(datafile, i, status) {
      let auth = await gbfGenerate.generateToken();
      console.log('datafileee ', datafile);
      let payload = {
        account_id: datafile.account_id,
        business_id: datafile.business_id,
        data_type: datafile.data_type,
        department_id: datafile.department_id,
        folder_id: datafile.folder_id,
        hashtag: datafile.hashtag,
        remark: datafile.remark,
        user_id: datafile.user_id,
        file_duplicate: this.temparraydataupload[i].fileduplicate,
        folder_from_share: datafile.folder_from_share,
        file_data: datafile.file_data
      };
      if (status === "chunk") {
        payload.complete_file_chunk = {
          bucket_name: datafile.uploadChunk.bucket_name,
          object_name: datafile.uploadChunk.object_name,
          upload_id: datafile.uploadChunk.upload_id,
          parts: this.temparraydataupload[i]["parts"].sort(
            (a, b) => a.PartNumber - b.PartNumber
          ),
        };
      }
       return new Promise (async (resolve, reject) => {
        await this.axios({
        method: "POST",
        url: process.env.VUE_APP_SERVICE_UPLOAD_API + "/api/v1/insert_file_data/smartbox",
        cancelToken: this.temparraydataupload[i].canceltoken.token,
        data: payload,
        headers: { Authorization: auth.code },
      })
        .then((response) => {
          if (response.data.status === "OK") {
            // สถานะเคยอัปโหลดสำเร็จ
            this.checkstatusupload = true;
            this.temparraydataupload[i].status = "success";
            this.temparraydataupload[i].msg = this.$t(
              "uploadfile.uploadsuccess"
            );
            this.temparraydataupload[i].colorupload = "success";
            this.temparraydataupload[i].value = 100;
            resolve({status: 'insert success', msg: ''})
            
          } else {
            this.temparraydataupload[i].status = "fail";
            this.temparraydataupload[i].msg = this.$t(
              "dragdrop.cannotdetailupload"
            );
            this.temparraydataupload[i].colorupload = "error";
          }
          this.createprogress = false;
          // if (this.temparraydataupload.length === this.length_processing) {
          //   // document.querySelector("#dropzoneuploadfiles").style.display = "auto";
          //   // document.querySelector("#dropzoneuploadfiles").style.opacity = "1";
          //   this.removeEventUploadfiles();
          //   this.addEventUploadfiles();
          //   this.createprogress = false;
          // }
        })
        .catch((thrown) => {
          console.log(thrown);
          // if (this.temparraydataupload[i].status !== "cancel" && this.count_cancel === 1) {
          //   this.temparraydataupload[i].status = "fail";
          //   this.temparraydataupload[i].msg = this.$t("uploadfile.uploadfail");
          //   this.temparraydataupload[i].colorupload = "error";
          // }
          // if (this.temparraydataupload.length === this.length_processing) {
          //   // document.querySelector("#dropzoneuploadfiles").style.display = "auto";
          //   // document.querySelector("#dropzoneuploadfiles").style.opacity = "1";
          //   this.removeEventUploadfiles();
          //   this.addEventUploadfiles();
          //   this.createprogress = false;
          // }
        });
       }) 
    },

    

    

    //  เส้นอัปโหลดไฟล์ chunk
    async makeRequest_v2(method, url, i, numchunk) {
      // รับค่า blob data จาก showfileupload
      // let data = this.temparraydataupload[i]["allchunk"][numchunk]["blob"];
      let data = numchunk.blob
      // สร้าง XMLHttpRequest object
      const xhr = new XMLHttpRequest();
      const self = this;
      
      // เพิ่ม XMLHttpRequest object นี้ไปใน listxhr ของ showfileupload
      this.temparraydataupload[i]["listxhr"].push(xhr);

      // คำนวณเปอร์เซ็นต์ที่แต่ละ request จะได้รับ
      const len_file = Math.ceil(this.temparraydataupload[i]["allchunk"].length / 1);
      const chunkProgress = 100 / len_file;

      // ตัวแปรสำหรับเก็บ progress ของ chunk ปัจจุบัน
      let currentProgress = 0;

      // Return a new promise
      return new Promise(function(resolve, reject) {
        xhr.open(method, url, true);
        xhr.onabort = function() {
          reject("ERR_REQUEST_WAS_ABORTED");
        };
        xhr.upload.onprogress = (event) => {
          // console.log('eventtt progress ',event)
          if (event.lengthComputable) {
            // คำนวณเปอร์เซ็นต์ของ progress
            let percentComplete = (event.loaded / event.total) * chunkProgress;
            // อัพเดตค่า self.temparraydataupload[i]["value"] โดยใช้ค่าที่แตกต่างจาก previous progress
            self.temparraydataupload[i]["value"] += percentComplete - currentProgress;
            // อัพเดต currentProgress สำหรับ chunk ปัจจุบัน
            currentProgress = percentComplete;
          }
        };
        xhr.onload = function() {
          if (xhr.status >= 200 && xhr.status < 300) {
            let responseHeaders = xhr.getAllResponseHeaders();
            resolve({ headers: responseHeaders, data: xhr, index_parent: i, indexchunk: numchunk.PartNumber - 1});
          } else {
            reject(xhr.statusText);
          }
        };

        xhr.onerror = function() {
          if (xhr.status === 0) {
            // Handle network error (e.g., ERR_INTERNET_DISCONNECTED)
            reject("ERR_INTERNET_DISCONNECTED");
          } else {
            reject(xhr.statusText);
          }
        };

        xhr.onreadystatechange = function() {
          if (xhr.readyState === 4 && xhr.status === 0) {
            // Handle network error (e.g., ERR_INTERNET_DISCONNECTED)
            reject("ERR_INTERNET_DISCONNECTED");
          }
        };
        xhr.send(data);
      });
    },

    async fnLoopMajorMinor (type, item) {
      this.createprogress = true;
      let i = this.temparraydataupload.findIndex(
        (item) => item.id === this.reloadId
      );
      this.$v.$touch();
      if (item.status_chunk) {
        this.temparraydataupload[i].status = "start";
        this.temparraydataupload[i].msg = "";
        this.temparraydataupload[i].colorupload = "primary";
        this.temparraydataupload[i].value = 0;
        this.temparraydataupload[i].checkfailformat = false
        await this.fnCheckStorage()
        if (this.userdata.remain_storage < this.temparraydataupload[i].size) {
          this.statusstorage = true;
          this.temparraydataupload[i].status = "fail";
          this.temparraydataupload[i].msg = this.$t(
            "dragdrop.yourspacenotenough"
          );
          this.temparraydataupload[i].colorupload = "error";
          this.createprogress = false;
        }
        
        let index_tempa = this.temparraydataupload.findIndex((itemFind) => itemFind.id === this.temparraydataupload[i].id)
        this.type_upload_reload = type
        await this.fn_checkfileChunck_v2(this.temparraydataupload[i], index_tempa, type)
        .then((response) => {
            console.log("response ", response);
          })
      } else {
      // this.createprogress = true;
      // let i = this.temparraydataupload.findIndex(
      //   (item) => item.id === this.reloadId
      // );
      // this.$v.$touch();
      this.temparraydataupload[i].status = "checked";
      this.temparraydataupload[i].msg = "";
      this.temparraydataupload[i].colorupload = "primary";
      this.temparraydataupload[i].value = 0;
      this.reloadId = "";
      this.temparraydataupload[i].checkfailformat = false;
      this.temparraydataupload[i].type_version = type

      this.temparraydataupload[i].formData.set("structure_data",this.structure_data);
      this.temparraydataupload[i].formData.set("user_id", this.dataUsername);
      this.temparraydataupload[i].formData.set("account_id", this.dataAccountId);
      this.temparraydataupload[i].formData.set("business_id",this.dataAccountActive.business_info.business_id);
      this.temparraydataupload[i].formData.set("file", this.temparraydataupload[i].file);
      this.temparraydataupload[i].formData.set("filename", this.temparraydataupload[i].name);
      this.temparraydataupload[i].formData.set("template_id", this.currenttemplate.id);
      this.temparraydataupload[i].formData.set("type_version", type);
      for ( let j = 0; j < this.temparraydataupload[i].aspect_data.length; j++) {
          this.temparraydataupload[i].formData.append("aspect_data", JSON.stringify(this.temparraydataupload[i].aspect_data[j]))
        }
      // let formDataDuplicate = await this.createPayloadUpload(i);
      // this.temparraydataupload[i].formData = formDataDuplicate;

      await this.fnCheckStorage();
      let count_file = 0;
      if (count_file <= 5) {
        this.fnUploadFile_V2(this.temparraydataupload[i].formData, i);
        count_file += 1;
      } else {
        await this.fnUploadFile_V2(this.temparraydataupload[i].formData, i);
        count_file = 0;
      }
      }
    },
    // เรียกใช้ api สำหรับอัปโหลด ยังไม่ได้ใช้งาน (ไม่มีการใช้งานเส้น chunk)
    async fnUploadFile(formData, i) {
      try {
        if (this.userdata.remain_storage > this.temparraydataupload[i].size) {
          let formData = new FormData();
          formData.append("user_id", this.dataUsername);
          formData.append("account_id", this.dataAccountId);
          formData.append(
            "business_id",
            this.dataAccountActive.business_info.business_id
          );
          formData.append("file", this.temparraydataupload[i].file);
          formData.append("filename", this.temparraydataupload[i].name);
          // formData.append(
          //   "filename",
          //   this.temparraydataupload[i].name +
          //     "." +
          //     this.temparraydataupload[i].typefile
          // );
          if (this.listaspectsymbol.length > 0) {
            let splitstructure_data = this.structure_data.split("/XXXXXXXXXX");
            // formData.append("structure_data", splitstructure_data[0]);
          } else {
            // formData.append("structure_data", this.structure_data);
          }
          // formData.append("aspect_symbol_id", this.currenttemplate.aspect_symbol_id);
          formData.append("template_id", this.currenttemplate.id);
          let aspect_data_prepare = []
          for (let j = 0; j < this.detailstemplate.aspect_data.length; j++) {
            // console.log("this. curretnt ", this.currenttemplate)
            // const result_w = this.currenttemplate.structure_data.match(/{{(.*?)}}/g).map(match => match.replace(/[{}]/g, ''));
            // let findAspect = result_w.find((itemFind) => itemFind.replace(/%/g, '') === this.detailstemplate.aspect_data[j].aspect_name)
            let raw_aspect_data = {
              aspect_id: this.detailstemplate.aspect_data[j].id,
              value: "ไม่ระบุ",
              aspect_name: this.detailstemplate.aspect_data[j].aspect_name,
              // status_file_name: "N"
            };
            if (
              this.detailstemplate.aspect_data[j]
              .aspect_fix_value.length > 0
              // .aspect_fix_value !== "{}"
            ) {
              if (this.detailstemplate.aspect_data[j].aspect_type === "") {
                raw_aspect_data.value = "ไม่ระบุ";
              } else if (
                this.detailstemplate.aspect_data[j].aspect_null !== "Y"
              ) {
                if (this.detailstemplate.aspect_data[
                  j
                ].value === "") {
                  raw_aspect_data.value = "ไม่ระบุ";
                } else {  
                  raw_aspect_data.value = this.detailstemplate.aspect_data[
                    j
                  ].value;
                }
              } else {
                if (this.detailstemplate.aspect_data[
                  j
                ].value === "") {
                  raw_aspect_data.value = "ไม่ระบุ";
                } else {  
                  raw_aspect_data.value = this.detailstemplate.aspect_data[
                    j
                  ].value;
                }
              }
            } else {
              if (this.detailstemplate.aspect_data[j].aspect_null === "Y") {
                //raw_aspect_data.value = this.detailstemplate.aspect_data[ // เปิดนี่
                raw_aspect_data.value = this.detailstemplate.aspect_data[j].readfilename === 'Y' ? "" : this.detailstemplate.aspect_data[ //ลบนี่
                  j
                ].fixvalue;
              } else {
                if (this.detailstemplate.aspect_data[
                  j
                ].value === "") {
                  raw_aspect_data.value = "ไม่ระบุ";
                } else {  
                  raw_aspect_data.value = this.detailstemplate.aspect_data[
                    j
                  ].value;
                }
              }
            }
            let aspect_data = JSON.stringify(raw_aspect_data);
            formData.append("aspect_data", aspect_data);
          }
          formData.append("type_version", this.temparraydataupload[i].type_version)
          this.temparraydataupload[i].formData = formData;

          // // Check duplicated 
          this.temparraydataupload[i].formData.forEach((value, key) => {
            let jsonObject = {}
            // If the key already exists, convert it to an array or append to the existing array
            if (jsonObject.hasOwnProperty(key)) {
                if (Array.isArray(jsonObject[key])) {
                    jsonObject[key].push(value);
                } else {
                    jsonObject[key] = [jsonObject[key], value];
                }
            } else {
                jsonObject[key] = value;
            }
            console.log("Jsonobject ", jsonObject)
            //ต้องการจะหา formdata รูปแบบ object ของแต่ละอัน
            if(Object.keys(jsonObject)[0] === 'aspect_data'){
              aspect_data_prepare.push(JSON.parse(Object.values(jsonObject)[0]))
            }
          })
          this.temparraydataupload[i].aspect_data = aspect_data_prepare
          //เอา aspect data ไว้ใช้ในการส่ง aspect_data ในเส้น check dup
          await this.checkDuplicateMajorMinor(this.temparraydataupload[i], this.currenttemplate.id, i)
          .then(async (response) => {
            if (response.status === 'fail') {
              this.temparraydataupload[i].status = 'duplicate'
              this.temparraydataupload[i].msg = this.$t('smartinput.duplicate_upload')
            } else {
              this.temparraydataupload[i].status = 'start'
                  const CancelToken = this.axios.CancelToken;
              this.source = CancelToken.source();
              this.temparraydataupload[i].canceltoken = this.source;
              console.log(
                "this.temparraydataupload[i]",
                this.temparraydataupload[i]
              );
              let auth = await gbfGenerate.generateToken();
              let url =
                // this.checkbizsymbolsmartupload === true
                //   ? "/api/smart_box/v2/upload_files"
                //   :
                // "/api/smart_box/v1/upload_files";
                "/api/smart_box/v3/upload_files";
              this.axios({
                method: "POST",
                url: process.env.VUE_APP_SERVICE_UPLOAD_API + url,
                cancelToken: this.temparraydataupload[i].canceltoken.token,
                data: this.temparraydataupload[i].formData,
                headers: { Authorization: auth.code },
                onUploadProgress: (e) => {
                  if ((e.loaded / e.total) * 100 >= 95) {
                    this.temparraydataupload[i]["value"] = 95;
                    this.percentfileuploading = this.temparraydataupload[i][
                      "value"
                    ];
                    this.percentfileuploading = this.temparraydataupload[i][
                      "value"
                    ];
                  } else {
                    this.temparraydataupload[i]["value"] = parseInt(
                      (e.loaded / e.total) * 100
                    );
                    this.percentfileuploading = this.temparraydataupload[i][
                      "value"
                    ];
                    this.percentfileuploading = this.temparraydataupload[i][
                      "value"
                    ];
                  }
                },
              })
                .then((response) => {
                  if (response.data.status === "OK") {
                    // สถานะเคยอัปโหลดสำเร็จ
                    this.checkstatusupload = true;
                    this.temparraydataupload[i].status = "success";
                    this.temparraydataupload[i].msg = this.$t(
                      "uploadfile.uploadsuccess"
                    );
                    this.temparraydataupload[i].colorupload = "success";
                    this.temparraydataupload[i].value = 100;
                    this.countupload += 1;
                    // let payload = {
                    //   data_id: response.data.data.id,
                    //   data_type: "file",
                    //   user_id: this.dataUsername,
                    //   account_id: this.dataAccountId,
                    //   aspect_data: [],
                    // };
                    // if (this.checkbizsymbolsmartupload === false) {
                    // this.payloadInsertAspactData(payload, i);
                    // } else {
                    //   // สถานะเคยอัปโหลดสำเร็จ
                    //   this.checkstatusupload = true;
                    //   this.temparraydataupload[i].status = "success";
                    //   this.temparraydataupload[i].msg = this.$t(
                    //     "uploadfile.uploadsuccess"
                    //   );
                    //   this.temparraydataupload[i].colorupload = "success";
                    //   this.temparraydataupload[i].value = 100;
                    //   this.countupload += 1;
                    // }
                  } else if (
                    response.data.errorMessage === "Value from file not same dropdown"
                  ) {
                    this.temparraydataupload[i].status = "fail";
                    this.temparraydataupload[i].msg = this.$t(
                      "smartinput.valuesamedropdown"
                    );
                    this.temparraydataupload[i].colorupload = "error";
                    this.temparraydataupload[i].checkfailformat = true;
                  } else if (
                    response.data.errorMessage === "Pettern file name wrong"
                  ) {
                    this.temparraydataupload[i].status = "fail";
                    this.temparraydataupload[i].msg = this.$t(
                      "smartinput.yourfileformatwrong"
                    );
                    this.temparraydataupload[i].colorupload = "error";
                    this.temparraydataupload[i].checkfailformat = true;
                  } else if (
                    response.data.errorMessage === "Your space not enough"
                  ) {
                    this.temparraydataupload[i].status = "fail";
                    this.temparraydataupload[i].msg = this.$t(
                      "dragdrop.yourspacenotenough"
                    );
                    this.temparraydataupload[i].colorupload = "error";
                  } else if (
                    response.data.errorMessage === "File Size More Than 5 GB"
                  ) {
                    this.temparraydataupload[i].status = "fail";
                    this.temparraydataupload[i].msg = this.$t(
                      "dragdrop.morefivegb"
                    );
                    this.temparraydataupload[i].colorupload = "error";
                  } else {
                    this.temparraydataupload[i].status = "fail";
                    this.temparraydataupload[i].msg = this.$t(
                      "dragdrop.cannotdetailupload"
                    );
                    this.temparraydataupload[i].colorupload = "error";
                  }

                  if (this.temparraydataupload.length === this.length_processing) {
                    this.removeEventUploadfiles();
                    this.addEventUploadfiles();
                    this.createprogress = false;
                  }
                })
                .catch((thrown) => {
                  console.log(thrown);
                  if (this.temparraydataupload[i].status !== "cancel") {
                    this.temparraydataupload[i].status = "fail";
                    this.temparraydataupload[i].msg = this.$t(
                      "uploadfile.uploadfail"
                    );
                    this.temparraydataupload[i].colorupload = "error";
                  } else {
                    this.temparraydataupload[i].status = "cancel";
                    this.temparraydataupload[i].msg = this.$t(
                      "dragdrop.cancelupload"
                    );
                    this.temparraydataupload[i].colorupload = "error";
                  }
                  if (this.temparraydataupload.length === this.length_processing) {
                    this.removeEventUploadfiles();
                    this.addEventUploadfiles();
                    this.createprogress = false;
                  }
                });
            }
          })
          .catch ((err) => {
            console.log("errorr ", err)
          })
          this.removeEventUploadfiles();
          this.addEventUploadfiles();
          this.createprogress = false;
          // // 

        } else {
          this.statusstorage = true;
          this.temparraydataupload[i].status = "fail";
          this.temparraydataupload[i].msg = this.$t(
            "dragdrop.yourspacenotenough"
          );
          this.temparraydataupload[i].colorupload = "error";
          this.createprogress = false;
        }
      } catch (err) {
        console.log("error", err);
        if (this.temparraydataupload[i].status !== "cancel") {
          this.temparraydataupload[i].status = "fail";
          this.temparraydataupload[i].msg = this.$t("uploadfile.uploadfail");
          this.temparraydataupload[i].colorupload = "error";
        } else {
          this.temparraydataupload[i].status = "cancel";
          this.temparraydataupload[i].msg = this.$t("dragdrop.cancelupload");
          this.temparraydataupload[i].colorupload = "error";
        }
        if (this.temparraydataupload.length === this.length_processing) {
          this.removeEventUploadfiles();
          this.addEventUploadfiles();
          this.createprogress = false;
        }
      }
    },
    async fnUploadFile_V2 (formData, i) {
      try {
        console.log("templatedaa ีupload foorllop ", this.temparraydataupload[i])
        if (this.userdata.remain_storage > this.temparraydataupload[i].size) {
          this.temparraydataupload[i].status = 'start'
          const CancelToken = this.axios.CancelToken;
          this.source = CancelToken.source();
          this.temparraydataupload[i].canceltoken = this.source;
          let auth = await gbfGenerate.generateToken();
          let url = "/api/smart_box/v3/upload_files";
          this.axios({
                method: "POST",
                url: process.env.VUE_APP_SERVICE_UPLOAD_API + url,
                cancelToken: this.temparraydataupload[i].canceltoken.token,
                data: this.temparraydataupload[i].formData,
                headers: { Authorization: auth.code },
                onUploadProgress: (e) => {
                  if ((e.loaded / e.total) * 100 >= 95) {
                    this.temparraydataupload[i]["value"] = 95;
                    this.percentfileuploading = this.temparraydataupload[i][
                      "value"
                    ];
                    this.percentfileuploading = this.temparraydataupload[i][
                      "value"
                    ];
                  } else {
                    this.temparraydataupload[i]["value"] = parseInt(
                      (e.loaded / e.total) * 100
                    );
                    this.percentfileuploading = this.temparraydataupload[i][
                      "value"
                    ];
                    this.percentfileuploading = this.temparraydataupload[i][
                      "value"
                    ];
                  }
                },
              })
                .then((response) => {
                  if (response.data.status === "OK") {
                    // สถานะเคยอัปโหลดสำเร็จ
                    this.checkstatusupload = true;
                    this.temparraydataupload[i].status = "success";
                    this.temparraydataupload[i].msg = this.$t(
                      "uploadfile.uploadsuccess"
                    );
                    this.temparraydataupload[i].colorupload = "success";
                    this.temparraydataupload[i].value = 100;
                    this.countupload += 1;
                  } else if (
                    response.data.errorMessage === "Value from file not same dropdown"
                  ) {
                    this.temparraydataupload[i].status = "fail";
                    this.temparraydataupload[i].msg = this.$t(
                      "smartinput.valuesamedropdown"
                    );
                    this.temparraydataupload[i].colorupload = "error";
                    this.temparraydataupload[i].checkfailformat = true;
                  } else if (
                    response.data.errorMessage === "Pettern file name wrong"
                  ) {
                    this.temparraydataupload[i].status = "fail";
                    this.temparraydataupload[i].msg = this.$t(
                      "smartinput.yourfileformatwrong"
                    );
                    this.temparraydataupload[i].colorupload = "error";
                    this.temparraydataupload[i].checkfailformat = true;
                  } else if (
                    response.data.errorMessage === "Your space not enough"
                  ) {
                    this.temparraydataupload[i].status = "fail";
                    this.temparraydataupload[i].msg = this.$t(
                      "dragdrop.yourspacenotenough"
                    );
                    this.temparraydataupload[i].colorupload = "error";
                  } else if (
                    response.data.errorMessage === "File Size More Than 5 GB"
                  ) {
                    this.temparraydataupload[i].status = "fail";
                    this.temparraydataupload[i].msg = this.$t(
                      "dragdrop.morefivegb"
                    );
                    this.temparraydataupload[i].colorupload = "error";
                  } else {
                    this.temparraydataupload[i].status = "fail";
                    this.temparraydataupload[i].msg = this.$t(
                      "dragdrop.cannotdetailupload"
                    );
                    this.temparraydataupload[i].colorupload = "error";
                  }

                  if (this.temparraydataupload.length === this.length_processing) {
                    this.removeEventUploadfiles();
                    this.addEventUploadfiles();
                    this.createprogress = false;
                    console.log('clear selected reuploaddd ')
                    this.selected_reupload = []
                  }
                  if (!this.length_uploading >= 1) {
                    console.log('clear selected reuploaddd ')
                    this.selected_reupload = []
                  }
                })
                .catch((thrown) => {
                  console.log("Cancelll uploaddd")
                  console.log(thrown);
                  if (this.temparraydataupload[i].status !== "cancel") {
                    this.temparraydataupload[i].status = "fail";
                    this.temparraydataupload[i].msg = this.$t(
                      "uploadfile.uploadfail"
                    );
                    this.temparraydataupload[i].colorupload = "error";
                  } else {
                    this.temparraydataupload[i].status = "cancel";
                    this.temparraydataupload[i].msg = this.$t(
                      "dragdrop.cancelupload"
                    );
                    this.temparraydataupload[i].colorupload = "error";
                  }
                  if (this.temparraydataupload.length === this.length_processing) {
                    this.removeEventUploadfiles();
                    this.addEventUploadfiles();
                    this.createprogress = false;
                    this.selected_reupload = []
                  }
                });



        } else {
          this.statusstorage = true;
          this.temparraydataupload[i].status = "fail";
          this.temparraydataupload[i].msg = this.$t(
            "dragdrop.yourspacenotenough"
          );
          this.temparraydataupload[i].colorupload = "error";
          this.createprogress = false;
        }
      } catch (err) {
        console.log("Errorrr ", err)
        // if (this.temparraydataupload[i].status !== "cancel") {
        //   this.temparraydataupload[i].status = "fail";
        //   this.temparraydataupload[i].msg = this.$t("uploadfile.uploadfail");
        //   this.temparraydataupload[i].colorupload = "error";
        // } else {
        //   this.temparraydataupload[i].status = "cancel";
        //   this.temparraydataupload[i].msg = this.$t("dragdrop.cancelupload");
        //   this.temparraydataupload[i].colorupload = "error";
        // }
        // if (this.temparraydataupload.length === this.length_processing) {
        //   this.removeEventUploadfiles();
        //   this.addEventUploadfiles();
        //   this.createprogress = false;
        // }
      }
    },

   async fnuploadChunks3 (datafile, i, data_detail) {
    return new Promise (async (resolve, reject) => {
    // ต้องการแบ่งกรุ๊ป chunk ก่อนน กรุุํปไม่เกิน 5
    
     let chunkeyFile =  this.temparraydataupload[i]["allchunk"].map((_, B) => (B % 5 === 0 ? this.temparraydataupload[i]["allchunk"].slice(B, B + 5) : null)) // สร้างกลุ่ม
    .filter((chunk) => chunk); // ลบค่าที่เป็น null
    this.temparraydataupload[i]['chunnky'] = chunkeyFile
      console.log(this.temparraydataupload[i]['chunnky']);
    let group_chunky_file = []
    for (var k = 0; k < this.temparraydataupload[i]['chunnky'].length; k++) {
      console.log(this.temparraydataupload[i]['chunnky'][k]);

      const promises_presign = this.temparraydataupload[i]['chunnky'][k].map((url) =>
        this.fnGetPresignChunk_v2(
          datafile,
          i,
          url["PartNumber"],
          url
          )
        )
        const results_presigns = await Promise.allSettled(promises_presign);
        console.log("resolveee presign ", results_presigns);
        if (results_presigns.every((itemStatus)=> itemStatus.status === 'rejected')) {
          console.log('why heree');
          resolve({status: 'cancel upload', msg: '', datafile: ''})
          break;
        }
        
        if (results_presigns.every((itemStatus)=> itemStatus.status === 'fulfilled')) { // อันนี้ของ Presign Chunk
          const promises = results_presigns.map((url) =>
              this.makeRequest_v2(
                "PUT",
                url.value.url,
                i,
                url.value.detail_file
              )
            );

            const results = await Promise.allSettled(promises);
            if (results.every((itemStatus)=> itemStatus.status === 'rejected')) {
              resolve({status: 'cancel upload', msg: '', datafile: ''})
              break;
            }
            if (results.some((itemStatus) => itemStatus.status === 'rejected' )) {
              resolve({status: 'cancel upload', msg: '', datafile: ''})
              // ต้องทำการเก็บ some error ของไฟล์ chunkkk เพื่อที่จะทำการอัปโหลดครั้งค่อไป
              break;
            }
            console.log("resolve makerequest s3 ", results)
            results.forEach((result, index) => {
              console.log("resulllt promisee ", result);
              if (result.status === "fulfilled") {
                if (result.value.data.status === 200) {
                  let headers =  this.parseResponseHeaders(result.value.headers);
                  headers.etag = headers.etag.replace('"', "");
                  headers.etag = headers.etag.replace('"\ ', "");
                  headers.etag = headers.etag.replace('"', "");
                  let datachunk = {
                    PartNumber: this.temparraydataupload[i]["allchunk"][result.value.indexchunk][
                      "PartNumber"
                    ],
                    ETag: headers.etag,
                  };
                  this.temparraydataupload[i]["parts"].push(datachunk);
                  this.temparraydataupload[i]["allchunk"][result.value.indexchunk]["status"] = "Success"
                  let countchunksuccess = this.temparraydataupload[i]["allchunk"].filter((item) => item.status === "Success").length;
                  if (
                    countchunksuccess === this.temparraydataupload[i]["allchunk"].length
                  ) {
                    console.log("HELLO Success");
                    resolve({status: 'upload success', msg: '', datafile: ''})
                  } else {
                    console.log("Not success");
                  }
                }
                // console.log(`Group ${i + 1}, API ${index + 1} success:`, result.value);
              } else {
                // console.error(`Group ${i + 1}, API ${index + 1} failed:`, result.reason);
              }
            });
        } else if (results_presigns.some((itemStatus) => itemStatus.status === 'rejected'))  { // อันนี้ของ Presign Chunk ที่พัง
          console.log("HELLO")
        }

    }
    // console.log(group_chunky_file);
    // for (let h = 0; h < group_chunky_file.length; h++) {
    //   console.log(`Starting group ${h + 1}`);

    //   // สร้าง Promise สำหรับ API ในกลุ่ม
    //   const promises = group_chunky_file[h].map((url) =>
    //     // fetch(url)
    //     //   .then((response) => response.json())
    //     //   .catch((error) => ({ error: error.message }))
    //       this.makeRequest_v2(
    //         "PUT",
    //         url.url,
    //         i,
    //         url.detail_chunk
    //       )
    //   );

    //   // รอให้ Promise ทั้งหมดในกลุ่มเสร็จ
    //   const results = await Promise.allSettled(promises);

    //   // ประมวลผลผลลัพธ์ของแต่ละ API
    //   console.log('resulllr ', results);
    //   if (results.every((itemStatus)=> itemStatus.status === 'rejected')) {
    //     resolve({status: 'cancel upload', msg: '', datafile: ''})
    //     break;
    //   }
    //   results.forEach((result, index) => {
    //     console.log("resulllt promisee ", result);
    //     if (result.status === "fulfilled") {
    //       if (result.value.data.status === 200) {
    //         let headers =  this.parseResponseHeaders(result.value.headers);
    //         headers.etag = headers.etag.replace('"', "");
    //         headers.etag = headers.etag.replace('"\ ', "");
    //         headers.etag = headers.etag.replace('"', "");
    //         let datachunk = {
    //           PartNumber: this.temparraydataupload[i]["allchunk"][result.value.indexchunk][
    //             "PartNumber"
    //           ],
    //           ETag: headers.etag,
    //         };
    //         this.temparraydataupload[i]["parts"].push(datachunk);
    //         this.temparraydataupload[i]["allchunk"][result.value.indexchunk]["status"] = "Success"
    //         let countchunksuccess = this.temparraydataupload[i]["allchunk"].filter((item) => item.status === "Success").length;
    //         if (
    //           countchunksuccess === this.temparraydataupload[i]["allchunk"].length
    //         ) {
    //           console.log("HELLO Success");
    //           resolve({status: 'upload success', msg: '', datafile: ''})
    //         } else {
    //           console.log("Not success");
    //         }
    //       }
    //       // console.log(`Group ${i + 1}, API ${index + 1} success:`, result.value);
    //     } else {
    //       // console.error(`Group ${i + 1}, API ${index + 1} failed:`, result.reason);
    //     }
    //   });

    //   console.log(`Finished group ${i + 1}`);
    // }
    })
   },

    async fn_uploadFileS3_nochunk(datafile, i) {
      console.log('datafille ', datafile)
      let auth = await gbfGenerate.generateToken();
      const formData = new FormData();
      formData.append("policy", datafile.presigned_url.fields.policy);
      formData.append("signature", datafile.presigned_url.fields.signature);
      formData.append(
        "AWSAccessKeyId",
        datafile.presigned_url.fields.AWSAccessKeyId
      );
      formData.append("key", datafile.presigned_url.fields.key);
      formData.append("file", this.temparraydataupload[i].file);
      return  new Promise((resolve, reject) => {
        this.axios({
        method: "POST",
        url: datafile.presigned_url.url,
        cancelToken: this.temparraydataupload[i].canceltoken.token,
        data: formData,
        headers: {
          Authorization: auth.code,
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (e) => {
          if ((e.loaded / e.total) * 100 >= 95) {
            this.temparraydataupload[i]["value"] = 99;
            this.percentfileuploading = this.temparraydataupload[i][
              "value"
            ];
            this.percentfileuploading = this.temparraydataupload[i][
              "value"
            ];
          } else {
            this.temparraydataupload[i]["value"] = parseInt(
              (e.loaded / e.total) * 100
            );
            this.percentfileuploading = this.temparraydataupload[i]["value"];
            this.percentfileuploading = this.temparraydataupload[i]["value"];
          }
        },
      })
        .then(async (response) => {
          if (response.status === 204) {
            this.temparraydataupload[i].status = "wait";
            resolve({status: 'success', msg: ''})
            // return {status: 'success', msg: ''}
          } else {
            this.temparraydataupload[i].status = "fail";
            this.temparraydataupload[i].msg = this.$t(
              "dragdrop.cannotdetailupload"
            );
            this.temparraydataupload[i].colorupload = "error";
          }
          
        })
        .catch((thrown) => {
          console.log(thrown);
          if (this.temparraydataupload[i].status !== "cancel" && this.count_cancel === 1) {
            this.temparraydataupload[i].status = "fail";
            this.temparraydataupload[i].msg = this.$t("uploadfile.uploadfail");
            this.temparraydataupload[i].colorupload = "error";
          }
          if (this.temparraydataupload.length === this.length_processing) {
            this.removeEventUploadfiles();
            this.addEventUploadfiles();
            this.createprogress = false;
          }
        });
      
      }) 
    },


    async fnUploadExtraFirst (i) {
      return new Promise(async (resolve, reject) => {
        try {
          if (this.userdata.remain_storage > this.temparraydataupload[i].size) {
          this.temparraydataupload[i].status = 'start'
          const CancelToken = this.axios.CancelToken;
          this.temparraydataupload[i].canceltoken = CancelToken.source();
          let auth = await gbfGenerate.generateToken();
          let url = "/api/smart_box/v3/upload_files";
          console.log("this. template ", this.temparraydataupload)
          this.axios({
                method: "POST",
                url: process.env.VUE_APP_SERVICE_UPLOAD_API + url,
                cancelToken: this.temparraydataupload[i].canceltoken.token,
                data: this.temparraydataupload[i].formData,
                headers: { Authorization: auth.code },
                onUploadProgress: (e) => {
                  if ((e.loaded / e.total) * 100 >= 95) {
                    this.temparraydataupload[i]["value"] = 95;
                    this.percentfileuploading = this.temparraydataupload[i][
                      "value"
                    ];
                    this.percentfileuploading = this.temparraydataupload[i][
                      "value"
                    ];
                  } else {
                    this.temparraydataupload[i]["value"] = parseInt(
                      (e.loaded / e.total) * 100
                    );
                    this.percentfileuploading = this.temparraydataupload[i][
                      "value"
                    ];
                    this.percentfileuploading = this.temparraydataupload[i][
                      "value"
                    ];
                  }
                },
              })
                .then((response) => {
                  if (response.data.status === "OK") {
                    // สถานะเคยอัปโหลดสำเร็จ
                    this.checkstatusupload = true;
                    this.temparraydataupload[i].status = "success";
                    this.temparraydataupload[i].msg = this.$t(
                      "uploadfile.uploadsuccess"
                    );
                    this.temparraydataupload[i].colorupload = "success";
                    this.temparraydataupload[i].value = 100;
                    this.countupload += 1;
                  } else if (
                    response.data.errorCode  === "ER509"
                  ) { 
                    this.temparraydataupload[i].status = "warning";
                    this.temparraydataupload[i].msg =  this.$t('default') === 'en' ?  `No Found ${response.data.errorMessage}` : `ไม่พบเอกสาร ${response.data.errorMessage} ในการอ้างอิง`  ;
                    this.temparraydataupload[i].colorupload = "warning";
                  } else if (
                    response.data.errorMessage === "Value from file not same dropdown"
                  ) {
                    this.temparraydataupload[i].status = "fail";
                    this.temparraydataupload[i].msg = this.$t(
                      "smartinput.valuesamedropdown"
                    );
                    this.temparraydataupload[i].colorupload = "error";
                    this.temparraydataupload[i].checkfailformat = true;
                  } else if (
                    response.data.errorMessage === "Pettern file name wrong"
                  ) {
                    this.temparraydataupload[i].status = "fail";
                    this.temparraydataupload[i].msg = this.$t(
                      "smartinput.yourfileformatwrong"
                    );
                    this.temparraydataupload[i].colorupload = "error";
                    this.temparraydataupload[i].checkfailformat = true;
                  } else if (
                    response.data.errorMessage === "Your space not enough"
                  ) {
                    this.temparraydataupload[i].status = "fail";
                    this.temparraydataupload[i].msg = this.$t(
                      "dragdrop.yourspacenotenough"
                    );
                    this.temparraydataupload[i].colorupload = "error";
                  } else if (
                    response.data.errorMessage === "File Size More Than 5 GB"
                  ) {
                    this.temparraydataupload[i].status = "fail";
                    this.temparraydataupload[i].msg = this.$t(
                      "dragdrop.morefivegb"
                    );
                    this.temparraydataupload[i].colorupload = "error";
                  } else {
                    this.temparraydataupload[i].status = "fail";
                    this.temparraydataupload[i].msg = this.$t(
                      "dragdrop.cannotdetailupload"
                    );
                    this.temparraydataupload[i].colorupload = "error";
                  }

                  if (this.temparraydataupload.filter((itemStatus) => itemStatus.status === 'start').length === 0) {
                    this.removeEventUploadfiles();
                    this.addEventUploadfiles();
                    this.createprogress = false;
                  }
                  resolve({status: 'OK', msg: 'Upload first success'})
                })
                .catch((thrown) => {
                  console.log(thrown);
                  if (this.temparraydataupload[i].status !== "cancel") {
                    this.temparraydataupload[i].status = "fail";
                    this.temparraydataupload[i].msg = this.$t(
                      "uploadfile.uploadfail"
                    );
                    this.temparraydataupload[i].colorupload = "error";
                  } else {
                    this.temparraydataupload[i].status = "cancel";
                    this.temparraydataupload[i].msg = this.$t(
                      "dragdrop.cancelupload"
                    );
                    this.temparraydataupload[i].colorupload = "error";
                  }
                  console.log("templateee cancel ", this.temparraydataupload)
                  if (this.temparraydataupload.filter((itemStatus) => itemStatus.status === 'start').length === 0) {
                    this.removeEventUploadfiles();
                    this.addEventUploadfiles();
                    this.createprogress = false;
                  }
                  resolve({status: 'OK', msg: 'Upload first success'})
                });
            } else {
              this.statusstorage = true;
              this.temparraydataupload[i].status = "fail";
              this.temparraydataupload[i].msg = this.$t(
                "dragdrop.yourspacenotenough"
              );
              this.temparraydataupload[i].colorupload = "error";
                  if (this.temparraydataupload.filter((itemStatus) => itemStatus.status === 'start').length === 0) {
                    this.removeEventUploadfiles();
                    this.addEventUploadfiles();
                    this.createprogress = false;
                  }
              resolve({status: 'OK', msg: 'Upload first success'})
            }
        } catch (err) {
          if (this.temparraydataupload.filter((itemStatus) => itemStatus.status === 'start').length === 0) {
            this.removeEventUploadfiles();
            this.addEventUploadfiles();
            this.createprogress = false;
          }
          resolve({status: 'OK', msg: 'Upload first success'})
        }
      })
      
    },

    async fnGetPresignChunk_v2(datafile, i, partnumber, detail_chunk) {
      return new Promise(async (resolve, reject) => {
      try {
        let payload = {
          bucket_name: datafile.uploadChunk.bucket_name,
          object_name: datafile.uploadChunk.object_name,
          upload_id: datafile.uploadChunk.upload_id,
          business_id: datafile.business_id,
          part_number: partnumber,
        };
        let auth = await gbfGenerate.generateToken();
        let result = await this.axios({
          method: "POST",
          url:
            process.env.VUE_APP_SERVICE_UPLOAD_API +
            "/api/v1/generate_presigned_url/upload/chunks/smartbox",
          data: payload,
          headers: { Authorization: auth.code },
          onUploadProgress: (e) => {},
        });
        if (result.data.status === "OK") {
          resolve({ status: 'OK', url: result.data.data.url, detail_file: detail_chunk })
          // return result.data.data.url;
        } else if (result.data.errorMessage === "Your space not enough") {
          this.temparraydataupload[i].status = "fail";
          this.temparraydataupload[i].msg = this.$t(
            "dragdrop.yourspacenotenough"
          );
          this.temparraydataupload[i].colorupload = "error";
          // this.chunkwaiting = [];
          this.checkopenchunk = false;
          return "Your space not enough";
        } else if (result.data.errorMessage === "File Size More Than 10 GB") {
          this.temparraydataupload[i].status = "fail";
          this.temparraydataupload[i].msg = this.$t("dragdrop.morefivegb");
          this.temparraydataupload[i].colorupload = "error";
          // this.chunkwaiting = [];
          this.checkopenchunk = false;
          return "File Size More Than 10 GB";
        } else {
          return undefined;
        }
      } catch (error) {
        console.log(error);
        // if (this.temparraydataupload[i].status !== "cancel" && this.count_cancel === 1) {
        //   this.temparraydataupload[i].status = "fail";
        //   this.temparraydataupload[i].msg = this.$t("uploadfile.uploadfail");
        //   this.temparraydataupload[i].colorupload = "error";
        //   this.checkopenchunk = false;
        // } else {
        //   return undefined;
        // }
        // if (this.temparraydataupload.length === this.length_processing) {
        //   this.removeEventUploadfiles();
        //   this.addEventUploadfiles();
        //   this.createprogress = false;
        //   this.checkopenchunk = false;
        // }
      }

      })
    },

    async create_chunk_new(item) {
      let chunck_file = []
      var size = 1073741824;
      // var size = 104857600;
      var chunks = 0;
      chunks = Math.ceil(item.size / size);
      for (let i = 0; i < chunks; i++) {
        let payload_blob = {
          status: "start",
          blob: item.file.slice(
            i * size,
            Math.min(i * size + size, item.size)
            // "text/plain"
          ),
          PartNumber: i + 1,
          parts: {},
          id: item.id
        };
        chunck_file.push(payload_blob);
      }
      return chunck_file
    },
    generate_uuid(_index) {
      let myuuid = "";
      myuuid = uuidv4();
      this.temparraydataupload[_index]["chunkkey"] = myuuid;
    },



    async fnUploadExtraReload (reloadID) {
      console.log("reoloadd id ", reloadID)
      let i = this.temparraydataupload.findIndex((itemFind) => itemFind.id === reloadID)

      await this.checkDuplicateMajorMinor(this.temparraydataupload[i], this.currenttemplate.id, i)
          .then(async (response) => {
            if (response.status === 'fail') {
              this.temparraydataupload[i].status = 'duplicate'
              this.temparraydataupload[i].msg = this.$t('smartinput.duplicate_upload')
              this.temparraydataupload[i].checkfailformat = false;
              this.temparraydataupload[i].colorupload = 'warning'
            } else if (response.status === 'fail_checked') { 
              this.temparraydataupload[i].status = 'fail'
              this.temparraydataupload[i].msg = this.$t('uploadFile.cannotupload')
              this.temparraydataupload[i].colorupload = 'error'
              this.temparraydataupload[i].checkfailformat = false;
              this.temparraydataupload[i].value = 99
            } else if (response.status === 'warning') { 
              this.temparraydataupload[i].status = 'warning'
              this.temparraydataupload[i].msg = response.msg
              this.temparraydataupload[i].colorupload = 'warning'
              this.temparraydataupload[i].value = 99
            } else {
              console.log("checkkked  ", this.temparraydataupload[i])
              this.temparraydataupload[i].checkfailformat = false 
              this.fnUploadFile_V2(null, i)
            }
          })
          .catch ((err) => {
            console.log("errorr ", err)
          })
    },

    
    


    async payloadInsertAspactData(payload, index) {
      try {
        for (let i = 0; i < this.detailstemplate.aspect_data.length; i++) {
          let aspect_data = {};
          if (this.detailstemplate.aspect_data[i].status_value === "Y") {
            let value = this.changeDateFormat(
              this.detailstemplate.aspect_data[i]
            );
            if (this.detailstemplate.aspect_data[i].aspect_type === "DATE") {
              this.detailstemplate.aspect_data[i].aspect_null === "Y"
                ? (this.detailstemplate.aspect_data[i].fixvalue = value)
                : (this.detailstemplate.aspect_data[i].value = value);
            }
            aspect_data = {
              aspect_id: this.detailstemplate.aspect_data[i].aspect_id,
              value:
                this.detailstemplate.aspect_data[i].aspect_null === "Y"
                  ? this.detailstemplate.aspect_data[i].aspect_type ===
                    "DROPDOWN"
                    ? this.detailstemplate.aspect_data[i].value
                    : this.detailstemplate.aspect_data[i].fixvalue
                  : this.detailstemplate.aspect_data[i].value,
            };
          }
          payload.aspect_data.push(aspect_data);
          if (this.detailstemplate.aspect_data.length === i + 1) {
            await this.callInsertAspactData(payload, index);
          }
        }
      } catch (err) {
        console.log("error", err);
      }
    },
    async callInsertAspactData(payload, i) {
      try {
        let auth = await gbfGenerate.generateToken();
        this.axios({
          method: "POST",
          url:
            process.env.VUE_APP_SERVICE_UPLOAD_API +
            "/api/v1/smart_box/insert_aspect_data",
          data: payload,
          headers: { Authorization: auth.code },
        })
          .then((response) => {
            if (response.data.status === "OK") {
              // สถานะเคยอัปโหลดสำเร็จ
              this.checkstatusupload = true;
              this.temparraydataupload[i].status = "success";
              this.temparraydataupload[i].msg = this.$t(
                "uploadfile.uploadsuccess"
              );
              this.temparraydataupload[i].colorupload = "success";
              this.temparraydataupload[i].value = 100;
              this.countupload += 1;
            } else {
              this.temparraydataupload[i].status = "fail";
              this.temparraydataupload[i].msg = this.$t(
                "dragdrop.cannotdetailupload"
              );
              this.temparraydataupload[i].colorupload = "error";
            }

            if (this.temparraydataupload.length === this.length_processing) {
              this.removeEventUploadfiles();
              this.addEventUploadfiles();
              this.createprogress = false;
            }
          })
          .catch((thrown) => {
            console.log(thrown);
            if (this.temparraydataupload[i].status !== "cancel") {
              this.temparraydataupload[i].status = "fail";
              this.temparraydataupload[i].msg = this.$t(
                "uploadfile.uploadfail"
              );
              this.temparraydataupload[i].colorupload = "error";
            }
            if (this.temparraydataupload.length === this.length_processing) {
              this.removeEventUploadfiles();
              this.addEventUploadfiles();
              this.createprogress = false;
            }
          });
      } catch (err) {
        console.log("error", err);
      }
    },
    // เช็คพื้นที่ข้อมูล
    async fnCheckStorage() {
      try {
        let payload = {
          account_id: this.dataAccountId,
          convert_storage: "True",
        };
        let auth = await gbfGenerate.generateToken();
        let response = await this.axios.post(
          process.env.VUE_APP_SERVICE_AUTHORIZE_BUSINESS_CHECK_STORAGE +
            "/api/check_used_storage",
          payload,
          { headers: { Authorization: auth.code } }
        );
        if (response.data.status === "OK") {
          let remain = await sizeDataConverter.convertStorageToByte(
            response.data.result[0].remain_storage
          );
          this.userdata.remain_storage = remain;
          console.log("remainnn storagee ", this.userdata.remain_storage)
        } else {
          console.log("res", response);
        }
      } catch (err) {
        console.log("err", err);
      }
    },
    // สำหรับยกเลิกการอัปโหลดของ mobile
    cancelUpload(i) {
      this.temparraydataupload[i].status = "cancel";
      this.temparraydataupload[i].msg = this.$t("dragdrop.cancelupload");
      this.temparraydataupload[i].colorupload = "error";
      if (this.temparraydataupload[i].canceltoken !== null) {
        this.temparraydataupload[i].canceltoken.cancel();
      }
      
    },
    cacelUpload_v2 (i) {
      // i คือ index pinter
      if (this.temparraydataupload[i].canceltoken !== null) {
        this.temparraydataupload[i].canceltoken.cancel();
      }
      this.temparraydataupload[i].status = "cancel";
      this.temparraydataupload[i].msg = this.$t("smartinput.cancelupload");
      this.temparraydataupload[i].colorupload = "error";
      // if (this.temparraydataupload[i].canceltoken !== null) {
      //   this.temparraydataupload[i].canceltoken.cancel();
      // }
      if (this.temparraydataupload[i]["listxhr"].length > 0) {
        const xhrList = this.temparraydataupload[i]["listxhr"];
        xhrList.forEach(xhr => xhr.abort());
      }
    },
    // ฟังก์ชันเช็คไฟล์ซ้ำ (ไม่ได้ใช้งาน)
    async checkDuplicateData(name, folder_id) {
      let payload = {
        folder_id: folder_id,
        data_type: "file",
        data_name: name,
      };
      let auth = await gbfGenerate.generateToken();
      try {
        let response = await this.axios({
          method: "POST",
          url:
            process.env.VUE_APP_SERVICE_UPLOAD_API +
            "/api/v1/check_duplicate_data",
          data: payload,
          headers: { Authorization: auth.code },
        });
        if (response.data.status === "OK") {
          if (response.data.message === "duplicate filename") {
            return new Promise(async (resolve, reject) => {
              resolve({
                status: "duplicate",
                msg: response.data.message,
              });
            });
          } else {
            return new Promise(async (resolve, reject) => {
              resolve({
                status: "upload success",
                msg: response.data.message,
              });
            });
          }
        } else {
          return new Promise(async (resolve, reject) => {
            resolve({
              status: "upload denied",
              msg: response.data.errorMessage,
            });
          });
        }
      } catch (err) {
        return new Promise(async (resolve, reject) => {
          resolve({
            status: "upload denied",
            msg: err,
          });
        });
      }
    },
    // เช็คไฟล์ซ้ำ major minor
    async checkDuplicateMajorMinor (filedetail, template_id, i) {
      console.log("hello check dup ", filedetail)
      if(filedetail.status === 'checked') {
        return {status: "start", msg: ""}
      } else {
      let formData = new FormData()
      formData.append("user_id", this.dataUsername)
      formData.append("account_id", this.dataAccountId)
      formData.append("business_id", this.dataAccountActive.business_info.business_id)
      // formData.append("file", filedetail.file)
      formData.append("filename", `${typeof(filedetail.name) === 'object' ? filedetail.name[0] : filedetail.name}`)
      formData.append("template_id", template_id)
      filedetail.aspect_data.forEach(element => {
          formData.append("aspect_data", JSON.stringify(element))
        });
      const CancelToken = this.axios.CancelToken;
      this.source = CancelToken.source();
      this.temparraydataupload[i].canceltoken = this.source;
      let auth = await gbfGenerate.generateToken();
      try {
        let response = await this.axios({
          method: "POST",
          url:
            process.env.VUE_APP_SERVICE_UPLOAD_API + 
            "/api/smart_box/v1/check_duplicate_data_smartbox",
          cancelToken: this.temparraydataupload[i].canceltoken.token,
          data: formData,
          headers: { Authorization: auth.code },
        });
        if (response.data.status === 'OK') {
          if(response.data.message === 'duplicate filename') {
            console.log("temparray ", this.temparraydataupload[i])
            return {status: "fail", msg: "duplicate"}
            // this.temparraydataupload[i].msg = "เอกสารชื่อซ้ำต้องการอัปโหลดแบบ Major หรือ Minor"
            // this.temparraydataupload[i].status = 'duplicate'
          }
        }
        return response
      } catch (err) {
        return {status: "fail_checked", msg: "duplicate"}
      }
      }
    },
    cleardata() {
      this.clickFetchDB = false
      this.alertSomeFolder = false
      this.statusuploading = false;
      this.createprogress = false;
      this.selectingimportFiles = false;
      this.fileImport = null;
      this.percentfileuploading = 0;
      this.arraydataupload = [];
      this.countupload = 0;
      this.checkstatusduplicate = false;
      this.totalstackfile = 0;
      this.temparraydataupload = [];
      this.stackfileloading = false;
      this.userdata = {};
      this.uniqueidfile = 0;
      this.checkdetailmobile = false;
      this.checktemplatefolder = false;
      this.datafoldertemplate = {};
      this.listaspectsymbol = [];
      this.reloadId = ""
      this.isloadingChecking = false
      // this.manageAI = false
      this.disableManageAI = false
      this.selectAll_reupload = false
      this.selected_reupload = []
      this.selectedItem = null
      this.$v.detailstemplate.$reset()
      this.$v.selectedItem.$reset()
      try {
        // if (
        //   this.listbizsymbolsmartupload.includes(
        //     this.dataAccountActive.business_info.taxid
        //   )
        // ) {
        // } else {
        // if (this.detailstemplate.aspect_data && this.selectedItem === null) {
        //   for (let i = 0; i < this.detailstemplate.aspect_data.length; i++) {
        //     if (
        //       this.detailstemplate.aspect_data[i]
        //       .aspect_fix_value.length > 0
        //       // .aspect_fix_value !== "{}"
        //     ) {
        //       if (this.detailstemplate.aspect_data[i].aspect_null !== "Y") {
        //         this.detailstemplate.aspect_data[i].aspect_fix_value.push(
        //           "notselecttemplate"
        //         );
        //         this.detailstemplate.aspect_data[
        //           i
        //         ].value = this.detailstemplate.aspect_data[i].aspect_fix_value[
        //           this.detailstemplate.aspect_data[i].aspect_fix_value.length -
        //             1
        //         ];
        //         this.detailstemplate.aspect_data[i].fixvalue = "notuse";
        //       } else {
        //         this.detailstemplate.aspect_data[
        //           i
        //         ].value = this.detailstemplate.aspect_data[
        //           i
        //         ].aspect_fix_value[0];
        //         this.detailstemplate.aspect_data[i].fixvalue = "notuse";
        //       }
        //     } else {
        //       if (this.detailstemplate.aspect_data[i].aspect_null === "Y") {
        //         this.detailstemplate.aspect_data[i].fixvalue = "";
        //       } else {
        //         this.detailstemplate.aspect_data[i].value = "";
        //         // this.detailstemplate.aspect_data[i].fixvalue = "";
        //         // this.detailstemplate.aspect_data[i].showdate = ""
        //       }
        //     }
        //   }
        // }
        this.$v.$reset();
        setTimeout(() => {
          //this.loadingdatatemplate = true;
          // หน่วงเวลาตอนปิด dialog
        }, 200);
        // }
      } catch (err) {
        console.log("SomeError But It's fine");
      }
    },
    cleardataNoclose() {
      this.statusuploading = false;
      this.createprogress = false;
      this.selectingimportFiles = false;
      this.fileImport = null;
      this.percentfileuploading = 0;
      this.arraydataupload = [];
      this.countupload = 0;
      this.checkstatusduplicate = false;
      this.totalstackfile = 0;
      this.temparraydataupload = [];
      this.stackfileloading = false;
      this.userdata = {};
      this.uniqueidfile = 0;
      this.checkdetailmobile = false;
      this.reloadId = ""
      this.isloadingChecking = false
      this.selectAll_reupload = false
      this.selected_reupload = []
      this.selectedItem = null
      this.$v.selectedItem.$reset()
    },
    closeClearData() {
      setTimeout(() => {
        this.cleardata();
      }, 1000);
    },
  },
  mounted() {
    this.createprogress = false;
  },
  beforeDestroy() {
    this.removeEventUploadfiles();
    this.cleardata();
    this.createprogress = false;
  },
};
</script>
<style scoped>
.v-list-item:hover {
  background-color: transparent !important;
}
.no-hover:hover {
  background-color: transparent !important;
}
.selected-item {
  background-color: #E0F7FA !important; /* สีฟ้าอ่อน */
  border-radius: 8px;
}
#linear-ai {
  background: rgb(23,73,102);
  background: linear-gradient(90deg, rgba(23,73,102,1) 12%, rgba(23,73,102,1) 23%, rgba(125,185,217,1) 95%);
}
.v-input.textFieldClass input {
  font-size: 14px;
  max-height: 90px;
  padding-bottom: 11px;
  padding-top: 11px;
}
.v-text-field.textFieldClass .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}
.checkboxStyle .v-label {
  font-size: 14px;
  color: black;
}
.textFieldClass .v-label {
  font-size: 14px;
  display: flex !important;
}
#titleTextUploadtitle {
  color: black;
  font-size: 18px;
  line-height: 24px;
}
#titleTextUploadsubtitle {
  color: red;
  font-size: 16px;
  line-height: 24px;
}
#inputuploadfiles {
  border-radius: 23px;
  cursor: pointer;
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 0;
}
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
</style>
